var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import o, { useRef, useDebugValue, createElement, useContext, PureComponent } from "react";
import require$$2$2 from "react-dom";
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f2 = n.default;
  if (typeof f2 == "function") {
    var a = function a2() {
      if (this instanceof a2) {
        return Reflect.construct(f2, arguments, this.constructor);
      }
      return f2.apply(this, arguments);
    };
    a.prototype = f2.prototype;
  } else a = {};
  Object.defineProperty(a, "__esModule", { value: true });
  Object.keys(n).forEach(function(k2) {
    var d = Object.getOwnPropertyDescriptor(n, k2);
    Object.defineProperty(a, k2, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k2];
      }
    });
  });
  return a;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production;
function requireReactJsxRuntime_production() {
  if (hasRequiredReactJsxRuntime_production) return reactJsxRuntime_production;
  hasRequiredReactJsxRuntime_production = 1;
  var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
  function jsxProd(type2, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
      maybeKey = {};
      for (var propName in config)
        "key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type: type2,
      key,
      ref: void 0 !== config ? config : null,
      props: maybeKey
    };
  }
  reactJsxRuntime_production.Fragment = REACT_FRAGMENT_TYPE;
  reactJsxRuntime_production.jsx = jsxProd;
  reactJsxRuntime_production.jsxs = jsxProd;
  return reactJsxRuntime_production;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  "production" !== process.env.NODE_ENV && function() {
    function getComponentNameFromType(type2) {
      if (null == type2) return null;
      if ("function" === typeof type2)
        return type2.$$typeof === REACT_CLIENT_REFERENCE ? null : type2.displayName || type2.name || null;
      if ("string" === typeof type2) return type2;
      switch (type2) {
        case REACT_FRAGMENT_TYPE:
          return "Fragment";
        case REACT_PROFILER_TYPE:
          return "Profiler";
        case REACT_STRICT_MODE_TYPE:
          return "StrictMode";
        case REACT_SUSPENSE_TYPE:
          return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
          return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
          return "Activity";
      }
      if ("object" === typeof type2)
        switch ("number" === typeof type2.tag && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), type2.$$typeof) {
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_CONTEXT_TYPE:
            return type2.displayName || "Context";
          case REACT_CONSUMER_TYPE:
            return (type2._context.displayName || "Context") + ".Consumer";
          case REACT_FORWARD_REF_TYPE:
            var innerType = type2.render;
            type2 = type2.displayName;
            type2 || (type2 = innerType.displayName || innerType.name || "", type2 = "" !== type2 ? "ForwardRef(" + type2 + ")" : "ForwardRef");
            return type2;
          case REACT_MEMO_TYPE:
            return innerType = type2.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type2.type) || "Memo";
          case REACT_LAZY_TYPE:
            innerType = type2._payload;
            type2 = type2._init;
            try {
              return getComponentNameFromType(type2(innerType));
            } catch (x2) {
            }
        }
      return null;
    }
    function testStringCoercion(value) {
      return "" + value;
    }
    function checkKeyStringCoercion(value) {
      try {
        testStringCoercion(value);
        var JSCompiler_inline_result = false;
      } catch (e2) {
        JSCompiler_inline_result = true;
      }
      if (JSCompiler_inline_result) {
        JSCompiler_inline_result = console;
        var JSCompiler_temp_const = JSCompiler_inline_result.error;
        var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        JSCompiler_temp_const.call(
          JSCompiler_inline_result,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          JSCompiler_inline_result$jscomp$0
        );
        return testStringCoercion(value);
      }
    }
    function getTaskName(type2) {
      if (type2 === REACT_FRAGMENT_TYPE) return "<>";
      if ("object" === typeof type2 && null !== type2 && type2.$$typeof === REACT_LAZY_TYPE)
        return "<...>";
      try {
        var name = getComponentNameFromType(type2);
        return name ? "<" + name + ">" : "<...>";
      } catch (x2) {
        return "<...>";
      }
    }
    function getOwner() {
      var dispatcher = ReactSharedInternals.A;
      return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
      return Error("react-stack-top-frame");
    }
    function hasValidKey(config) {
      if (hasOwnProperty2.call(config, "key")) {
        var getter = Object.getOwnPropertyDescriptor(config, "key").get;
        if (getter && getter.isReactWarning) return false;
      }
      return void 0 !== config.key;
    }
    function defineKeyPropWarningGetter(props, displayName) {
      function warnAboutAccessingKey() {
        specialPropKeyWarningShown || (specialPropKeyWarningShown = true, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          displayName
        ));
      }
      warnAboutAccessingKey.isReactWarning = true;
      Object.defineProperty(props, "key", {
        get: warnAboutAccessingKey,
        configurable: true
      });
    }
    function elementRefGetterWithDeprecationWarning() {
      var componentName = getComponentNameFromType(this.type);
      didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = true, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      ));
      componentName = this.props.ref;
      return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type2, key, props, owner, debugStack, debugTask) {
      var refProp = props.ref;
      type2 = {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type2,
        key,
        props,
        _owner: owner
      };
      null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type2, "ref", {
        enumerable: false,
        get: elementRefGetterWithDeprecationWarning
      }) : Object.defineProperty(type2, "ref", { enumerable: false, value: null });
      type2._store = {};
      Object.defineProperty(type2._store, "validated", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: 0
      });
      Object.defineProperty(type2, "_debugInfo", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: null
      });
      Object.defineProperty(type2, "_debugStack", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugStack
      });
      Object.defineProperty(type2, "_debugTask", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugTask
      });
      Object.freeze && (Object.freeze(type2.props), Object.freeze(type2));
      return type2;
    }
    function jsxDEVImpl(type2, config, maybeKey, isStaticChildren, debugStack, debugTask) {
      var children = config.children;
      if (void 0 !== children)
        if (isStaticChildren)
          if (isArrayImpl(children)) {
            for (isStaticChildren = 0; isStaticChildren < children.length; isStaticChildren++)
              validateChildKeys(children[isStaticChildren]);
            Object.freeze && Object.freeze(children);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else validateChildKeys(children);
      if (hasOwnProperty2.call(config, "key")) {
        children = getComponentNameFromType(type2);
        var keys = Object.keys(config).filter(function(k2) {
          return "key" !== k2;
        });
        isStaticChildren = 0 < keys.length ? "{key: someKey, " + keys.join(": ..., ") + ": ...}" : "{key: someKey}";
        didWarnAboutKeySpread[children + isStaticChildren] || (keys = 0 < keys.length ? "{" + keys.join(": ..., ") + ": ...}" : "{}", console.error(
          'A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />',
          isStaticChildren,
          children,
          keys,
          children
        ), didWarnAboutKeySpread[children + isStaticChildren] = true);
      }
      children = null;
      void 0 !== maybeKey && (checkKeyStringCoercion(maybeKey), children = "" + maybeKey);
      hasValidKey(config) && (checkKeyStringCoercion(config.key), children = "" + config.key);
      if ("key" in config) {
        maybeKey = {};
        for (var propName in config)
          "key" !== propName && (maybeKey[propName] = config[propName]);
      } else maybeKey = config;
      children && defineKeyPropWarningGetter(
        maybeKey,
        "function" === typeof type2 ? type2.displayName || type2.name || "Unknown" : type2
      );
      return ReactElement(
        type2,
        children,
        maybeKey,
        getOwner(),
        debugStack,
        debugTask
      );
    }
    function validateChildKeys(node2) {
      isValidElement(node2) ? node2._store && (node2._store.validated = 1) : "object" === typeof node2 && null !== node2 && node2.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node2._payload.status ? isValidElement(node2._payload.value) && node2._payload.value._store && (node2._payload.value._store.validated = 1) : node2._store && (node2._store.validated = 1));
    }
    function isValidElement(object) {
      return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var React2 = o, REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, hasOwnProperty2 = Object.prototype.hasOwnProperty, isArrayImpl = Array.isArray, createTask = console.createTask ? console.createTask : function() {
      return null;
    };
    React2 = {
      react_stack_bottom_frame: function(callStackForError) {
        return callStackForError();
      }
    };
    var specialPropKeyWarningShown;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = React2.react_stack_bottom_frame.bind(
      React2,
      UnknownOwner
    )();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutKeySpread = {};
    reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
    reactJsxRuntime_development.jsx = function(type2, config, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      return jsxDEVImpl(
        type2,
        config,
        maybeKey,
        false,
        trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack,
        trackActualOwner ? createTask(getTaskName(type2)) : unknownOwnerDebugTask
      );
    };
    reactJsxRuntime_development.jsxs = function(type2, config, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      return jsxDEVImpl(
        type2,
        config,
        maybeKey,
        true,
        trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack,
        trackActualOwner ? createTask(getTaskName(type2)) : unknownOwnerDebugTask
      );
    };
  }();
  return reactJsxRuntime_development;
}
if (process.env.NODE_ENV === "production") {
  jsxRuntime.exports = requireReactJsxRuntime_production();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}
var jsxRuntimeExports = jsxRuntime.exports;
var __assign = function() {
  __assign = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __spreadArray(to, from2, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from2.length, ar; i < l; i++) {
    if (ar || !(i in from2)) {
      if (!ar) ar = Array.prototype.slice.call(from2, 0, i);
      ar[i] = from2[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from2));
}
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
  var e2 = new Error(message);
  return e2.name = "SuppressedError", e2.error = error, e2.suppressed = suppressed, e2;
};
function memoize(fn) {
  var cache = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache[arg] === void 0) cache[arg] = fn(arg);
    return cache[arg];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var isPropValid = /* @__PURE__ */ memoize(
  function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var LAYER = "@layer";
var abs = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash(value, length2) {
  return charat(value, 0) ^ 45 ? (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}
function trim(value) {
  return value.trim();
}
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search, position2) {
  return value.indexOf(search, position2);
}
function charat(value, index2) {
  return value.charCodeAt(index2) | 0;
}
function substr(value, begin, end) {
  return value.slice(begin, end);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append(value, array) {
  return array.push(value), value;
}
function combine(array, callback) {
  return array.map(callback).join("");
}
function filter(array, pattern) {
  return array.filter(function(value) {
    return !match(value, pattern);
  });
}
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value, root, parent, type2, props, children, length2, siblings) {
  return { value, root, parent, type: type2, props, children, line, column, length: length2, return: "", siblings };
}
function copy(root, props) {
  return assign(node("", null, null, "", null, null, 0, root.siblings), root, { length: -root.length }, props);
}
function lift(root) {
  while (root.root)
    root = copy(root.root, { children: [root] });
  append(root, root.siblings);
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(begin, end) {
  return substr(characters, begin, end);
}
function token(type2) {
  switch (type2) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type2) {
  return trim(slice(position - 1, delimiter(type2 === 91 ? type2 + 2 : type2 === 40 ? type2 + 1 : type2)));
}
function whitespace(type2) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type2) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index2, count) {
  while (--count && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index2, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type2) {
  while (next())
    switch (character) {
      case type2:
        return position;
      case 34:
      case 39:
        if (type2 !== 34 && type2 !== 39)
          delimiter(character);
        break;
      case 40:
        if (type2 === 41)
          delimiter(type2);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(type2, index2) {
  while (next())
    if (type2 + character === 47 + 10)
      break;
    else if (type2 + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index2, position - 1) + "*" + from(type2 === 47 ? type2 : next());
}
function identifier(index2) {
  while (!token(peek()))
    next();
  return slice(index2, position);
}
function compile(value) {
  return dealloc(parse("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index2 = 0;
  var offset = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type2 = "";
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters2 = type2;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      case 40:
        if (previous != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f", abs(index2 ? points[index2 - 1] : 0)) != -1)
            ampersand = -1;
          break;
        }
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root, parent, declarations), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      case 123 * variable:
        points[index2++] = strlen(characters2) * ampersand;
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          case 0:
          case 125:
            scanning = 0;
          case 59 + offset:
            if (ampersand == -1) characters2 = replace(characters2, /\f/g, "");
            if (property > 0 && strlen(characters2) - length2)
              append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1, declarations) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2, declarations), declarations);
            break;
          case 59:
            characters2 += ";";
          default:
            append(reference = ruleset(characters2, root, parent, index2, offset, rules, points, type2, props = [], children = [], length2, rulesets), rulesets);
            if (character2 === 123)
              if (offset === 0)
                parse(characters2, root, reference, reference, props, rulesets, length2, points, children);
              else
                switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type2, rules, props = [], length2, children), children), rules, children, length2, points, rule ? props : children);
                    break;
                  default:
                    parse(characters2, reference, reference, reference, [""], children, 0, points, children);
                }
        }
        index2 = offset = property = 0, variable = ampersand = 1, type2 = characters2 = "", length2 = pseudo;
        break;
      case 58:
        length2 = 1 + strlen(characters2), property = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          case 38:
            ampersand = offset > 0 ? 1 : (characters2 += "\f", -1);
            break;
          case 44:
            points[index2++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset = length2 = strlen(type2 = characters2 += identifier(caret())), character2++;
            break;
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root, parent, index2, offset, rules, points, type2, props, children, length2, siblings) {
  var post = offset - 1;
  var rule = offset === 0 ? rules : [""];
  var size = sizeof(rule);
  for (var i = 0, j2 = 0, k2 = 0; i < index2; ++i)
    for (var x2 = 0, y2 = substr(value, post + 1, post = abs(j2 = points[i])), z2 = value; x2 < size; ++x2)
      if (z2 = trim(j2 > 0 ? rule[x2] + " " + y2 : replace(y2, /&\f/g, rule[x2])))
        props[k2++] = z2;
  return node(value, root, parent, offset === 0 ? RULESET : type2, props, children, length2, siblings);
}
function comment(value, root, parent, siblings) {
  return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0, siblings);
}
function declaration(value, root, parent, length2, siblings) {
  return node(value, root, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2, siblings);
}
function prefix(value, length2, children) {
  switch (hash(value, length2)) {
    case 5103:
      return WEBKIT + "print-" + value + value;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    case 4789:
      return MOZ + value + value;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    case 5936:
      switch (charat(value, length2 + 11)) {
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
    case 6828:
    case 4268:
    case 2903:
      return WEBKIT + value + MS + value + value;
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/g, "") + (!match(value, /flex-|baseline/) ? MS + "grid-row-" + replace(value, /flex-|-self/g, "") : "") + value;
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/g, "") + value;
    case 5548:
      return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;
    case 5292:
      return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;
    case 6060:
      return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;
    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    case 4200:
      if (!match(value, /flex-|baseline/)) return MS + "grid-column-align" + substr(value, length2) + value;
      break;
    case 2592:
    case 3360:
      return MS + replace(value, "template-", "") + value;
    case 4384:
    case 3616:
      if (children && children.some(function(element, index2) {
        return length2 = index2, match(element.props, /grid-\w+-end/);
      })) {
        return ~indexof(value + (children = children[length2].value), "span", 0) ? value : MS + replace(value, "-start", "") + value + MS + "grid-row-span:" + (~indexof(children, "span", 0) ? match(children, /\d+/) : +match(children, /\d+/) - +match(value, /\d+/)) + ";";
      }
      return MS + replace(value, "-start", "") + value;
    case 4896:
    case 4128:
      return children && children.some(function(element) {
        return match(element.props, /grid-\w+-start/);
      }) ? value : MS + replace(replace(value, "-end", "-span"), "span ", "") + value;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6)
        switch (charat(value, length2 + 1)) {
          case 109:
            if (charat(value, length2 + 4) !== 45)
              break;
          case 102:
            return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
          case 115:
            return ~indexof(value, "stretch", 0) ? prefix(replace(value, "stretch", "fill-available"), length2, children) + value : value;
        }
      break;
    case 5152:
    case 5920:
      return replace(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_2, a, b, c, d, e2, f2) {
        return MS + a + ":" + b + f2 + (c ? MS + a + "-span:" + (d ? e2 : +e2 - +b) + f2 : "") + value;
      });
    case 4949:
      if (charat(value, length2 + 6) === 121)
        return replace(value, ":", ":" + WEBKIT) + value;
      break;
    case 6444:
      switch (charat(value, charat(value, 14) === 45 ? 18 : 11)) {
        case 120:
          return replace(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
        case 100:
          return replace(value, ":", ":" + MS) + value;
      }
      break;
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return replace(value, "scroll-", "scroll-snap-") + value;
  }
  return value;
}
function serialize(children, callback) {
  var output = "";
  for (var i = 0; i < children.length; i++)
    output += callback(children[i], i, children, callback) || "";
  return output;
}
function stringify(element, index2, children, callback) {
  switch (element.type) {
    case LAYER:
      if (element.children.length) break;
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";
    case RULESET:
      if (!strlen(element.value = element.props.join(","))) return "";
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element, index2, children, callback) {
    var output = "";
    for (var i = 0; i < length2; i++)
      output += collection[i](element, index2, children, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function(element) {
    if (!element.root) {
      if (element = element.return)
        callback(element);
    }
  };
}
function prefixer(element, index2, children, callback) {
  if (element.length > -1) {
    if (!element.return)
      switch (element.type) {
        case DECLARATION:
          element.return = prefix(element.value, element.length, children);
          return;
        case KEYFRAMES:
          return serialize([copy(element, { value: replace(element.value, "@", "@" + WEBKIT) })], callback);
        case RULESET:
          if (element.length)
            return combine(children = element.props, function(value) {
              switch (match(value, callback = /(::plac\w+|:read-\w+)/)) {
                case ":read-only":
                case ":read-write":
                  lift(copy(element, { props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")] }));
                  lift(copy(element, { props: [value] }));
                  assign(element, { props: filter(children, callback) });
                  break;
                case "::placeholder":
                  lift(copy(element, { props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")] }));
                  lift(copy(element, { props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")] }));
                  lift(copy(element, { props: [replace(value, /:(plac\w+)/, MS + "input-$1")] }));
                  lift(copy(element, { props: [value] }));
                  assign(element, { props: filter(children, callback) });
                  break;
              }
              return "";
            });
      }
  }
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var f = "undefined" != typeof process && void 0 !== process.env && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", m = "active", y = "data-styled-version", v = "6.1.12", g = "/*!sc*/\n", S = "undefined" != typeof window && "HTMLElement" in window, w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env && void 0 !== process.env.REACT_APP_SC_DISABLE_SPEEDY && "" !== process.env.REACT_APP_SC_DISABLE_SPEEDY ? "false" !== process.env.REACT_APP_SC_DISABLE_SPEEDY && process.env.REACT_APP_SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env && void 0 !== process.env.SC_DISABLE_SPEEDY && "" !== process.env.SC_DISABLE_SPEEDY ? "false" !== process.env.SC_DISABLE_SPEEDY && process.env.SC_DISABLE_SPEEDY : "production" !== process.env.NODE_ENV), E = /invalid hook call/i, N = /* @__PURE__ */ new Set(), P = function(t, n) {
  if ("production" !== process.env.NODE_ENV) {
    var o2 = n ? ' with the id of "'.concat(n, '"') : "", s = "The component ".concat(t).concat(o2, " has been created dynamically.\n") + "You may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.", i = console.error;
    try {
      var a = true;
      console.error = function(t2) {
        for (var n2 = [], o3 = 1; o3 < arguments.length; o3++) n2[o3 - 1] = arguments[o3];
        E.test(t2) ? (a = false, N.delete(s)) : i.apply(void 0, __spreadArray([t2], n2, false));
      }, useRef(), a && !N.has(s) && (console.warn(s), N.add(s));
    } catch (e2) {
      E.test(e2.message) && N.delete(s);
    } finally {
      console.error = i;
    }
  }
}, _ = Object.freeze([]), C = Object.freeze({});
function I(e2, t, n) {
  return void 0 === n && (n = C), e2.theme !== n.theme && e2.theme || t || n.theme;
}
var A = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]), O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, D = /(^-|-$)/g;
function R(e2) {
  return e2.replace(O, "-").replace(D, "");
}
var T = /(a)(d)/gi, k = 52, j = function(e2) {
  return String.fromCharCode(e2 + (e2 > 25 ? 39 : 97));
};
function x(e2) {
  var t, n = "";
  for (t = Math.abs(e2); t > k; t = t / k | 0) n = j(t % k) + n;
  return (j(t % k) + n).replace(T, "$1-$2");
}
var V, F = 5381, M = function(e2, t) {
  for (var n = t.length; n; ) e2 = 33 * e2 ^ t.charCodeAt(--n);
  return e2;
}, z = function(e2) {
  return M(F, e2);
};
function $(e2) {
  return x(z(e2) >>> 0);
}
function B(e2) {
  return "production" !== process.env.NODE_ENV && "string" == typeof e2 && e2 || e2.displayName || e2.name || "Component";
}
function L(e2) {
  return "string" == typeof e2 && ("production" === process.env.NODE_ENV || e2.charAt(0) === e2.charAt(0).toLowerCase());
}
var G = "function" == typeof Symbol && Symbol.for, Y = G ? Symbol.for("react.memo") : 60115, W = G ? Symbol.for("react.forward_ref") : 60112, q = { childContextTypes: true, contextType: true, contextTypes: true, defaultProps: true, displayName: true, getDefaultProps: true, getDerivedStateFromError: true, getDerivedStateFromProps: true, mixins: true, propTypes: true, type: true }, H = { name: true, length: true, prototype: true, caller: true, callee: true, arguments: true, arity: true }, U = { $$typeof: true, compare: true, defaultProps: true, displayName: true, propTypes: true, type: true }, J = ((V = {})[W] = { $$typeof: true, render: true, defaultProps: true, displayName: true, propTypes: true }, V[Y] = U, V);
function X(e2) {
  return ("type" in (t = e2) && t.type.$$typeof) === Y ? U : "$$typeof" in e2 ? J[e2.$$typeof] : q;
  var t;
}
var Z = Object.defineProperty, K = Object.getOwnPropertyNames, Q = Object.getOwnPropertySymbols, ee = Object.getOwnPropertyDescriptor, te = Object.getPrototypeOf, ne = Object.prototype;
function oe(e2, t, n) {
  if ("string" != typeof t) {
    if (ne) {
      var o2 = te(t);
      o2 && o2 !== ne && oe(e2, o2, n);
    }
    var r2 = K(t);
    Q && (r2 = r2.concat(Q(t)));
    for (var s = X(e2), i = X(t), a = 0; a < r2.length; ++a) {
      var c = r2[a];
      if (!(c in H || n && n[c] || i && c in i || s && c in s)) {
        var l = ee(t, c);
        try {
          Z(e2, c, l);
        } catch (e3) {
        }
      }
    }
  }
  return e2;
}
function re(e2) {
  return "function" == typeof e2;
}
function se(e2) {
  return "object" == typeof e2 && "styledComponentId" in e2;
}
function ie(e2, t) {
  return e2 && t ? "".concat(e2, " ").concat(t) : e2 || t || "";
}
function ae(e2, t) {
  if (0 === e2.length) return "";
  for (var n = e2[0], o2 = 1; o2 < e2.length; o2++) n += e2[o2];
  return n;
}
function ce(e2) {
  return null !== e2 && "object" == typeof e2 && e2.constructor.name === Object.name && !("props" in e2 && e2.$$typeof);
}
function le(e2, t, n) {
  if (void 0 === n && (n = false), !n && !ce(e2) && !Array.isArray(e2)) return t;
  if (Array.isArray(t)) for (var o2 = 0; o2 < t.length; o2++) e2[o2] = le(e2[o2], t[o2]);
  else if (ce(t)) for (var o2 in t) e2[o2] = le(e2[o2], t[o2]);
  return e2;
}
function ue(e2, t) {
  Object.defineProperty(e2, "toString", { value: t });
}
var pe = "production" !== process.env.NODE_ENV ? { 1: "Cannot create styled-component for component: %s.\n\n", 2: "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n", 3: "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n", 4: "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n", 5: "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n", 6: "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n", 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: 'ThemeProvider: Please make your "theme" prop an object.\n\n', 9: "Missing document `<head>`\n\n", 10: "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n", 11: "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n", 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n", 14: 'ThemeProvider: "theme" prop is required.\n\n', 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n", 17: "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n", 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function de() {
  for (var e2 = [], t = 0; t < arguments.length; t++) e2[t] = arguments[t];
  for (var n = e2[0], o2 = [], r2 = 1, s = e2.length; r2 < s; r2 += 1) o2.push(e2[r2]);
  return o2.forEach(function(e3) {
    n = n.replace(/%[a-z]/, e3);
  }), n;
}
function he(t) {
  for (var n = [], o2 = 1; o2 < arguments.length; o2++) n[o2 - 1] = arguments[o2];
  return "production" === process.env.NODE_ENV ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : "")) : new Error(de.apply(void 0, __spreadArray([pe[t]], n, false)).trim());
}
var fe = function() {
  function e2(e3) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e3;
  }
  return e2.prototype.indexOfGroup = function(e3) {
    for (var t = 0, n = 0; n < e3; n++) t += this.groupSizes[n];
    return t;
  }, e2.prototype.insertRules = function(e3, t) {
    if (e3 >= this.groupSizes.length) {
      for (var n = this.groupSizes, o2 = n.length, r2 = o2; e3 >= r2; ) if ((r2 <<= 1) < 0) throw he(16, "".concat(e3));
      this.groupSizes = new Uint32Array(r2), this.groupSizes.set(n), this.length = r2;
      for (var s = o2; s < r2; s++) this.groupSizes[s] = 0;
    }
    for (var i = this.indexOfGroup(e3 + 1), a = (s = 0, t.length); s < a; s++) this.tag.insertRule(i, t[s]) && (this.groupSizes[e3]++, i++);
  }, e2.prototype.clearGroup = function(e3) {
    if (e3 < this.length) {
      var t = this.groupSizes[e3], n = this.indexOfGroup(e3), o2 = n + t;
      this.groupSizes[e3] = 0;
      for (var r2 = n; r2 < o2; r2++) this.tag.deleteRule(n);
    }
  }, e2.prototype.getGroup = function(e3) {
    var t = "";
    if (e3 >= this.length || 0 === this.groupSizes[e3]) return t;
    for (var n = this.groupSizes[e3], o2 = this.indexOfGroup(e3), r2 = o2 + n, s = o2; s < r2; s++) t += "".concat(this.tag.getRule(s)).concat(g);
    return t;
  }, e2;
}(), me = 1 << 30, ye = /* @__PURE__ */ new Map(), ve = /* @__PURE__ */ new Map(), ge = 1, Se = function(e2) {
  if (ye.has(e2)) return ye.get(e2);
  for (; ve.has(ge); ) ge++;
  var t = ge++;
  if ("production" !== process.env.NODE_ENV && ((0 | t) < 0 || t > me)) throw he(16, "".concat(t));
  return ye.set(e2, t), ve.set(t, e2), t;
}, we = function(e2, t) {
  ge = t + 1, ye.set(e2, t), ve.set(t, e2);
}, be = "style[".concat(f, "][").concat(y, '="').concat(v, '"]'), Ee = new RegExp("^".concat(f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), Ne = function(e2, t, n) {
  for (var o2, r2 = n.split(","), s = 0, i = r2.length; s < i; s++) (o2 = r2[s]) && e2.registerName(t, o2);
}, Pe = function(e2, t) {
  for (var n, o2 = (null !== (n = t.textContent) && void 0 !== n ? n : "").split(g), r2 = [], s = 0, i = o2.length; s < i; s++) {
    var a = o2[s].trim();
    if (a) {
      var c = a.match(Ee);
      if (c) {
        var l = 0 | parseInt(c[1], 10), u = c[2];
        0 !== l && (we(u, l), Ne(e2, u, c[3]), e2.getTag().insertRules(l, r2)), r2.length = 0;
      } else r2.push(a);
    }
  }
}, _e = function(e2) {
  for (var t = document.querySelectorAll(be), n = 0, o2 = t.length; n < o2; n++) {
    var r2 = t[n];
    r2 && r2.getAttribute(f) !== m && (Pe(e2, r2), r2.parentNode && r2.parentNode.removeChild(r2));
  }
};
function Ce() {
  return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var Ie = function(e2) {
  var t = document.head, n = e2 || t, o2 = document.createElement("style"), r2 = function(e3) {
    var t2 = Array.from(e3.querySelectorAll("style[".concat(f, "]")));
    return t2[t2.length - 1];
  }(n), s = void 0 !== r2 ? r2.nextSibling : null;
  o2.setAttribute(f, m), o2.setAttribute(y, v);
  var i = Ce();
  return i && o2.setAttribute("nonce", i), n.insertBefore(o2, s), o2;
}, Ae = function() {
  function e2(e3) {
    this.element = Ie(e3), this.element.appendChild(document.createTextNode("")), this.sheet = function(e4) {
      if (e4.sheet) return e4.sheet;
      for (var t = document.styleSheets, n = 0, o2 = t.length; n < o2; n++) {
        var r2 = t[n];
        if (r2.ownerNode === e4) return r2;
      }
      throw he(17);
    }(this.element), this.length = 0;
  }
  return e2.prototype.insertRule = function(e3, t) {
    try {
      return this.sheet.insertRule(t, e3), this.length++, true;
    } catch (e4) {
      return false;
    }
  }, e2.prototype.deleteRule = function(e3) {
    this.sheet.deleteRule(e3), this.length--;
  }, e2.prototype.getRule = function(e3) {
    var t = this.sheet.cssRules[e3];
    return t && t.cssText ? t.cssText : "";
  }, e2;
}(), Oe = function() {
  function e2(e3) {
    this.element = Ie(e3), this.nodes = this.element.childNodes, this.length = 0;
  }
  return e2.prototype.insertRule = function(e3, t) {
    if (e3 <= this.length && e3 >= 0) {
      var n = document.createTextNode(t);
      return this.element.insertBefore(n, this.nodes[e3] || null), this.length++, true;
    }
    return false;
  }, e2.prototype.deleteRule = function(e3) {
    this.element.removeChild(this.nodes[e3]), this.length--;
  }, e2.prototype.getRule = function(e3) {
    return e3 < this.length ? this.nodes[e3].textContent : "";
  }, e2;
}(), De = function() {
  function e2(e3) {
    this.rules = [], this.length = 0;
  }
  return e2.prototype.insertRule = function(e3, t) {
    return e3 <= this.length && (this.rules.splice(e3, 0, t), this.length++, true);
  }, e2.prototype.deleteRule = function(e3) {
    this.rules.splice(e3, 1), this.length--;
  }, e2.prototype.getRule = function(e3) {
    return e3 < this.length ? this.rules[e3] : "";
  }, e2;
}(), Re = S, Te = { isServer: !S, useCSSOMInjection: !w }, ke = function() {
  function e2(e3, n, o2) {
    void 0 === e3 && (e3 = C), void 0 === n && (n = {});
    var r2 = this;
    this.options = __assign(__assign({}, Te), e3), this.gs = n, this.names = new Map(o2), this.server = !!e3.isServer, !this.server && S && Re && (Re = false, _e(this)), ue(this, function() {
      return function(e4) {
        for (var t = e4.getTag(), n2 = t.length, o3 = "", r3 = function(n3) {
          var r4 = function(e5) {
            return ve.get(e5);
          }(n3);
          if (void 0 === r4) return "continue";
          var s2 = e4.names.get(r4), i = t.getGroup(n3);
          if (void 0 === s2 || !s2.size || 0 === i.length) return "continue";
          var a = "".concat(f, ".g").concat(n3, '[id="').concat(r4, '"]'), c = "";
          void 0 !== s2 && s2.forEach(function(e5) {
            e5.length > 0 && (c += "".concat(e5, ","));
          }), o3 += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat(g);
        }, s = 0; s < n2; s++) r3(s);
        return o3;
      }(r2);
    });
  }
  return e2.registerId = function(e3) {
    return Se(e3);
  }, e2.prototype.rehydrate = function() {
    !this.server && S && _e(this);
  }, e2.prototype.reconstructWithOptions = function(n, o2) {
    return void 0 === o2 && (o2 = true), new e2(__assign(__assign({}, this.options), n), this.gs, o2 && this.names || void 0);
  }, e2.prototype.allocateGSInstance = function(e3) {
    return this.gs[e3] = (this.gs[e3] || 0) + 1;
  }, e2.prototype.getTag = function() {
    return this.tag || (this.tag = (e3 = function(e4) {
      var t = e4.useCSSOMInjection, n = e4.target;
      return e4.isServer ? new De(n) : t ? new Ae(n) : new Oe(n);
    }(this.options), new fe(e3)));
    var e3;
  }, e2.prototype.hasNameForId = function(e3, t) {
    return this.names.has(e3) && this.names.get(e3).has(t);
  }, e2.prototype.registerName = function(e3, t) {
    if (Se(e3), this.names.has(e3)) this.names.get(e3).add(t);
    else {
      var n = /* @__PURE__ */ new Set();
      n.add(t), this.names.set(e3, n);
    }
  }, e2.prototype.insertRules = function(e3, t, n) {
    this.registerName(e3, t), this.getTag().insertRules(Se(e3), n);
  }, e2.prototype.clearNames = function(e3) {
    this.names.has(e3) && this.names.get(e3).clear();
  }, e2.prototype.clearRules = function(e3) {
    this.getTag().clearGroup(Se(e3)), this.clearNames(e3);
  }, e2.prototype.clearTag = function() {
    this.tag = void 0;
  }, e2;
}(), je = /&/g, xe = /^\s*\/\/.*$/gm;
function Ve(e2, t) {
  return e2.map(function(e3) {
    return "rule" === e3.type && (e3.value = "".concat(t, " ").concat(e3.value), e3.value = e3.value.replaceAll(",", ",".concat(t, " ")), e3.props = e3.props.map(function(e4) {
      return "".concat(t, " ").concat(e4);
    })), Array.isArray(e3.children) && "@keyframes" !== e3.type && (e3.children = Ve(e3.children, t)), e3;
  });
}
function Fe(e2) {
  var t, n, o2, r2 = C, s = r2.options, i = void 0 === s ? C : s, a = r2.plugins, c = void 0 === a ? _ : a, l = function(e3, o3, r3) {
    return r3.startsWith(n) && r3.endsWith(n) && r3.replaceAll(n, "").length > 0 ? ".".concat(t) : e3;
  }, u = c.slice();
  u.push(function(e3) {
    e3.type === RULESET && e3.value.includes("&") && (e3.props[0] = e3.props[0].replace(je, n).replace(o2, l));
  }), i.prefix && u.push(prefixer), u.push(stringify);
  var p = function(e3, r3, s2, a2) {
    void 0 === r3 && (r3 = ""), void 0 === s2 && (s2 = ""), void 0 === a2 && (a2 = "&"), t = a2, n = r3, o2 = new RegExp("\\".concat(n, "\\b"), "g");
    var c2 = e3.replace(xe, ""), l2 = compile(s2 || r3 ? "".concat(s2, " ").concat(r3, " { ").concat(c2, " }") : c2);
    i.namespace && (l2 = Ve(l2, i.namespace));
    var p2 = [];
    return serialize(l2, middleware(u.concat(rulesheet(function(e4) {
      return p2.push(e4);
    })))), p2;
  };
  return p.hash = c.length ? c.reduce(function(e3, t2) {
    return t2.name || he(15), M(e3, t2.name);
  }, F).toString() : "", p;
}
var Me = new ke(), ze = Fe(), $e = o.createContext({ shouldForwardProp: void 0, styleSheet: Me, stylis: ze });
$e.Consumer;
o.createContext(void 0);
function Ge() {
  return useContext($e);
}
var We = function() {
  function e2(e3, t) {
    var n = this;
    this.inject = function(e4, t2) {
      void 0 === t2 && (t2 = ze);
      var o2 = n.name + t2.hash;
      e4.hasNameForId(n.id, o2) || e4.insertRules(n.id, o2, t2(n.rules, o2, "@keyframes"));
    }, this.name = e3, this.id = "sc-keyframes-".concat(e3), this.rules = t, ue(this, function() {
      throw he(12, String(n.name));
    });
  }
  return e2.prototype.getName = function(e3) {
    return void 0 === e3 && (e3 = ze), this.name + e3.hash;
  }, e2;
}(), qe = function(e2) {
  return e2 >= "A" && e2 <= "Z";
};
function He(e2) {
  for (var t = "", n = 0; n < e2.length; n++) {
    var o2 = e2[n];
    if (1 === n && "-" === o2 && "-" === e2[0]) return e2;
    qe(o2) ? t += "-" + o2.toLowerCase() : t += o2;
  }
  return t.startsWith("ms-") ? "-" + t : t;
}
var Ue = function(e2) {
  return null == e2 || false === e2 || "" === e2;
}, Je = function(t) {
  var n, o2, r2 = [];
  for (var s in t) {
    var i = t[s];
    t.hasOwnProperty(s) && !Ue(i) && (Array.isArray(i) && i.isCss || re(i) ? r2.push("".concat(He(s), ":"), i, ";") : ce(i) ? r2.push.apply(r2, __spreadArray(__spreadArray(["".concat(s, " {")], Je(i), false), ["}"], false)) : r2.push("".concat(He(s), ": ").concat((n = s, null == (o2 = i) || "boolean" == typeof o2 || "" === o2 ? "" : "number" != typeof o2 || 0 === o2 || n in unitlessKeys || n.startsWith("--") ? String(o2).trim() : "".concat(o2, "px")), ";")));
  }
  return r2;
};
function Xe(e2, t, n, o2) {
  if (Ue(e2)) return [];
  if (se(e2)) return [".".concat(e2.styledComponentId)];
  if (re(e2)) {
    if (!re(s = e2) || s.prototype && s.prototype.isReactComponent || !t) return [e2];
    var r2 = e2(t);
    return "production" === process.env.NODE_ENV || "object" != typeof r2 || Array.isArray(r2) || r2 instanceof We || ce(r2) || null === r2 || console.error("".concat(B(e2), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), Xe(r2, t, n, o2);
  }
  var s;
  return e2 instanceof We ? n ? (e2.inject(n, o2), [e2.getName(o2)]) : [e2] : ce(e2) ? Je(e2) : Array.isArray(e2) ? Array.prototype.concat.apply(_, e2.map(function(e3) {
    return Xe(e3, t, n, o2);
  })) : [e2.toString()];
}
function Ze(e2) {
  for (var t = 0; t < e2.length; t += 1) {
    var n = e2[t];
    if (re(n) && !se(n)) return false;
  }
  return true;
}
var Ke = z(v), Qe = function() {
  function e2(e3, t, n) {
    this.rules = e3, this.staticRulesId = "", this.isStatic = "production" === process.env.NODE_ENV && (void 0 === n || n.isStatic) && Ze(e3), this.componentId = t, this.baseHash = M(Ke, t), this.baseStyle = n, ke.registerId(t);
  }
  return e2.prototype.generateAndInjectStyles = function(e3, t, n) {
    var o2 = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e3, t, n) : "";
    if (this.isStatic && !n.hash) if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o2 = ie(o2, this.staticRulesId);
    else {
      var r2 = ae(Xe(this.rules, e3, t, n)), s = x(M(this.baseHash, r2) >>> 0);
      if (!t.hasNameForId(this.componentId, s)) {
        var i = n(r2, ".".concat(s), void 0, this.componentId);
        t.insertRules(this.componentId, s, i);
      }
      o2 = ie(o2, s), this.staticRulesId = s;
    }
    else {
      for (var a = M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++) {
        var u = this.rules[l];
        if ("string" == typeof u) c += u, "production" !== process.env.NODE_ENV && (a = M(a, u));
        else if (u) {
          var p = ae(Xe(u, e3, t, n));
          a = M(a, p + l), c += p;
        }
      }
      if (c) {
        var d = x(a >>> 0);
        t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o2 = ie(o2, d);
      }
    }
    return o2;
  }, e2;
}(), et = o.createContext(void 0);
et.Consumer;
var rt = {}, st = /* @__PURE__ */ new Set();
function it(e2, r2, s) {
  var i = se(e2), a = e2, c = !L(e2), p = r2.attrs, d = void 0 === p ? _ : p, h = r2.componentId, f2 = void 0 === h ? function(e3, t) {
    var n = "string" != typeof e3 ? "sc" : R(e3);
    rt[n] = (rt[n] || 0) + 1;
    var o2 = "".concat(n, "-").concat($(v + n + rt[n]));
    return t ? "".concat(t, "-").concat(o2) : o2;
  }(r2.displayName, r2.parentComponentId) : h, m2 = r2.displayName, y2 = void 0 === m2 ? function(e3) {
    return L(e3) ? "styled.".concat(e3) : "Styled(".concat(B(e3), ")");
  }(e2) : m2, g2 = r2.displayName && r2.componentId ? "".concat(R(r2.displayName), "-").concat(r2.componentId) : r2.componentId || f2, S2 = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w2 = r2.shouldForwardProp;
  if (i && a.shouldForwardProp) {
    var b = a.shouldForwardProp;
    if (r2.shouldForwardProp) {
      var E2 = r2.shouldForwardProp;
      w2 = function(e3, t) {
        return b(e3, t) && E2(e3, t);
      };
    } else w2 = b;
  }
  var N2 = new Qe(s, g2, i ? a.componentStyle : void 0);
  function O2(e3, r3) {
    return function(e4, r4, s2) {
      var i2 = e4.attrs, a2 = e4.componentStyle, c2 = e4.defaultProps, p2 = e4.foldedComponentIds, d2 = e4.styledComponentId, h2 = e4.target, f3 = o.useContext(et), m3 = Ge(), y3 = e4.shouldForwardProp || m3.shouldForwardProp;
      "production" !== process.env.NODE_ENV && useDebugValue(d2);
      var v2 = I(r4, f3, c2) || C, g3 = function(e5, n, o2) {
        for (var r5, s3 = __assign(__assign({}, n), { className: void 0, theme: o2 }), i3 = 0; i3 < e5.length; i3 += 1) {
          var a3 = re(r5 = e5[i3]) ? r5(s3) : r5;
          for (var c3 in a3) s3[c3] = "className" === c3 ? ie(s3[c3], a3[c3]) : "style" === c3 ? __assign(__assign({}, s3[c3]), a3[c3]) : a3[c3];
        }
        return n.className && (s3.className = ie(s3.className, n.className)), s3;
      }(i2, r4, v2), S3 = g3.as || h2, w3 = {};
      for (var b2 in g3) void 0 === g3[b2] || "$" === b2[0] || "as" === b2 || "theme" === b2 && g3.theme === v2 || ("forwardedAs" === b2 ? w3.as = g3.forwardedAs : y3 && !y3(b2, S3) || (w3[b2] = g3[b2], y3 || "development" !== process.env.NODE_ENV || isPropValid(b2) || st.has(b2) || !A.has(S3) || (st.add(b2), console.warn('styled-components: it looks like an unknown prop "'.concat(b2, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var E3 = function(e5, t) {
        var n = Ge(), o2 = e5.generateAndInjectStyles(t, n.styleSheet, n.stylis);
        return "production" !== process.env.NODE_ENV && useDebugValue(o2), o2;
      }(a2, g3);
      "production" !== process.env.NODE_ENV && e4.warnTooManyClasses && e4.warnTooManyClasses(E3);
      var N3 = ie(p2, d2);
      return E3 && (N3 += " " + E3), g3.className && (N3 += " " + g3.className), w3[L(S3) && !A.has(S3) ? "class" : "className"] = N3, w3.ref = s2, createElement(S3, w3);
    }(D2, e3, r3);
  }
  O2.displayName = y2;
  var D2 = o.forwardRef(O2);
  return D2.attrs = S2, D2.componentStyle = N2, D2.displayName = y2, D2.shouldForwardProp = w2, D2.foldedComponentIds = i ? ie(a.foldedComponentIds, a.styledComponentId) : "", D2.styledComponentId = g2, D2.target = i ? a.target : e2, Object.defineProperty(D2, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(e3) {
    this._foldedDefaultProps = i ? function(e4) {
      for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
      for (var o2 = 0, r3 = t; o2 < r3.length; o2++) le(e4, r3[o2], true);
      return e4;
    }({}, a.defaultProps, e3) : e3;
  } }), "production" !== process.env.NODE_ENV && (P(y2, g2), D2.warnTooManyClasses = /* @__PURE__ */ function(e3, t) {
    var n = {}, o2 = false;
    return function(r3) {
      if (!o2 && (n[r3] = true, Object.keys(n).length >= 200)) {
        var s2 = t ? ' with the id of "'.concat(t, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(e3).concat(s2, ".\n") + "Consider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"), o2 = true, n = {};
      }
    };
  }(y2, g2)), ue(D2, function() {
    return ".".concat(D2.styledComponentId);
  }), c && oe(D2, e2, { attrs: true, componentStyle: true, displayName: true, foldedComponentIds: true, shouldForwardProp: true, styledComponentId: true, target: true }), D2;
}
function at(e2, t) {
  for (var n = [e2[0]], o2 = 0, r2 = t.length; o2 < r2; o2 += 1) n.push(t[o2], e2[o2 + 1]);
  return n;
}
var ct = function(e2) {
  return Object.assign(e2, { isCss: true });
};
function lt(t) {
  for (var n = [], o2 = 1; o2 < arguments.length; o2++) n[o2 - 1] = arguments[o2];
  if (re(t) || ce(t)) return ct(Xe(at(_, __spreadArray([t], n, true))));
  var r2 = t;
  return 0 === n.length && 1 === r2.length && "string" == typeof r2[0] ? Xe(r2) : ct(Xe(at(r2, n)));
}
function ut(n, o2, r2) {
  if (void 0 === r2 && (r2 = C), !o2) throw he(1, o2);
  var s = function(t) {
    for (var s2 = [], i = 1; i < arguments.length; i++) s2[i - 1] = arguments[i];
    return n(o2, r2, lt.apply(void 0, __spreadArray([t], s2, false)));
  };
  return s.attrs = function(e2) {
    return ut(n, o2, __assign(__assign({}, r2), { attrs: Array.prototype.concat(r2.attrs, e2).filter(Boolean) }));
  }, s.withConfig = function(e2) {
    return ut(n, o2, __assign(__assign({}, r2), e2));
  }, s;
}
var pt = function(e2) {
  return ut(it, e2);
}, dt = pt;
A.forEach(function(e2) {
  dt[e2] = pt(e2);
});
"production" !== process.env.NODE_ENV && "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native");
var St = "__sc-".concat(f, "__");
"production" !== process.env.NODE_ENV && "test" !== process.env.NODE_ENV && "undefined" != typeof window && (window[St] || (window[St] = 0), 1 === window[St] && console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."), window[St] += 1);
const StyledPageImage = dt.img.withConfig({
  shouldForwardProp: (prop) => prop !== "maxWidth" && prop !== "maxHeight" && prop !== "minWidth" && prop !== "minHeight" && prop !== "height" && prop !== "width"
})`
  /*
   * IMPORTANT NOTE: height, min-height, max-height should not be changed without
   * reviewing Page Layout specs to understand the implications of the change.
   */
  width: ${(props) => props.width};
  max-width: ${(props) => props.maxWidth};
  min-width: ${(props) => props.minWidth};
  height: ${(props) => props.height};
  max-height: ${(props) => props.maxHeight};
  min-height: ${(props) => props.minHeight};
  top: auto;
  right: auto;
  left: auto;
  bottom: auto;
  z-index: 1;
  position: absolute;
  box-sizing: border-box;
`;
const PageBackground = ({
  padding,
  backgroundImage,
  backgroundSize
}) => {
  const targetPadding = (padding || 0) * 2;
  const oneHundredPercent = `calc(100% - ${targetPadding}px)`;
  const styles = {
    width: oneHundredPercent,
    maxWidth: oneHundredPercent,
    minWidth: oneHundredPercent
  };
  if (backgroundSize === "100% 100%") {
    styles.height = oneHundredPercent;
    styles.minHeight = oneHundredPercent;
    styles.maxHeight = oneHundredPercent;
  } else {
    styles.height = "auto";
    styles.minHeight = "auto";
    styles.maxHeight = oneHundredPercent;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    StyledPageImage,
    {
      ...styles,
      src: backgroundImage
    }
  );
};
const StyledPage = dt.div.withConfig({
  shouldForwardProp: (prop) => prop !== "maxWidth" && prop !== "maxHeight" && prop !== "minWidth" && prop !== "minHeight" && prop !== "maxWidthType" && prop !== "maxHeightType" && prop !== "minWidthType" && prop !== "minHeightType" && prop !== "padding" && prop !== "backgroundColor" && prop !== "borderColor" && prop !== "borderWidth" && prop !== "borderRadius" && prop !== "boxShadow" && prop !== "fields" && prop !== "layout" && prop !== "rowHeight" && prop !== "cols" && prop !== "overflow"
})`
  display: flex;
  flex-direction: column;
  overflow: ${(props) => props.overflow || "auto"};
  position: relative;
  box-sizing: border-box;
  max-width: ${(props) => props.maxWidth ? `${props.maxWidth}${props.maxWidthType}` : "initial"};
  max-height: ${(props) => props.maxHeight ? `${props.maxHeight}${props.maxHeightType}` : "initial"};
  min-width: ${(props) => props.minWidth ? `${props.minWidth}${props.minWidthType}` : "initial"};
  min-height: ${(props) => props.minHeight ? `${props.minHeight}${props.minHeightType}` : "initial"};
  padding: ${(props) => props.padding}px;
  background-color: ${(props) => props.backgroundColor || "transparent"};
  border: ${(props) => props.borderWidth}px solid ${(props) => props.borderColor};
  border-radius: ${(props) => props.borderRadius}px;
  box-shadow: ${(props) => props.boxShadow};
`;
const StyledPageContent = dt.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  position: relative;
  z-index: 2;
`;
const Page = ({
  overflow,
  maxWidth,
  maxHeight,
  minWidth,
  minHeight,
  maxWidthType,
  maxHeightType,
  minWidthType,
  minHeightType,
  padding,
  borderColor,
  borderWidth,
  boxShadow,
  backgroundColor,
  backgroundImage,
  backgroundSize,
  children
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    StyledPage,
    {
      ...{
        overflow,
        maxWidth,
        maxHeight,
        minWidth,
        minHeight,
        maxWidthType,
        maxHeightType,
        minWidthType,
        minHeightType,
        padding,
        borderColor,
        borderWidth,
        boxShadow,
        backgroundColor
      },
      "data-testid": "page",
      children: [
        backgroundImage ? /* @__PURE__ */ jsxRuntimeExports.jsx(PageBackground, { ...{ padding, backgroundImage, backgroundSize } }) : null,
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPageContent, { children })
      ]
    }
  );
};
var reactGridLayout = { exports: {} };
var ReactGridLayout$1 = {};
function createDefaultIsNestedEqual(comparator) {
  return function isEqual(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, meta) {
    return comparator(a, b, meta);
  };
}
function createIsCircular(areItemsEqual) {
  return function isCircular(a, b, isEqual, cache) {
    if (!a || !b || typeof a !== "object" || typeof b !== "object") {
      return areItemsEqual(a, b, isEqual, cache);
    }
    var cachedA = cache.get(a);
    var cachedB = cache.get(b);
    if (cachedA && cachedB) {
      return cachedA === b && cachedB === a;
    }
    cache.set(a, b);
    cache.set(b, a);
    var result = areItemsEqual(a, b, isEqual, cache);
    cache.delete(a);
    cache.delete(b);
    return result;
  };
}
function merge(a, b) {
  var merged = {};
  for (var key in a) {
    merged[key] = a[key];
  }
  for (var key in b) {
    merged[key] = b[key];
  }
  return merged;
}
function isPlainObject(value) {
  return value.constructor === Object || value.constructor == null;
}
function isPromiseLike(value) {
  return typeof value.then === "function";
}
function sameValueZeroEqual(a, b) {
  return a === b || a !== a && b !== b;
}
var ARGUMENTS_TAG = "[object Arguments]";
var BOOLEAN_TAG = "[object Boolean]";
var DATE_TAG = "[object Date]";
var REG_EXP_TAG = "[object RegExp]";
var MAP_TAG = "[object Map]";
var NUMBER_TAG = "[object Number]";
var OBJECT_TAG = "[object Object]";
var SET_TAG = "[object Set]";
var STRING_TAG = "[object String]";
var toString = Object.prototype.toString;
function createComparator(_a) {
  var areArraysEqual2 = _a.areArraysEqual, areDatesEqual2 = _a.areDatesEqual, areMapsEqual2 = _a.areMapsEqual, areObjectsEqual2 = _a.areObjectsEqual, areRegExpsEqual2 = _a.areRegExpsEqual, areSetsEqual2 = _a.areSetsEqual, createIsNestedEqual = _a.createIsNestedEqual;
  var isEqual = createIsNestedEqual(comparator);
  function comparator(a, b, meta) {
    if (a === b) {
      return true;
    }
    if (!a || !b || typeof a !== "object" || typeof b !== "object") {
      return a !== a && b !== b;
    }
    if (isPlainObject(a) && isPlainObject(b)) {
      return areObjectsEqual2(a, b, isEqual, meta);
    }
    var aArray = Array.isArray(a);
    var bArray = Array.isArray(b);
    if (aArray || bArray) {
      return aArray === bArray && areArraysEqual2(a, b, isEqual, meta);
    }
    var aTag = toString.call(a);
    if (aTag !== toString.call(b)) {
      return false;
    }
    if (aTag === DATE_TAG) {
      return areDatesEqual2(a, b, isEqual, meta);
    }
    if (aTag === REG_EXP_TAG) {
      return areRegExpsEqual2(a, b, isEqual, meta);
    }
    if (aTag === MAP_TAG) {
      return areMapsEqual2(a, b, isEqual, meta);
    }
    if (aTag === SET_TAG) {
      return areSetsEqual2(a, b, isEqual, meta);
    }
    if (aTag === OBJECT_TAG || aTag === ARGUMENTS_TAG) {
      return isPromiseLike(a) || isPromiseLike(b) ? false : areObjectsEqual2(a, b, isEqual, meta);
    }
    if (aTag === BOOLEAN_TAG || aTag === NUMBER_TAG || aTag === STRING_TAG) {
      return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    return false;
  }
  return comparator;
}
function areArraysEqual(a, b, isEqual, meta) {
  var index2 = a.length;
  if (b.length !== index2) {
    return false;
  }
  while (index2-- > 0) {
    if (!isEqual(a[index2], b[index2], index2, index2, a, b, meta)) {
      return false;
    }
  }
  return true;
}
var areArraysEqualCircular = createIsCircular(areArraysEqual);
function areDatesEqual(a, b) {
  return sameValueZeroEqual(a.valueOf(), b.valueOf());
}
function areMapsEqual(a, b, isEqual, meta) {
  var isValueEqual = a.size === b.size;
  if (!isValueEqual) {
    return false;
  }
  if (!a.size) {
    return true;
  }
  var matchedIndices = {};
  var indexA = 0;
  a.forEach(function(aValue, aKey) {
    if (!isValueEqual) {
      return;
    }
    var hasMatch = false;
    var matchIndexB = 0;
    b.forEach(function(bValue, bKey) {
      if (!hasMatch && !matchedIndices[matchIndexB] && (hasMatch = isEqual(aKey, bKey, indexA, matchIndexB, a, b, meta) && isEqual(aValue, bValue, aKey, bKey, a, b, meta))) {
        matchedIndices[matchIndexB] = true;
      }
      matchIndexB++;
    });
    indexA++;
    isValueEqual = hasMatch;
  });
  return isValueEqual;
}
var areMapsEqualCircular = createIsCircular(areMapsEqual);
var OWNER = "_owner";
var hasOwnProperty = Object.prototype.hasOwnProperty;
function areObjectsEqual(a, b, isEqual, meta) {
  var keysA = Object.keys(a);
  var index2 = keysA.length;
  if (Object.keys(b).length !== index2) {
    return false;
  }
  var key;
  while (index2-- > 0) {
    key = keysA[index2];
    if (key === OWNER) {
      var reactElementA = !!a.$$typeof;
      var reactElementB = !!b.$$typeof;
      if ((reactElementA || reactElementB) && reactElementA !== reactElementB) {
        return false;
      }
    }
    if (!hasOwnProperty.call(b, key) || !isEqual(a[key], b[key], key, key, a, b, meta)) {
      return false;
    }
  }
  return true;
}
var areObjectsEqualCircular = createIsCircular(areObjectsEqual);
function areRegExpsEqual(a, b) {
  return a.source === b.source && a.flags === b.flags;
}
function areSetsEqual(a, b, isEqual, meta) {
  var isValueEqual = a.size === b.size;
  if (!isValueEqual) {
    return false;
  }
  if (!a.size) {
    return true;
  }
  var matchedIndices = {};
  a.forEach(function(aValue, aKey) {
    if (!isValueEqual) {
      return;
    }
    var hasMatch = false;
    var matchIndex = 0;
    b.forEach(function(bValue, bKey) {
      if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = isEqual(aValue, bValue, aKey, bKey, a, b, meta))) {
        matchedIndices[matchIndex] = true;
      }
      matchIndex++;
    });
    isValueEqual = hasMatch;
  });
  return isValueEqual;
}
var areSetsEqualCircular = createIsCircular(areSetsEqual);
var DEFAULT_CONFIG = Object.freeze({
  areArraysEqual,
  areDatesEqual,
  areMapsEqual,
  areObjectsEqual,
  areRegExpsEqual,
  areSetsEqual,
  createIsNestedEqual: createDefaultIsNestedEqual
});
var DEFAULT_CIRCULAR_CONFIG = Object.freeze({
  areArraysEqual: areArraysEqualCircular,
  areDatesEqual,
  areMapsEqual: areMapsEqualCircular,
  areObjectsEqual: areObjectsEqualCircular,
  areRegExpsEqual,
  areSetsEqual: areSetsEqualCircular,
  createIsNestedEqual: createDefaultIsNestedEqual
});
var isDeepEqual = createComparator(DEFAULT_CONFIG);
function deepEqual(a, b) {
  return isDeepEqual(a, b, void 0);
}
var isShallowEqual = createComparator(merge(DEFAULT_CONFIG, { createIsNestedEqual: function() {
  return sameValueZeroEqual;
} }));
function shallowEqual(a, b) {
  return isShallowEqual(a, b, void 0);
}
var isCircularDeepEqual = createComparator(DEFAULT_CIRCULAR_CONFIG);
function circularDeepEqual(a, b) {
  return isCircularDeepEqual(a, b, /* @__PURE__ */ new WeakMap());
}
var isCircularShallowEqual = createComparator(merge(DEFAULT_CIRCULAR_CONFIG, {
  createIsNestedEqual: function() {
    return sameValueZeroEqual;
  }
}));
function circularShallowEqual(a, b) {
  return isCircularShallowEqual(a, b, /* @__PURE__ */ new WeakMap());
}
function createCustomEqual(getComparatorOptions) {
  return createComparator(merge(DEFAULT_CONFIG, getComparatorOptions(DEFAULT_CONFIG)));
}
function createCustomCircularEqual(getComparatorOptions) {
  var comparator = createComparator(merge(DEFAULT_CIRCULAR_CONFIG, getComparatorOptions(DEFAULT_CIRCULAR_CONFIG)));
  return function(a, b, meta) {
    if (meta === void 0) {
      meta = /* @__PURE__ */ new WeakMap();
    }
    return comparator(a, b, meta);
  };
}
const fastEquals_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  circularDeepEqual,
  circularShallowEqual,
  createCustomCircularEqual,
  createCustomEqual,
  deepEqual,
  sameValueZeroEqual,
  shallowEqual
}, Symbol.toStringTag, { value: "Module" }));
const require$$2$1 = /* @__PURE__ */ getAugmentedNamespace(fastEquals_esm);
var clsx$1 = { exports: {} };
function r$1(e2) {
  var o2, t, f2 = "";
  if ("string" == typeof e2 || "number" == typeof e2) f2 += e2;
  else if ("object" == typeof e2) if (Array.isArray(e2)) {
    var n = e2.length;
    for (o2 = 0; o2 < n; o2++) e2[o2] && (t = r$1(e2[o2])) && (f2 && (f2 += " "), f2 += t);
  } else for (t in e2) e2[t] && (f2 && (f2 += " "), f2 += t);
  return f2;
}
function e() {
  for (var e2, o2, t = 0, f2 = "", n = arguments.length; t < n; t++) (e2 = arguments[t]) && (o2 = r$1(e2)) && (f2 && (f2 += " "), f2 += o2);
  return f2;
}
clsx$1.exports = e, clsx$1.exports.clsx = e;
var clsxExports = clsx$1.exports;
var utils$1 = {};
var fastRGLPropsEqual = function fastRGLPropsEqual2(a, b, isEqualImpl) {
  if (a === b) return true;
  return a.className === b.className && isEqualImpl(a.style, b.style) && a.width === b.width && a.autoSize === b.autoSize && a.cols === b.cols && a.draggableCancel === b.draggableCancel && a.draggableHandle === b.draggableHandle && isEqualImpl(a.verticalCompact, b.verticalCompact) && isEqualImpl(a.compactType, b.compactType) && isEqualImpl(a.layout, b.layout) && isEqualImpl(a.margin, b.margin) && isEqualImpl(a.containerPadding, b.containerPadding) && a.rowHeight === b.rowHeight && a.maxRows === b.maxRows && a.isBounded === b.isBounded && a.isDraggable === b.isDraggable && a.isResizable === b.isResizable && a.allowOverlap === b.allowOverlap && a.preventCollision === b.preventCollision && a.useCSSTransforms === b.useCSSTransforms && a.transformScale === b.transformScale && a.isDroppable === b.isDroppable && isEqualImpl(a.resizeHandles, b.resizeHandles) && isEqualImpl(a.resizeHandle, b.resizeHandle) && a.onLayoutChange === b.onLayoutChange && a.onDragStart === b.onDragStart && a.onDrag === b.onDrag && a.onDragStop === b.onDragStop && a.onResizeStart === b.onResizeStart && a.onResize === b.onResize && a.onResizeStop === b.onResizeStop && a.onDrop === b.onDrop && isEqualImpl(a.droppingItem, b.droppingItem) && isEqualImpl(a.innerRef, b.innerRef);
};
Object.defineProperty(utils$1, "__esModule", {
  value: true
});
utils$1.bottom = bottom$1;
utils$1.childrenEqual = childrenEqual;
utils$1.cloneLayout = cloneLayout;
utils$1.cloneLayoutItem = cloneLayoutItem$1;
utils$1.collides = collides$1;
utils$1.compact = compact$1;
utils$1.compactForResize = compactForResize;
utils$1.compactItem = compactItem$1;
utils$1.compactType = compactType;
utils$1.correctBounds = correctBounds;
utils$1.fastPositionEqual = fastPositionEqual;
utils$1.fastRGLPropsEqual = void 0;
utils$1.getAllCollisions = getAllCollisions;
utils$1.getFirstCollision = getFirstCollision$1;
utils$1.getLayoutItem = getLayoutItem;
utils$1.getStatics = getStatics$1;
utils$1.isLayoutItemVisible = isLayoutItemVisible;
utils$1.modifyLayout = modifyLayout;
utils$1.moveElement = moveElement;
utils$1.moveElementAwayFromCollision = moveElementAwayFromCollision;
utils$1.noop = void 0;
utils$1.perc = perc;
utils$1.resizeItemInDirection = resizeItemInDirection;
utils$1.setTopLeft = setTopLeft;
utils$1.setTransform = setTransform;
utils$1.sortLayoutItems = sortLayoutItems$1;
utils$1.sortLayoutItemsByColRow = sortLayoutItemsByColRow$1;
utils$1.sortLayoutItemsByRowCol = sortLayoutItemsByRowCol$1;
utils$1.synchronizeLayoutWithChildren = synchronizeLayoutWithChildren;
utils$1.validateLayout = validateLayout;
utils$1.withLayoutItem = withLayoutItem;
var _fastEquals$2 = require$$2$1;
var _react$3 = _interopRequireDefault$9(o);
function _interopRequireDefault$9(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
const isProduction = process.env.NODE_ENV === "production";
function bottom$1(layout) {
  let max = 0, bottomY;
  for (let i = 0, len = layout.length; i < len; i++) {
    bottomY = layout[i].y + layout[i].h;
    if (bottomY > max) max = bottomY;
  }
  return max;
}
function cloneLayout(layout) {
  const newLayout = Array(layout.length);
  for (let i = 0, len = layout.length; i < len; i++) {
    newLayout[i] = cloneLayoutItem$1(layout[i]);
  }
  return newLayout;
}
function modifyLayout(layout, layoutItem) {
  const newLayout = Array(layout.length);
  for (let i = 0, len = layout.length; i < len; i++) {
    if (layoutItem.i === layout[i].i) {
      newLayout[i] = layoutItem;
    } else {
      newLayout[i] = layout[i];
    }
  }
  return newLayout;
}
function withLayoutItem(layout, itemKey, cb) {
  let item = getLayoutItem(layout, itemKey);
  if (!item) return [layout, null];
  item = cb(cloneLayoutItem$1(item));
  layout = modifyLayout(layout, item);
  return [layout, item];
}
function cloneLayoutItem$1(layoutItem) {
  return {
    w: layoutItem.w,
    h: layoutItem.h,
    x: layoutItem.x,
    y: layoutItem.y,
    i: layoutItem.i,
    minW: layoutItem.minW,
    maxW: layoutItem.maxW,
    minH: layoutItem.minH,
    maxH: layoutItem.maxH,
    moved: Boolean(layoutItem.moved),
    static: Boolean(layoutItem.static),
    // These can be null/undefined
    isDraggable: layoutItem.isDraggable,
    isResizable: layoutItem.isResizable,
    resizeHandles: layoutItem.resizeHandles,
    isBounded: layoutItem.isBounded
  };
}
function childrenEqual(a, b) {
  return (0, _fastEquals$2.deepEqual)(_react$3.default.Children.map(a, (c) => c == null ? void 0 : c.key), _react$3.default.Children.map(b, (c) => c == null ? void 0 : c.key)) && (0, _fastEquals$2.deepEqual)(_react$3.default.Children.map(a, (c) => c == null ? void 0 : c.props["data-grid"]), _react$3.default.Children.map(b, (c) => c == null ? void 0 : c.props["data-grid"]));
}
utils$1.fastRGLPropsEqual = fastRGLPropsEqual;
function fastPositionEqual(a, b) {
  return a.left === b.left && a.top === b.top && a.width === b.width && a.height === b.height;
}
function collides$1(l1, l2) {
  if (l1.i === l2.i) return false;
  if (l1.x + l1.w <= l2.x) return false;
  if (l1.x >= l2.x + l2.w) return false;
  if (l1.y + l1.h <= l2.y) return false;
  if (l1.y >= l2.y + l2.h) return false;
  return true;
}
function compact$1(layout, compactType2, cols, allowOverlap) {
  const compareWith = getStatics$1(layout);
  const sorted = sortLayoutItems$1(layout, compactType2);
  const out = Array(layout.length);
  for (let i = 0, len = sorted.length; i < len; i++) {
    let l = cloneLayoutItem$1(sorted[i]);
    if (!l.static) {
      l = compactItem$1(compareWith, l, compactType2, cols, sorted, allowOverlap);
      compareWith.push(l);
    }
    out[layout.indexOf(sorted[i])] = l;
    l.moved = false;
  }
  return out;
}
const heightWidth$1 = {
  x: "w",
  y: "h"
};
function resolveCompactionCollision$1(layout, item, moveToCoord, axis) {
  const sizeProp = heightWidth$1[axis];
  item[axis] += 1;
  const itemIndex = layout.map((layoutItem) => {
    return layoutItem.i;
  }).indexOf(item.i);
  for (let i = itemIndex + 1; i < layout.length; i++) {
    const otherItem = layout[i];
    if (otherItem.static) continue;
    if (otherItem.y > item.y + item.h) break;
    if (collides$1(item, otherItem)) {
      resolveCompactionCollision$1(layout, otherItem, moveToCoord + item[sizeProp], axis);
    }
  }
  item[axis] = moveToCoord;
}
function compactItem$1(compareWith, l, compactType2, cols, fullLayout, allowOverlap) {
  const compactV = compactType2 === "vertical";
  const compactH = compactType2 === "horizontal";
  if (compactV) {
    l.y = Math.min(bottom$1(compareWith), l.y);
    while (l.y > 0 && !getFirstCollision$1(compareWith, l)) {
      l.y--;
    }
  } else if (compactH) {
    while (l.x > 0 && !getFirstCollision$1(compareWith, l)) {
      l.x--;
    }
  }
  let collides2;
  while ((collides2 = getFirstCollision$1(compareWith, l)) && !(compactType2 === null && allowOverlap)) {
    if (compactH) {
      resolveCompactionCollision$1(fullLayout, l, collides2.x + collides2.w, "x");
    } else {
      resolveCompactionCollision$1(fullLayout, l, collides2.y + collides2.h, "y");
    }
    if (compactH && l.x + l.w > cols) {
      l.x = cols - l.w;
      l.y++;
      while (l.x > 0 && !getFirstCollision$1(compareWith, l)) {
        l.x--;
      }
    }
  }
  l.y = Math.max(l.y, 0);
  l.x = Math.max(l.x, 0);
  return l;
}
function compactForResize(layout, i, w2, h, handle, preventCollision, allowOverlap, cols, compactType2) {
  let shouldMoveItem = false;
  let finalLayout;
  let x2;
  let y2;
  const [newLayout, l] = withLayoutItem(layout, i, (l2) => {
    let hasCollisions;
    x2 = l2.x;
    y2 = l2.y;
    if (["sw", "w", "nw", "n", "ne"].indexOf(handle) !== -1) {
      if (["sw", "nw", "w"].indexOf(handle) !== -1) {
        x2 = l2.x + (l2.w - w2);
        w2 = l2.x !== x2 && x2 < 0 ? l2.w : w2;
        x2 = x2 < 0 ? 0 : x2;
      }
      if (["ne", "n", "nw"].indexOf(handle) !== -1) {
        y2 = l2.y + (l2.h - h);
        h = l2.y !== y2 && y2 < 0 ? l2.h : h;
        y2 = y2 < 0 ? 0 : y2;
      }
      shouldMoveItem = true;
    }
    if (preventCollision && !allowOverlap) {
      const collisions = getAllCollisions(layout, {
        ...l2,
        w: w2,
        h,
        x: x2,
        y: y2
      }).filter((layoutItem) => layoutItem.i !== l2.i);
      hasCollisions = collisions.length > 0;
      if (hasCollisions) {
        y2 = l2.y;
        h = l2.h;
        x2 = l2.x;
        w2 = l2.w;
        shouldMoveItem = false;
      }
    }
    l2.w = w2;
    l2.h = h;
    return l2;
  });
  if (!l) return;
  finalLayout = newLayout;
  if (shouldMoveItem) {
    const isUserAction = true;
    finalLayout = moveElement(newLayout, l, x2, y2, isUserAction, preventCollision, compactType2, cols, allowOverlap);
  }
  return finalLayout;
}
function correctBounds(layout, bounds) {
  const collidesWith = getStatics$1(layout);
  for (let i = 0, len = layout.length; i < len; i++) {
    const l = layout[i];
    if (l.x + l.w > bounds.cols) l.x = bounds.cols - l.w;
    if (l.x < 0) {
      l.x = 0;
      l.w = bounds.cols;
    }
    if (!l.static) collidesWith.push(l);
    else {
      while (getFirstCollision$1(collidesWith, l)) {
        l.y++;
      }
    }
  }
  return layout;
}
function getLayoutItem(layout, id) {
  for (let i = 0, len = layout.length; i < len; i++) {
    if (layout[i].i === id) return layout[i];
  }
}
function getFirstCollision$1(layout, layoutItem) {
  for (let i = 0, len = layout.length; i < len; i++) {
    if (collides$1(layout[i], layoutItem)) return layout[i];
  }
}
function getAllCollisions(layout, layoutItem) {
  return layout.filter((l) => collides$1(l, layoutItem));
}
function getStatics$1(layout) {
  return layout.filter((l) => l.static);
}
function moveElement(layout, l, x2, y2, isUserAction, preventCollision, compactType2, cols, allowOverlap) {
  if (l.static && l.isDraggable !== true) return layout;
  if (l.y === y2 && l.x === x2) return layout;
  log$2(`Moving element ${l.i} to [${String(x2)},${String(y2)}] from [${l.x},${l.y}]`);
  const oldX = l.x;
  const oldY = l.y;
  if (typeof x2 === "number") l.x = x2;
  if (typeof y2 === "number") l.y = y2;
  l.moved = true;
  let sorted = sortLayoutItems$1(layout, compactType2);
  const movingUp = compactType2 === "vertical" && typeof y2 === "number" ? oldY >= y2 : compactType2 === "horizontal" && typeof x2 === "number" ? oldX >= x2 : false;
  if (movingUp) sorted = sorted.reverse();
  const collisions = getAllCollisions(sorted, l);
  const hasCollisions = collisions.length > 0;
  if (hasCollisions && allowOverlap) {
    return cloneLayout(layout);
  } else if (hasCollisions && preventCollision) {
    log$2(`Collision prevented on ${l.i}, reverting.`);
    l.x = oldX;
    l.y = oldY;
    l.moved = false;
    return layout;
  }
  for (let i = 0, len = collisions.length; i < len; i++) {
    const collision = collisions[i];
    log$2(`Resolving collision between ${l.i} at [${l.x},${l.y}] and ${collision.i} at [${collision.x},${collision.y}]`);
    if (collision.moved) continue;
    if (collision.static) {
      layout = moveElementAwayFromCollision(layout, collision, l, isUserAction, compactType2);
    } else {
      layout = moveElementAwayFromCollision(layout, l, collision, isUserAction, compactType2);
    }
  }
  return layout;
}
function moveElementAwayFromCollision(layout, collidesWith, itemToMove, isUserAction, compactType2, cols) {
  const compactH = compactType2 === "horizontal";
  const compactV = compactType2 === "vertical";
  const preventCollision = collidesWith.static;
  if (isUserAction) {
    isUserAction = false;
    const fakeItem = {
      x: compactH ? Math.max(collidesWith.x - itemToMove.w, 0) : itemToMove.x,
      y: compactV ? Math.max(collidesWith.y - itemToMove.h, 0) : itemToMove.y,
      w: itemToMove.w,
      h: itemToMove.h,
      i: "-1"
    };
    const firstCollision = getFirstCollision$1(layout, fakeItem);
    const collisionNorth = firstCollision && firstCollision.y + firstCollision.h > collidesWith.y;
    const collisionWest = firstCollision && collidesWith.x + collidesWith.w > firstCollision.x;
    if (!firstCollision) {
      log$2(`Doing reverse collision on ${itemToMove.i} up to [${fakeItem.x},${fakeItem.y}].`);
      return moveElement(layout, itemToMove, compactH ? fakeItem.x : void 0, compactV ? fakeItem.y : void 0, isUserAction, preventCollision, compactType2);
    } else if (collisionNorth && compactV) {
      return moveElement(layout, itemToMove, void 0, collidesWith.y + 1, isUserAction, preventCollision, compactType2);
    } else if (collisionNorth && compactType2 == null) {
      collidesWith.y = itemToMove.y;
      itemToMove.y = itemToMove.y + itemToMove.h;
      return layout;
    } else if (collisionWest && compactH) {
      return moveElement(layout, collidesWith, itemToMove.x, void 0, isUserAction, preventCollision, compactType2);
    }
  }
  const newX = compactH ? itemToMove.x + 1 : void 0;
  const newY = compactV ? itemToMove.y + 1 : void 0;
  if (newX == null && newY == null) {
    return layout;
  }
  return moveElement(layout, itemToMove, compactH ? itemToMove.x + 1 : void 0, compactV ? itemToMove.y + 1 : void 0, isUserAction, preventCollision, compactType2);
}
function perc(num) {
  return num * 100 + "%";
}
const constrainWidth = (left, currentWidth, newWidth, containerWidth) => {
  return left + newWidth > containerWidth ? currentWidth : newWidth;
};
const constrainHeight = (top, currentHeight, newHeight) => {
  return top < 0 ? currentHeight : newHeight;
};
const constrainLeft = (left) => Math.max(0, left);
const constrainTop = (top) => Math.max(0, top);
const resizeNorth = (currentSize, _ref, _containerWidth) => {
  let {
    left,
    height: height2,
    width: width2
  } = _ref;
  const top = currentSize.top - (height2 - currentSize.height);
  return {
    left,
    width: width2,
    height: constrainHeight(top, currentSize.height, height2),
    top: constrainTop(top)
  };
};
const resizeEast = (currentSize, _ref2, containerWidth) => {
  let {
    top,
    left,
    height: height2,
    width: width2
  } = _ref2;
  return {
    top,
    height: height2,
    width: constrainWidth(currentSize.left, currentSize.width, width2, containerWidth),
    left: constrainLeft(left)
  };
};
const resizeWest = (currentSize, _ref3, containerWidth) => {
  let {
    top,
    height: height2,
    width: width2
  } = _ref3;
  const left = currentSize.left - (width2 - currentSize.width);
  return {
    height: height2,
    width: left < 0 ? currentSize.width : constrainWidth(currentSize.left, currentSize.width, width2, containerWidth),
    top: constrainTop(top),
    left: constrainLeft(left)
  };
};
const resizeSouth = (currentSize, _ref4, containerWidth) => {
  let {
    top,
    left,
    height: height2,
    width: width2
  } = _ref4;
  return {
    width: width2,
    left,
    height: constrainHeight(top, currentSize.height, height2),
    top: constrainTop(top)
  };
};
const resizeNorthEast = function() {
  return resizeNorth(arguments.length <= 0 ? void 0 : arguments[0], resizeEast(...arguments));
};
const resizeNorthWest = function() {
  return resizeNorth(arguments.length <= 0 ? void 0 : arguments[0], resizeWest(...arguments));
};
const resizeSouthEast = function() {
  return resizeSouth(arguments.length <= 0 ? void 0 : arguments[0], resizeEast(...arguments));
};
const resizeSouthWest = function() {
  return resizeSouth(arguments.length <= 0 ? void 0 : arguments[0], resizeWest(...arguments));
};
const ordinalResizeHandlerMap = {
  n: resizeNorth,
  ne: resizeNorthEast,
  e: resizeEast,
  se: resizeSouthEast,
  s: resizeSouth,
  sw: resizeSouthWest,
  w: resizeWest,
  nw: resizeNorthWest
};
function resizeItemInDirection(direction, currentSize, newSize, containerWidth) {
  const ordinalHandler = ordinalResizeHandlerMap[direction];
  if (!ordinalHandler) return newSize;
  return ordinalHandler(currentSize, {
    ...currentSize,
    ...newSize
  }, containerWidth);
}
function setTransform(_ref5) {
  let {
    top,
    left,
    width: width2,
    height: height2
  } = _ref5;
  const translate = `translate(${left}px,${top}px)`;
  return {
    transform: translate,
    WebkitTransform: translate,
    MozTransform: translate,
    msTransform: translate,
    OTransform: translate,
    width: `${width2}px`,
    height: `${height2}px`,
    position: "absolute"
  };
}
function setTopLeft(_ref6) {
  let {
    top,
    left,
    width: width2,
    height: height2
  } = _ref6;
  return {
    top: `${top}px`,
    left: `${left}px`,
    width: `${width2}px`,
    height: `${height2}px`,
    position: "absolute"
  };
}
function sortLayoutItems$1(layout, compactType2) {
  if (compactType2 === "horizontal") return sortLayoutItemsByColRow$1(layout);
  if (compactType2 === "vertical") return sortLayoutItemsByRowCol$1(layout);
  else return layout;
}
function sortLayoutItemsByRowCol$1(layout) {
  return layout.slice(0).sort(function(a, b) {
    if (a.y > b.y || a.y === b.y && a.x > b.x) {
      return 1;
    } else if (a.y === b.y && a.x === b.x) {
      return 0;
    }
    return -1;
  });
}
function sortLayoutItemsByColRow$1(layout) {
  return layout.slice(0).sort(function(a, b) {
    if (a.x > b.x || a.x === b.x && a.y > b.y) {
      return 1;
    }
    return -1;
  });
}
function synchronizeLayoutWithChildren(initialLayout, children, cols, compactType2, allowOverlap) {
  initialLayout = initialLayout || [];
  const layout = [];
  _react$3.default.Children.forEach(children, (child) => {
    if ((child == null ? void 0 : child.key) == null) return;
    const exists = getLayoutItem(initialLayout, String(child.key));
    const g2 = child.props["data-grid"];
    if (exists && g2 == null) {
      layout.push(cloneLayoutItem$1(exists));
    } else {
      if (g2) {
        if (!isProduction) {
          validateLayout([g2], "ReactGridLayout.children");
        }
        layout.push(cloneLayoutItem$1({
          ...g2,
          i: child.key
        }));
      } else {
        layout.push(cloneLayoutItem$1({
          w: 1,
          h: 1,
          x: 0,
          y: bottom$1(layout),
          i: String(child.key)
        }));
      }
    }
  });
  const correctedLayout = correctBounds(layout, {
    cols
  });
  return allowOverlap ? correctedLayout : compact$1(correctedLayout, compactType2, cols);
}
function isLayoutItemVisible(l, rowHeight, margin, parentContainerScrollTop, parentContainerHeight) {
  const top = rowHeight * l.y + margin[1];
  const bottom2 = top + margin[1] + rowHeight * l.h;
  const scrollTop = parentContainerScrollTop;
  const scrollBottom = scrollTop + parentContainerHeight;
  const isTopVisible = top >= scrollTop && top <= scrollBottom;
  const isBottomVisible = bottom2 >= scrollTop && bottom2 <= scrollBottom;
  const elementHeight = bottom2 - top;
  const viewportHeight = scrollBottom - scrollTop;
  const isElementTallerThanViewport = elementHeight > viewportHeight;
  const isViewportWithinElement = isElementTallerThanViewport && top <= scrollTop && bottom2 >= scrollBottom;
  return isTopVisible || isBottomVisible || isViewportWithinElement;
}
function validateLayout(layout) {
  let contextName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Layout";
  const subProps = ["x", "y", "w", "h"];
  if (!Array.isArray(layout)) throw new Error(contextName + " must be an array!");
  for (let i = 0, len = layout.length; i < len; i++) {
    const item = layout[i];
    for (let j2 = 0; j2 < subProps.length; j2++) {
      const key = subProps[j2];
      const value = item[key];
      if (typeof value !== "number" || Number.isNaN(value)) {
        throw new Error(`ReactGridLayout: ${contextName}[${i}].${key} must be a number! Received: ${value} (${typeof value})`);
      }
    }
    if (typeof item.i !== "undefined" && typeof item.i !== "string") {
      throw new Error(`ReactGridLayout: ${contextName}[${i}].i must be a string! Received: ${item.i} (${typeof item.i})`);
    }
  }
}
function compactType(props) {
  const {
    verticalCompact,
    compactType: compactType2
  } = props || {};
  return verticalCompact === false ? null : compactType2;
}
function log$2() {
  return;
}
const noop = () => {
};
utils$1.noop = noop;
var calculateUtils = {};
Object.defineProperty(calculateUtils, "__esModule", {
  value: true
});
calculateUtils.calcGridColWidth = calcGridColWidth;
calculateUtils.calcGridItemPosition = calcGridItemPosition;
calculateUtils.calcGridItemWHPx = calcGridItemWHPx;
calculateUtils.calcWH = calcWH;
calculateUtils.calcXY = calcXY;
calculateUtils.clamp = clamp;
function calcGridColWidth(positionParams) {
  const {
    margin,
    containerPadding,
    containerWidth,
    cols
  } = positionParams;
  return (containerWidth - margin[0] * (cols - 1) - containerPadding[0] * 2) / cols;
}
function calcGridItemWHPx(gridUnits, colOrRowSize, marginPx) {
  if (!Number.isFinite(gridUnits)) return gridUnits;
  return Math.round(colOrRowSize * gridUnits + Math.max(0, gridUnits - 1) * marginPx);
}
function calcGridItemPosition(positionParams, x2, y2, w2, h, state) {
  const {
    margin,
    containerPadding,
    rowHeight
  } = positionParams;
  const colWidth = calcGridColWidth(positionParams);
  const out = {};
  if (state && state.resizing) {
    out.width = Math.round(state.resizing.width);
    out.height = Math.round(state.resizing.height);
  } else {
    out.width = calcGridItemWHPx(w2, colWidth, margin[0]);
    out.height = calcGridItemWHPx(h, rowHeight, margin[1]);
  }
  if (state && state.dragging) {
    out.top = Math.round(state.dragging.top);
    out.left = Math.round(state.dragging.left);
  } else if (state && state.resizing && typeof state.resizing.top === "number" && typeof state.resizing.left === "number") {
    out.top = Math.round(state.resizing.top);
    out.left = Math.round(state.resizing.left);
  } else {
    out.top = Math.round((rowHeight + margin[1]) * y2 + containerPadding[1]);
    out.left = Math.round((colWidth + margin[0]) * x2 + containerPadding[0]);
  }
  return out;
}
function calcXY(positionParams, top, left, w2, h) {
  const {
    margin,
    containerPadding,
    cols,
    rowHeight,
    maxRows
  } = positionParams;
  const colWidth = calcGridColWidth(positionParams);
  let x2 = Math.round((left - containerPadding[0]) / (colWidth + margin[0]));
  let y2 = Math.round((top - containerPadding[1]) / (rowHeight + margin[1]));
  x2 = clamp(x2, 0, cols - w2);
  y2 = clamp(y2, 0, maxRows - h);
  return {
    x: x2,
    y: y2
  };
}
function calcWH(positionParams, width2, height2, x2, y2, handle) {
  const {
    margin,
    maxRows,
    cols,
    rowHeight
  } = positionParams;
  const colWidth = calcGridColWidth(positionParams);
  let w2 = Math.round((width2 + margin[0]) / (colWidth + margin[0]));
  let h = Math.round((height2 + margin[1]) / (rowHeight + margin[1]));
  let _w = clamp(w2, 0, cols - x2);
  let _h = clamp(h, 0, maxRows - y2);
  if (["sw", "w", "nw"].indexOf(handle) !== -1) {
    _w = clamp(w2, 0, cols);
  }
  if (["nw", "n", "ne"].indexOf(handle) !== -1) {
    _h = clamp(h, 0, maxRows);
  }
  return {
    w: _w,
    h: _h
  };
}
function clamp(num, lowerBound, upperBound) {
  return Math.max(Math.min(num, upperBound), lowerBound);
}
var GridItem$1 = {};
var propTypes$1 = { exports: {} };
var reactIs = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e2 = b ? Symbol.for("react.fragment") : 60107, f2 = b ? Symbol.for("react.strict_mode") : 60108, g2 = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k2 = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m2 = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q2 = b ? Symbol.for("react.suspense_list") : 60120, r2 = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v2 = b ? Symbol.for("react.block") : 60121, w2 = b ? Symbol.for("react.fundamental") : 60117, x2 = b ? Symbol.for("react.responder") : 60118, y2 = b ? Symbol.for("react.scope") : 60119;
  function z2(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m2:
            case e2:
            case g2:
            case f2:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k2:
                case n:
                case t:
                case r2:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A2(a) {
    return z2(a) === m2;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m2;
  reactIs_production_min.ContextConsumer = k2;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e2;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r2;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g2;
  reactIs_production_min.StrictMode = f2;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function(a) {
    return A2(a) || z2(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A2;
  reactIs_production_min.isContextConsumer = function(a) {
    return z2(a) === k2;
  };
  reactIs_production_min.isContextProvider = function(a) {
    return z2(a) === h;
  };
  reactIs_production_min.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function(a) {
    return z2(a) === n;
  };
  reactIs_production_min.isFragment = function(a) {
    return z2(a) === e2;
  };
  reactIs_production_min.isLazy = function(a) {
    return z2(a) === t;
  };
  reactIs_production_min.isMemo = function(a) {
    return z2(a) === r2;
  };
  reactIs_production_min.isPortal = function(a) {
    return z2(a) === d;
  };
  reactIs_production_min.isProfiler = function(a) {
    return z2(a) === g2;
  };
  reactIs_production_min.isStrictMode = function(a) {
    return z2(a) === f2;
  };
  reactIs_production_min.isSuspense = function(a) {
    return z2(a) === p;
  };
  reactIs_production_min.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e2 || a === m2 || a === g2 || a === f2 || a === p || a === q2 || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r2 || a.$$typeof === h || a.$$typeof === k2 || a.$$typeof === n || a.$$typeof === w2 || a.$$typeof === x2 || a.$$typeof === y2 || a.$$typeof === v2);
  };
  reactIs_production_min.typeOf = z2;
  return reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type2) {
        return typeof type2 === "string" || typeof type2 === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type2 === REACT_FRAGMENT_TYPE || type2 === REACT_CONCURRENT_MODE_TYPE || type2 === REACT_PROFILER_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || typeof type2 === "object" && type2 !== null && (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_FUNDAMENTAL_TYPE || type2.$$typeof === REACT_RESPONDER_TYPE || type2.$$typeof === REACT_SCOPE_TYPE || type2.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type2 = object.type;
              switch (type2) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type2;
                default:
                  var $$typeofType = type2 && type2.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2["_" + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
        return test2[n];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from2;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from2 = Object(arguments[s]);
      for (var key in from2) {
        if (hasOwnProperty2.call(from2, key)) {
          to[key] = from2[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from2);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from2, symbols[i])) {
            to[symbols[i]] = from2[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = requireHas();
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x2) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign2 = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has2 = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x2) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is(x2, y2) {
      if (x2 === y2) {
        return x2 !== 0 || 1 / x2 === 1 / y2;
      } else {
        return x2 !== x2 && y2 !== y2;
      }
    }
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type2 = getPreciseType(value);
          if (type2 === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
          var checker2 = arrayOfTypeCheckers[i2];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type2) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type2 + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign2({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type2 = getPreciseType(value);
      switch (type2) {
        case "array":
        case "object":
          return "an " + type2;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type2;
        default:
          return type2;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs();
  var throwOnDirectAccess = true;
  propTypes$1.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes$1.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes$1.exports;
var cjs = { exports: {} };
var Draggable$1 = {};
function r(e2) {
  var t, f2, n = "";
  if ("string" == typeof e2 || "number" == typeof e2) n += e2;
  else if ("object" == typeof e2) if (Array.isArray(e2)) for (t = 0; t < e2.length; t++) e2[t] && (f2 = r(e2[t])) && (n && (n += " "), n += f2);
  else for (t in e2) e2[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e2, t, f2 = 0, n = ""; f2 < arguments.length; ) (e2 = arguments[f2++]) && (t = r(e2)) && (n && (n += " "), n += t);
  return n;
}
const clsx_m = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clsx,
  default: clsx
}, Symbol.toStringTag, { value: "Module" }));
const require$$3 = /* @__PURE__ */ getAugmentedNamespace(clsx_m);
var domFns = {};
var shims = {};
Object.defineProperty(shims, "__esModule", {
  value: true
});
shims.dontSetMe = dontSetMe;
shims.findInArray = findInArray;
shims.int = int;
shims.isFunction = isFunction;
shims.isNum = isNum;
function findInArray(array, callback) {
  for (let i = 0, length2 = array.length; i < length2; i++) {
    if (callback.apply(callback, [array[i], i, array])) return array[i];
  }
}
function isFunction(func) {
  return typeof func === "function" || Object.prototype.toString.call(func) === "[object Function]";
}
function isNum(num) {
  return typeof num === "number" && !isNaN(num);
}
function int(a) {
  return parseInt(a, 10);
}
function dontSetMe(props, propName, componentName) {
  if (props[propName]) {
    return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
  }
}
var getPrefix$1 = {};
Object.defineProperty(getPrefix$1, "__esModule", {
  value: true
});
getPrefix$1.browserPrefixToKey = browserPrefixToKey;
getPrefix$1.browserPrefixToStyle = browserPrefixToStyle;
getPrefix$1.default = void 0;
getPrefix$1.getPrefix = getPrefix;
const prefixes = ["Moz", "Webkit", "O", "ms"];
function getPrefix() {
  var _window$document;
  let prop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
  if (typeof window === "undefined") return "";
  const style = (_window$document = window.document) === null || _window$document === void 0 || (_window$document = _window$document.documentElement) === null || _window$document === void 0 ? void 0 : _window$document.style;
  if (!style) return "";
  if (prop in style) return "";
  for (let i = 0; i < prefixes.length; i++) {
    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
  }
  return "";
}
function browserPrefixToKey(prop, prefix2) {
  return prefix2 ? "".concat(prefix2).concat(kebabToTitleCase(prop)) : prop;
}
function browserPrefixToStyle(prop, prefix2) {
  return prefix2 ? "-".concat(prefix2.toLowerCase(), "-").concat(prop) : prop;
}
function kebabToTitleCase(str) {
  let out = "";
  let shouldCapitalize = true;
  for (let i = 0; i < str.length; i++) {
    if (shouldCapitalize) {
      out += str[i].toUpperCase();
      shouldCapitalize = false;
    } else if (str[i] === "-") {
      shouldCapitalize = true;
    } else {
      out += str[i];
    }
  }
  return out;
}
getPrefix$1.default = getPrefix();
Object.defineProperty(domFns, "__esModule", {
  value: true
});
domFns.addClassName = addClassName;
domFns.addEvent = addEvent;
domFns.addUserSelectStyles = addUserSelectStyles;
domFns.createCSSTransform = createCSSTransform;
domFns.createSVGTransform = createSVGTransform;
domFns.getTouch = getTouch;
domFns.getTouchIdentifier = getTouchIdentifier;
domFns.getTranslation = getTranslation;
domFns.innerHeight = innerHeight;
domFns.innerWidth = innerWidth;
domFns.matchesSelector = matchesSelector;
domFns.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
domFns.offsetXYFromParent = offsetXYFromParent;
domFns.outerHeight = outerHeight;
domFns.outerWidth = outerWidth;
domFns.removeClassName = removeClassName;
domFns.removeEvent = removeEvent;
domFns.removeUserSelectStyles = removeUserSelectStyles;
var _shims$2 = shims;
var _getPrefix = _interopRequireWildcard$6(getPrefix$1);
function _getRequireWildcardCache$6(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
  var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$6 = function(nodeInterop2) {
    return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard$6(obj, nodeInterop) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache$6(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
let matchesSelectorFunc = "";
function matchesSelector(el, selector) {
  if (!matchesSelectorFunc) {
    matchesSelectorFunc = (0, _shims$2.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(method) {
      return (0, _shims$2.isFunction)(el[method]);
    });
  }
  if (!(0, _shims$2.isFunction)(el[matchesSelectorFunc])) return false;
  return el[matchesSelectorFunc](selector);
}
function matchesSelectorAndParentsTo(el, selector, baseNode) {
  let node2 = el;
  do {
    if (matchesSelector(node2, selector)) return true;
    if (node2 === baseNode) return false;
    node2 = node2.parentNode;
  } while (node2);
  return false;
}
function addEvent(el, event, handler, inputOptions) {
  if (!el) return;
  const options = {
    capture: true,
    ...inputOptions
  };
  if (el.addEventListener) {
    el.addEventListener(event, handler, options);
  } else if (el.attachEvent) {
    el.attachEvent("on" + event, handler);
  } else {
    el["on" + event] = handler;
  }
}
function removeEvent(el, event, handler, inputOptions) {
  if (!el) return;
  const options = {
    capture: true,
    ...inputOptions
  };
  if (el.removeEventListener) {
    el.removeEventListener(event, handler, options);
  } else if (el.detachEvent) {
    el.detachEvent("on" + event, handler);
  } else {
    el["on" + event] = null;
  }
}
function outerHeight(node2) {
  let height2 = node2.clientHeight;
  const computedStyle = node2.ownerDocument.defaultView.getComputedStyle(node2);
  height2 += (0, _shims$2.int)(computedStyle.borderTopWidth);
  height2 += (0, _shims$2.int)(computedStyle.borderBottomWidth);
  return height2;
}
function outerWidth(node2) {
  let width2 = node2.clientWidth;
  const computedStyle = node2.ownerDocument.defaultView.getComputedStyle(node2);
  width2 += (0, _shims$2.int)(computedStyle.borderLeftWidth);
  width2 += (0, _shims$2.int)(computedStyle.borderRightWidth);
  return width2;
}
function innerHeight(node2) {
  let height2 = node2.clientHeight;
  const computedStyle = node2.ownerDocument.defaultView.getComputedStyle(node2);
  height2 -= (0, _shims$2.int)(computedStyle.paddingTop);
  height2 -= (0, _shims$2.int)(computedStyle.paddingBottom);
  return height2;
}
function innerWidth(node2) {
  let width2 = node2.clientWidth;
  const computedStyle = node2.ownerDocument.defaultView.getComputedStyle(node2);
  width2 -= (0, _shims$2.int)(computedStyle.paddingLeft);
  width2 -= (0, _shims$2.int)(computedStyle.paddingRight);
  return width2;
}
function offsetXYFromParent(evt, offsetParent, scale) {
  const isBody = offsetParent === offsetParent.ownerDocument.body;
  const offsetParentRect = isBody ? {
    left: 0,
    top: 0
  } : offsetParent.getBoundingClientRect();
  const x2 = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
  const y2 = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
  return {
    x: x2,
    y: y2
  };
}
function createCSSTransform(controlPos, positionOffset) {
  const translation = getTranslation(controlPos, positionOffset, "px");
  return {
    [(0, _getPrefix.browserPrefixToKey)("transform", _getPrefix.default)]: translation
  };
}
function createSVGTransform(controlPos, positionOffset) {
  const translation = getTranslation(controlPos, positionOffset, "");
  return translation;
}
function getTranslation(_ref, positionOffset, unitSuffix) {
  let {
    x: x2,
    y: y2
  } = _ref;
  let translation = "translate(".concat(x2).concat(unitSuffix, ",").concat(y2).concat(unitSuffix, ")");
  if (positionOffset) {
    const defaultX = "".concat(typeof positionOffset.x === "string" ? positionOffset.x : positionOffset.x + unitSuffix);
    const defaultY = "".concat(typeof positionOffset.y === "string" ? positionOffset.y : positionOffset.y + unitSuffix);
    translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
  }
  return translation;
}
function getTouch(e2, identifier2) {
  return e2.targetTouches && (0, _shims$2.findInArray)(e2.targetTouches, (t) => identifier2 === t.identifier) || e2.changedTouches && (0, _shims$2.findInArray)(e2.changedTouches, (t) => identifier2 === t.identifier);
}
function getTouchIdentifier(e2) {
  if (e2.targetTouches && e2.targetTouches[0]) return e2.targetTouches[0].identifier;
  if (e2.changedTouches && e2.changedTouches[0]) return e2.changedTouches[0].identifier;
}
function addUserSelectStyles(doc) {
  if (!doc) return;
  let styleEl = doc.getElementById("react-draggable-style-el");
  if (!styleEl) {
    styleEl = doc.createElement("style");
    styleEl.type = "text/css";
    styleEl.id = "react-draggable-style-el";
    styleEl.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n";
    styleEl.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n";
    doc.getElementsByTagName("head")[0].appendChild(styleEl);
  }
  if (doc.body) addClassName(doc.body, "react-draggable-transparent-selection");
}
function removeUserSelectStyles(doc) {
  if (!doc) return;
  try {
    if (doc.body) removeClassName(doc.body, "react-draggable-transparent-selection");
    if (doc.selection) {
      doc.selection.empty();
    } else {
      const selection = (doc.defaultView || window).getSelection();
      if (selection && selection.type !== "Caret") {
        selection.removeAllRanges();
      }
    }
  } catch (e2) {
  }
}
function addClassName(el, className) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) {
      el.className += " ".concat(className);
    }
  }
}
function removeClassName(el, className) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), "g"), "");
  }
}
var positionFns = {};
Object.defineProperty(positionFns, "__esModule", {
  value: true
});
positionFns.canDragX = canDragX;
positionFns.canDragY = canDragY;
positionFns.createCoreData = createCoreData;
positionFns.createDraggableData = createDraggableData;
positionFns.getBoundPosition = getBoundPosition;
positionFns.getControlPosition = getControlPosition;
positionFns.snapToGrid = snapToGrid;
var _shims$1 = shims;
var _domFns$1 = domFns;
function getBoundPosition(draggable, x2, y2) {
  if (!draggable.props.bounds) return [x2, y2];
  let {
    bounds
  } = draggable.props;
  bounds = typeof bounds === "string" ? bounds : cloneBounds(bounds);
  const node2 = findDOMNode(draggable);
  if (typeof bounds === "string") {
    const {
      ownerDocument
    } = node2;
    const ownerWindow = ownerDocument.defaultView;
    let boundNode;
    if (bounds === "parent") {
      boundNode = node2.parentNode;
    } else {
      boundNode = ownerDocument.querySelector(bounds);
    }
    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
    }
    const boundNodeEl = boundNode;
    const nodeStyle = ownerWindow.getComputedStyle(node2);
    const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
    bounds = {
      left: -node2.offsetLeft + (0, _shims$1.int)(boundNodeStyle.paddingLeft) + (0, _shims$1.int)(nodeStyle.marginLeft),
      top: -node2.offsetTop + (0, _shims$1.int)(boundNodeStyle.paddingTop) + (0, _shims$1.int)(nodeStyle.marginTop),
      right: (0, _domFns$1.innerWidth)(boundNodeEl) - (0, _domFns$1.outerWidth)(node2) - node2.offsetLeft + (0, _shims$1.int)(boundNodeStyle.paddingRight) - (0, _shims$1.int)(nodeStyle.marginRight),
      bottom: (0, _domFns$1.innerHeight)(boundNodeEl) - (0, _domFns$1.outerHeight)(node2) - node2.offsetTop + (0, _shims$1.int)(boundNodeStyle.paddingBottom) - (0, _shims$1.int)(nodeStyle.marginBottom)
    };
  }
  if ((0, _shims$1.isNum)(bounds.right)) x2 = Math.min(x2, bounds.right);
  if ((0, _shims$1.isNum)(bounds.bottom)) y2 = Math.min(y2, bounds.bottom);
  if ((0, _shims$1.isNum)(bounds.left)) x2 = Math.max(x2, bounds.left);
  if ((0, _shims$1.isNum)(bounds.top)) y2 = Math.max(y2, bounds.top);
  return [x2, y2];
}
function snapToGrid(grid2, pendingX, pendingY) {
  const x2 = Math.round(pendingX / grid2[0]) * grid2[0];
  const y2 = Math.round(pendingY / grid2[1]) * grid2[1];
  return [x2, y2];
}
function canDragX(draggable) {
  return draggable.props.axis === "both" || draggable.props.axis === "x";
}
function canDragY(draggable) {
  return draggable.props.axis === "both" || draggable.props.axis === "y";
}
function getControlPosition(e2, touchIdentifier, draggableCore) {
  const touchObj = typeof touchIdentifier === "number" ? (0, _domFns$1.getTouch)(e2, touchIdentifier) : null;
  if (typeof touchIdentifier === "number" && !touchObj) return null;
  const node2 = findDOMNode(draggableCore);
  const offsetParent = draggableCore.props.offsetParent || node2.offsetParent || node2.ownerDocument.body;
  return (0, _domFns$1.offsetXYFromParent)(touchObj || e2, offsetParent, draggableCore.props.scale);
}
function createCoreData(draggable, x2, y2) {
  const isStart = !(0, _shims$1.isNum)(draggable.lastX);
  const node2 = findDOMNode(draggable);
  if (isStart) {
    return {
      node: node2,
      deltaX: 0,
      deltaY: 0,
      lastX: x2,
      lastY: y2,
      x: x2,
      y: y2
    };
  } else {
    return {
      node: node2,
      deltaX: x2 - draggable.lastX,
      deltaY: y2 - draggable.lastY,
      lastX: draggable.lastX,
      lastY: draggable.lastY,
      x: x2,
      y: y2
    };
  }
}
function createDraggableData(draggable, coreData) {
  const scale = draggable.props.scale;
  return {
    node: coreData.node,
    x: draggable.state.x + coreData.deltaX / scale,
    y: draggable.state.y + coreData.deltaY / scale,
    deltaX: coreData.deltaX / scale,
    deltaY: coreData.deltaY / scale,
    lastX: draggable.state.x,
    lastY: draggable.state.y
  };
}
function cloneBounds(bounds) {
  return {
    left: bounds.left,
    top: bounds.top,
    right: bounds.right,
    bottom: bounds.bottom
  };
}
function findDOMNode(draggable) {
  const node2 = draggable.findDOMNode();
  if (!node2) {
    throw new Error("<DraggableCore>: Unmounted during event!");
  }
  return node2;
}
var DraggableCore$2 = {};
var log$1 = {};
Object.defineProperty(log$1, "__esModule", {
  value: true
});
log$1.default = log;
function log() {
}
Object.defineProperty(DraggableCore$2, "__esModule", {
  value: true
});
DraggableCore$2.default = void 0;
var React$5 = _interopRequireWildcard$5(o);
var _propTypes$7 = _interopRequireDefault$8(propTypesExports);
var _reactDom = _interopRequireDefault$8(require$$2$2);
var _domFns = domFns;
var _positionFns = positionFns;
var _shims = shims;
var _log = _interopRequireDefault$8(log$1);
function _interopRequireDefault$8(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _getRequireWildcardCache$5(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
  var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$5 = function(nodeInterop2) {
    return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard$5(obj, nodeInterop) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache$5(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _defineProperty$7(obj, key, value) {
  key = _toPropertyKey$7(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$7(arg) {
  var key = _toPrimitive$7(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$7(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
const eventsFor = {
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend"
  },
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  }
};
let dragEventFor = eventsFor.mouse;
let DraggableCore$1 = class DraggableCore extends React$5.Component {
  constructor() {
    super(...arguments);
    _defineProperty$7(this, "dragging", false);
    _defineProperty$7(this, "lastX", NaN);
    _defineProperty$7(this, "lastY", NaN);
    _defineProperty$7(this, "touchIdentifier", null);
    _defineProperty$7(this, "mounted", false);
    _defineProperty$7(this, "handleDragStart", (e2) => {
      this.props.onMouseDown(e2);
      if (!this.props.allowAnyClick && typeof e2.button === "number" && e2.button !== 0) return false;
      const thisNode = this.findDOMNode();
      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
        throw new Error("<DraggableCore> not mounted on DragStart!");
      }
      const {
        ownerDocument
      } = thisNode;
      if (this.props.disabled || !(e2.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e2.target, this.props.handle, thisNode) || this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e2.target, this.props.cancel, thisNode)) {
        return;
      }
      if (e2.type === "touchstart") e2.preventDefault();
      const touchIdentifier = (0, _domFns.getTouchIdentifier)(e2);
      this.touchIdentifier = touchIdentifier;
      const position2 = (0, _positionFns.getControlPosition)(e2, touchIdentifier, this);
      if (position2 == null) return;
      const {
        x: x2,
        y: y2
      } = position2;
      const coreEvent = (0, _positionFns.createCoreData)(this, x2, y2);
      (0, _log.default)("DraggableCore: handleDragStart: %j", coreEvent);
      (0, _log.default)("calling", this.props.onStart);
      const shouldUpdate = this.props.onStart(e2, coreEvent);
      if (shouldUpdate === false || this.mounted === false) return;
      if (this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument);
      this.dragging = true;
      this.lastX = x2;
      this.lastY = y2;
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, this.handleDrag);
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, this.handleDragStop);
    });
    _defineProperty$7(this, "handleDrag", (e2) => {
      const position2 = (0, _positionFns.getControlPosition)(e2, this.touchIdentifier, this);
      if (position2 == null) return;
      let {
        x: x2,
        y: y2
      } = position2;
      if (Array.isArray(this.props.grid)) {
        let deltaX = x2 - this.lastX, deltaY = y2 - this.lastY;
        [deltaX, deltaY] = (0, _positionFns.snapToGrid)(this.props.grid, deltaX, deltaY);
        if (!deltaX && !deltaY) return;
        x2 = this.lastX + deltaX, y2 = this.lastY + deltaY;
      }
      const coreEvent = (0, _positionFns.createCoreData)(this, x2, y2);
      (0, _log.default)("DraggableCore: handleDrag: %j", coreEvent);
      const shouldUpdate = this.props.onDrag(e2, coreEvent);
      if (shouldUpdate === false || this.mounted === false) {
        try {
          this.handleDragStop(new MouseEvent("mouseup"));
        } catch (err) {
          const event = document.createEvent("MouseEvents");
          event.initMouseEvent("mouseup", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          this.handleDragStop(event);
        }
        return;
      }
      this.lastX = x2;
      this.lastY = y2;
    });
    _defineProperty$7(this, "handleDragStop", (e2) => {
      if (!this.dragging) return;
      const position2 = (0, _positionFns.getControlPosition)(e2, this.touchIdentifier, this);
      if (position2 == null) return;
      let {
        x: x2,
        y: y2
      } = position2;
      if (Array.isArray(this.props.grid)) {
        let deltaX = x2 - this.lastX || 0;
        let deltaY = y2 - this.lastY || 0;
        [deltaX, deltaY] = (0, _positionFns.snapToGrid)(this.props.grid, deltaX, deltaY);
        x2 = this.lastX + deltaX, y2 = this.lastY + deltaY;
      }
      const coreEvent = (0, _positionFns.createCoreData)(this, x2, y2);
      const shouldContinue = this.props.onStop(e2, coreEvent);
      if (shouldContinue === false || this.mounted === false) return false;
      const thisNode = this.findDOMNode();
      if (thisNode) {
        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
      }
      (0, _log.default)("DraggableCore: handleDragStop: %j", coreEvent);
      this.dragging = false;
      this.lastX = NaN;
      this.lastY = NaN;
      if (thisNode) {
        (0, _log.default)("DraggableCore: Removing handlers");
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, this.handleDrag);
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, this.handleDragStop);
      }
    });
    _defineProperty$7(this, "onMouseDown", (e2) => {
      dragEventFor = eventsFor.mouse;
      return this.handleDragStart(e2);
    });
    _defineProperty$7(this, "onMouseUp", (e2) => {
      dragEventFor = eventsFor.mouse;
      return this.handleDragStop(e2);
    });
    _defineProperty$7(this, "onTouchStart", (e2) => {
      dragEventFor = eventsFor.touch;
      return this.handleDragStart(e2);
    });
    _defineProperty$7(this, "onTouchEnd", (e2) => {
      dragEventFor = eventsFor.touch;
      return this.handleDragStop(e2);
    });
  }
  componentDidMount() {
    this.mounted = true;
    const thisNode = this.findDOMNode();
    if (thisNode) {
      (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
        passive: false
      });
    }
  }
  componentWillUnmount() {
    this.mounted = false;
    const thisNode = this.findDOMNode();
    if (thisNode) {
      const {
        ownerDocument
      } = thisNode;
      (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
      (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
      (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
      (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
      (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
        passive: false
      });
      if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
    }
  }
  // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
  // the underlying DOM node ourselves. See the README for more information.
  findDOMNode() {
    var _this$props, _this$props2;
    return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.nodeRef) === null || _this$props2 === void 0 ? void 0 : _this$props2.current : _reactDom.default.findDOMNode(this);
  }
  render() {
    return /* @__PURE__ */ React$5.cloneElement(React$5.Children.only(this.props.children), {
      // Note: mouseMove handler is attached to document so it will still function
      // when the user drags quickly and leaves the bounds of the element.
      onMouseDown: this.onMouseDown,
      onMouseUp: this.onMouseUp,
      // onTouchStart is added on `componentDidMount` so they can be added with
      // {passive: false}, which allows it to cancel. See
      // https://developers.google.com/web/updates/2017/01/scrolling-intervention
      onTouchEnd: this.onTouchEnd
    });
  }
};
DraggableCore$2.default = DraggableCore$1;
_defineProperty$7(DraggableCore$1, "displayName", "DraggableCore");
_defineProperty$7(DraggableCore$1, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: _propTypes$7.default.bool,
  children: _propTypes$7.default.node.isRequired,
  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: _propTypes$7.default.bool,
  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: _propTypes$7.default.bool,
  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function(props, propName) {
    if (props[propName] && props[propName].nodeType !== 1) {
      throw new Error("Draggable's offsetParent must be a DOM Node.");
    }
  },
  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: _propTypes$7.default.arrayOf(_propTypes$7.default.number),
  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: _propTypes$7.default.string,
  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: _propTypes$7.default.string,
  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: _propTypes$7.default.object,
  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: _propTypes$7.default.func,
  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: _propTypes$7.default.func,
  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: _propTypes$7.default.func,
  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: _propTypes$7.default.func,
  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: _propTypes$7.default.number,
  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
});
_defineProperty$7(DraggableCore$1, "defaultProps", {
  allowAnyClick: false,
  // by default only accept left click
  disabled: false,
  enableUserSelectHack: true,
  onStart: function() {
  },
  onDrag: function() {
  },
  onStop: function() {
  },
  onMouseDown: function() {
  },
  scale: 1
});
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "DraggableCore", {
    enumerable: true,
    get: function() {
      return _DraggableCore.default;
    }
  });
  exports.default = void 0;
  var React2 = _interopRequireWildcard2(o);
  var _propTypes3 = _interopRequireDefault2(propTypesExports);
  var _reactDom2 = _interopRequireDefault2(require$$2$2);
  var _clsx2 = _interopRequireDefault2(require$$3);
  var _domFns2 = domFns;
  var _positionFns2 = positionFns;
  var _shims2 = shims;
  var _DraggableCore = _interopRequireDefault2(DraggableCore$2);
  var _log2 = _interopRequireDefault2(log$1);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _getRequireWildcardCache2(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
    var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
    return (_getRequireWildcardCache2 = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard2(obj, nodeInterop) {
    if (obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return { default: obj };
    }
    var cache = _getRequireWildcardCache2(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _extends2() {
    _extends2 = Object.assign ? Object.assign.bind() : function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends2.apply(this, arguments);
  }
  function _defineProperty2(obj, key, value) {
    key = _toPropertyKey2(key);
    if (key in obj) {
      Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey2(arg) {
    var key = _toPrimitive2(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }
  function _toPrimitive2(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  class Draggable2 extends React2.Component {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(_ref, _ref2) {
      let {
        position: position2
      } = _ref;
      let {
        prevPropsPosition
      } = _ref2;
      if (position2 && (!prevPropsPosition || position2.x !== prevPropsPosition.x || position2.y !== prevPropsPosition.y)) {
        (0, _log2.default)("Draggable: getDerivedStateFromProps %j", {
          position: position2,
          prevPropsPosition
        });
        return {
          x: position2.x,
          y: position2.y,
          prevPropsPosition: {
            ...position2
          }
        };
      }
      return null;
    }
    constructor(props) {
      super(props);
      _defineProperty2(this, "onDragStart", (e2, coreData) => {
        (0, _log2.default)("Draggable: onDragStart: %j", coreData);
        const shouldStart = this.props.onStart(e2, (0, _positionFns2.createDraggableData)(this, coreData));
        if (shouldStart === false) return false;
        this.setState({
          dragging: true,
          dragged: true
        });
      });
      _defineProperty2(this, "onDrag", (e2, coreData) => {
        if (!this.state.dragging) return false;
        (0, _log2.default)("Draggable: onDrag: %j", coreData);
        const uiData = (0, _positionFns2.createDraggableData)(this, coreData);
        const newState = {
          x: uiData.x,
          y: uiData.y,
          slackX: 0,
          slackY: 0
        };
        if (this.props.bounds) {
          const {
            x: x2,
            y: y2
          } = newState;
          newState.x += this.state.slackX;
          newState.y += this.state.slackY;
          const [newStateX, newStateY] = (0, _positionFns2.getBoundPosition)(this, newState.x, newState.y);
          newState.x = newStateX;
          newState.y = newStateY;
          newState.slackX = this.state.slackX + (x2 - newState.x);
          newState.slackY = this.state.slackY + (y2 - newState.y);
          uiData.x = newState.x;
          uiData.y = newState.y;
          uiData.deltaX = newState.x - this.state.x;
          uiData.deltaY = newState.y - this.state.y;
        }
        const shouldUpdate = this.props.onDrag(e2, uiData);
        if (shouldUpdate === false) return false;
        this.setState(newState);
      });
      _defineProperty2(this, "onDragStop", (e2, coreData) => {
        if (!this.state.dragging) return false;
        const shouldContinue = this.props.onStop(e2, (0, _positionFns2.createDraggableData)(this, coreData));
        if (shouldContinue === false) return false;
        (0, _log2.default)("Draggable: onDragStop: %j", coreData);
        const newState = {
          dragging: false,
          slackX: 0,
          slackY: 0
        };
        const controlled = Boolean(this.props.position);
        if (controlled) {
          const {
            x: x2,
            y: y2
          } = this.props.position;
          newState.x = x2;
          newState.y = y2;
        }
        this.setState(newState);
      });
      this.state = {
        // Whether or not we are currently dragging.
        dragging: false,
        // Whether or not we have been dragged before.
        dragged: false,
        // Current transform x and y.
        x: props.position ? props.position.x : props.defaultPosition.x,
        y: props.position ? props.position.y : props.defaultPosition.y,
        prevPropsPosition: {
          ...props.position
        },
        // Used for compensating for out-of-bounds drags
        slackX: 0,
        slackY: 0,
        // Can only determine if SVG after mounting
        isElementSVG: false
      };
      if (props.position && !(props.onDrag || props.onStop)) {
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
      }
    }
    componentDidMount() {
      if (typeof window.SVGElement !== "undefined" && this.findDOMNode() instanceof window.SVGElement) {
        this.setState({
          isElementSVG: true
        });
      }
    }
    componentWillUnmount() {
      this.setState({
        dragging: false
      });
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() {
      var _this$props$nodeRef$c, _this$props;
      return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 || (_this$props = _this$props.nodeRef) === null || _this$props === void 0 ? void 0 : _this$props.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom2.default.findDOMNode(this);
    }
    render() {
      const {
        axis,
        bounds,
        children,
        defaultPosition,
        defaultClassName,
        defaultClassNameDragging,
        defaultClassNameDragged,
        position: position2,
        positionOffset,
        scale,
        ...draggableCoreProps
      } = this.props;
      let style = {};
      let svgTransform = null;
      const controlled = Boolean(position2);
      const draggable = !controlled || this.state.dragging;
      const validPosition = position2 || defaultPosition;
      const transformOpts = {
        // Set left if horizontal drag is enabled
        x: (0, _positionFns2.canDragX)(this) && draggable ? this.state.x : validPosition.x,
        // Set top if vertical drag is enabled
        y: (0, _positionFns2.canDragY)(this) && draggable ? this.state.y : validPosition.y
      };
      if (this.state.isElementSVG) {
        svgTransform = (0, _domFns2.createSVGTransform)(transformOpts, positionOffset);
      } else {
        style = (0, _domFns2.createCSSTransform)(transformOpts, positionOffset);
      }
      const className = (0, _clsx2.default)(children.props.className || "", defaultClassName, {
        [defaultClassNameDragging]: this.state.dragging,
        [defaultClassNameDragged]: this.state.dragged
      });
      return /* @__PURE__ */ React2.createElement(_DraggableCore.default, _extends2({}, draggableCoreProps, {
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop
      }), /* @__PURE__ */ React2.cloneElement(React2.Children.only(children), {
        className,
        style: {
          ...children.props.style,
          ...style
        },
        transform: svgTransform
      }));
    }
  }
  exports.default = Draggable2;
  _defineProperty2(Draggable2, "displayName", "Draggable");
  _defineProperty2(Draggable2, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ..._DraggableCore.default.propTypes,
    /**
     * `axis` determines which axis the draggable can move.
     *
     *  Note that all callbacks will still return data as normal. This only
     *  controls flushing to the DOM.
     *
     * 'both' allows movement horizontally and vertically.
     * 'x' limits movement to horizontal axis.
     * 'y' limits movement to vertical axis.
     * 'none' limits all movement.
     *
     * Defaults to 'both'.
     */
    axis: _propTypes3.default.oneOf(["both", "x", "y", "none"]),
    /**
     * `bounds` determines the range of movement available to the element.
     * Available values are:
     *
     * 'parent' restricts movement within the Draggable's parent node.
     *
     * Alternatively, pass an object with the following properties, all of which are optional:
     *
     * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
     *
     * All values are in px.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *         return (
     *            <Draggable bounds={{right: 300, bottom: 300}}>
     *              <div>Content</div>
     *           </Draggable>
     *         );
     *       }
     *   });
     * ```
     */
    bounds: _propTypes3.default.oneOfType([_propTypes3.default.shape({
      left: _propTypes3.default.number,
      right: _propTypes3.default.number,
      top: _propTypes3.default.number,
      bottom: _propTypes3.default.number
    }), _propTypes3.default.string, _propTypes3.default.oneOf([false])]),
    defaultClassName: _propTypes3.default.string,
    defaultClassNameDragging: _propTypes3.default.string,
    defaultClassNameDragged: _propTypes3.default.string,
    /**
     * `defaultPosition` specifies the x and y that the dragged item should start at
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable defaultPosition={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    defaultPosition: _propTypes3.default.shape({
      x: _propTypes3.default.number,
      y: _propTypes3.default.number
    }),
    positionOffset: _propTypes3.default.shape({
      x: _propTypes3.default.oneOfType([_propTypes3.default.number, _propTypes3.default.string]),
      y: _propTypes3.default.oneOfType([_propTypes3.default.number, _propTypes3.default.string])
    }),
    /**
     * `position`, if present, defines the current position of the element.
     *
     *  This is similar to how form elements in React work - if no `position` is supplied, the component
     *  is uncontrolled.
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable position={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    position: _propTypes3.default.shape({
      x: _propTypes3.default.number,
      y: _propTypes3.default.number
    }),
    /**
     * These properties should be defined on the child, not here.
     */
    className: _shims2.dontSetMe,
    style: _shims2.dontSetMe,
    transform: _shims2.dontSetMe
  });
  _defineProperty2(Draggable2, "defaultProps", {
    ..._DraggableCore.default.defaultProps,
    axis: "both",
    bounds: false,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
      x: 0,
      y: 0
    },
    scale: 1
  });
})(Draggable$1);
const {
  default: Draggable,
  DraggableCore: DraggableCore2
} = Draggable$1;
cjs.exports = Draggable;
cjs.exports.default = Draggable;
cjs.exports.DraggableCore = DraggableCore2;
var cjsExports = cjs.exports;
var reactResizable = { exports: {} };
var Resizable$1 = {};
var utils = {};
utils.__esModule = true;
utils.cloneElement = cloneElement;
var _react$2 = _interopRequireDefault$7(o);
function _interopRequireDefault$7(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$2(Object(source), true).forEach(function(key) {
      _defineProperty$6(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$6(obj, key, value) {
  key = _toPropertyKey$6(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$6(arg) {
  var key = _toPrimitive$6(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$6(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function cloneElement(element, props) {
  if (props.style && element.props.style) {
    props.style = _objectSpread$2(_objectSpread$2({}, element.props.style), props.style);
  }
  if (props.className && element.props.className) {
    props.className = element.props.className + " " + props.className;
  }
  return /* @__PURE__ */ _react$2.default.cloneElement(element, props);
}
var propTypes = {};
propTypes.__esModule = true;
propTypes.resizableProps = void 0;
var _propTypes$6 = _interopRequireDefault$6(propTypesExports);
function _interopRequireDefault$6(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var resizableProps = {
  /*
  * Restricts resizing to a particular axis (default: 'both')
  * 'both' - allows resizing by width or height
  * 'x' - only allows the width to be changed
  * 'y' - only allows the height to be changed
  * 'none' - disables resizing altogether
  * */
  axis: _propTypes$6.default.oneOf(["both", "x", "y", "none"]),
  className: _propTypes$6.default.string,
  /*
  * Require that one and only one child be present.
  * */
  children: _propTypes$6.default.element.isRequired,
  /*
  * These will be passed wholesale to react-draggable's DraggableCore
  * */
  draggableOpts: _propTypes$6.default.shape({
    allowAnyClick: _propTypes$6.default.bool,
    cancel: _propTypes$6.default.string,
    children: _propTypes$6.default.node,
    disabled: _propTypes$6.default.bool,
    enableUserSelectHack: _propTypes$6.default.bool,
    offsetParent: _propTypes$6.default.node,
    grid: _propTypes$6.default.arrayOf(_propTypes$6.default.number),
    handle: _propTypes$6.default.string,
    nodeRef: _propTypes$6.default.object,
    onStart: _propTypes$6.default.func,
    onDrag: _propTypes$6.default.func,
    onStop: _propTypes$6.default.func,
    onMouseDown: _propTypes$6.default.func,
    scale: _propTypes$6.default.number
  }),
  /*
  * Initial height
  * */
  height: function height() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var props = args[0];
    if (props.axis === "both" || props.axis === "y") {
      var _PropTypes$number;
      return (_PropTypes$number = _propTypes$6.default.number).isRequired.apply(_PropTypes$number, args);
    }
    return _propTypes$6.default.number.apply(_propTypes$6.default, args);
  },
  /*
  * Customize cursor resize handle
  * */
  handle: _propTypes$6.default.oneOfType([_propTypes$6.default.node, _propTypes$6.default.func]),
  /*
  * If you change this, be sure to update your css
  * */
  handleSize: _propTypes$6.default.arrayOf(_propTypes$6.default.number),
  lockAspectRatio: _propTypes$6.default.bool,
  /*
  * Max X & Y measure
  * */
  maxConstraints: _propTypes$6.default.arrayOf(_propTypes$6.default.number),
  /*
  * Min X & Y measure
  * */
  minConstraints: _propTypes$6.default.arrayOf(_propTypes$6.default.number),
  /*
  * Called on stop resize event
  * */
  onResizeStop: _propTypes$6.default.func,
  /*
  * Called on start resize event
  * */
  onResizeStart: _propTypes$6.default.func,
  /*
  * Called on resize event
  * */
  onResize: _propTypes$6.default.func,
  /*
  * Defines which resize handles should be rendered (default: 'se')
  * 's' - South handle (bottom-center)
  * 'w' - West handle (left-center)
  * 'e' - East handle (right-center)
  * 'n' - North handle (top-center)
  * 'sw' - Southwest handle (bottom-left)
  * 'nw' - Northwest handle (top-left)
  * 'se' - Southeast handle (bottom-right)
  * 'ne' - Northeast handle (top-center)
  * */
  resizeHandles: _propTypes$6.default.arrayOf(_propTypes$6.default.oneOf(["s", "w", "e", "n", "sw", "nw", "se", "ne"])),
  /*
  * If `transform: scale(n)` is set on the parent, this should be set to `n`.
  * */
  transformScale: _propTypes$6.default.number,
  /*
   * Initial width
   */
  width: function width() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    var props = args[0];
    if (props.axis === "both" || props.axis === "x") {
      var _PropTypes$number2;
      return (_PropTypes$number2 = _propTypes$6.default.number).isRequired.apply(_PropTypes$number2, args);
    }
    return _propTypes$6.default.number.apply(_propTypes$6.default, args);
  }
};
propTypes.resizableProps = resizableProps;
Resizable$1.__esModule = true;
Resizable$1.default = void 0;
var React$4 = _interopRequireWildcard$4(o);
var _reactDraggable$1 = cjsExports;
var _utils$4 = utils;
var _propTypes$5 = propTypes;
var _excluded$1 = ["children", "className", "draggableOpts", "width", "height", "handle", "handleSize", "lockAspectRatio", "axis", "minConstraints", "maxConstraints", "onResize", "onResizeStop", "onResizeStart", "resizeHandles", "transformScale"];
function _getRequireWildcardCache$4(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
  var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$4 = function _getRequireWildcardCache2(nodeInterop2) {
    return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard$4(obj, nodeInterop) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache$4(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), true).forEach(function(key) {
      _defineProperty$5(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$5(obj, key, value) {
  key = _toPropertyKey$5(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$5(arg) {
  var key = _toPrimitive$5(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$5(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$1(subClass, superClass);
}
function _setPrototypeOf$1(o2, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p2) {
    o3.__proto__ = p2;
    return o3;
  };
  return _setPrototypeOf$1(o2, p);
}
var Resizable = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose$1(Resizable2, _React$Component);
  function Resizable2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.handleRefs = {};
    _this.lastHandleRect = null;
    _this.slack = null;
    return _this;
  }
  var _proto = Resizable2.prototype;
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.resetData();
  };
  _proto.resetData = function resetData() {
    this.lastHandleRect = this.slack = null;
  };
  _proto.runConstraints = function runConstraints(width2, height2) {
    var _this$props = this.props, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio;
    if (!minConstraints && !maxConstraints && !lockAspectRatio) return [width2, height2];
    if (lockAspectRatio) {
      var ratio = this.props.width / this.props.height;
      var deltaW = width2 - this.props.width;
      var deltaH = height2 - this.props.height;
      if (Math.abs(deltaW) > Math.abs(deltaH * ratio)) {
        height2 = width2 / ratio;
      } else {
        width2 = height2 * ratio;
      }
    }
    var oldW = width2, oldH = height2;
    var _ref = this.slack || [0, 0], slackW = _ref[0], slackH = _ref[1];
    width2 += slackW;
    height2 += slackH;
    if (minConstraints) {
      width2 = Math.max(minConstraints[0], width2);
      height2 = Math.max(minConstraints[1], height2);
    }
    if (maxConstraints) {
      width2 = Math.min(maxConstraints[0], width2);
      height2 = Math.min(maxConstraints[1], height2);
    }
    this.slack = [slackW + (oldW - width2), slackH + (oldH - height2)];
    return [width2, height2];
  };
  _proto.resizeHandler = function resizeHandler(handlerName, axis) {
    var _this2 = this;
    return function(e2, _ref2) {
      var node2 = _ref2.node, deltaX = _ref2.deltaX, deltaY = _ref2.deltaY;
      if (handlerName === "onResizeStart") _this2.resetData();
      var canDragX2 = (_this2.props.axis === "both" || _this2.props.axis === "x") && axis !== "n" && axis !== "s";
      var canDragY2 = (_this2.props.axis === "both" || _this2.props.axis === "y") && axis !== "e" && axis !== "w";
      if (!canDragX2 && !canDragY2) return;
      var axisV = axis[0];
      var axisH = axis[axis.length - 1];
      var handleRect = node2.getBoundingClientRect();
      if (_this2.lastHandleRect != null) {
        if (axisH === "w") {
          var deltaLeftSinceLast = handleRect.left - _this2.lastHandleRect.left;
          deltaX += deltaLeftSinceLast;
        }
        if (axisV === "n") {
          var deltaTopSinceLast = handleRect.top - _this2.lastHandleRect.top;
          deltaY += deltaTopSinceLast;
        }
      }
      _this2.lastHandleRect = handleRect;
      if (axisH === "w") deltaX = -deltaX;
      if (axisV === "n") deltaY = -deltaY;
      var width2 = _this2.props.width + (canDragX2 ? deltaX / _this2.props.transformScale : 0);
      var height2 = _this2.props.height + (canDragY2 ? deltaY / _this2.props.transformScale : 0);
      var _this2$runConstraints = _this2.runConstraints(width2, height2);
      width2 = _this2$runConstraints[0];
      height2 = _this2$runConstraints[1];
      var dimensionsChanged = width2 !== _this2.props.width || height2 !== _this2.props.height;
      var cb = typeof _this2.props[handlerName] === "function" ? _this2.props[handlerName] : null;
      var shouldSkipCb = handlerName === "onResize" && !dimensionsChanged;
      if (cb && !shouldSkipCb) {
        e2.persist == null ? void 0 : e2.persist();
        cb(e2, {
          node: node2,
          size: {
            width: width2,
            height: height2
          },
          handle: axis
        });
      }
      if (handlerName === "onResizeStop") _this2.resetData();
    };
  };
  _proto.renderResizeHandle = function renderResizeHandle(handleAxis, ref) {
    var handle = this.props.handle;
    if (!handle) {
      return /* @__PURE__ */ React$4.createElement("span", {
        className: "react-resizable-handle react-resizable-handle-" + handleAxis,
        ref
      });
    }
    if (typeof handle === "function") {
      return handle(handleAxis, ref);
    }
    var isDOMElement = typeof handle.type === "string";
    var props = _objectSpread$1({
      ref
    }, isDOMElement ? {} : {
      handleAxis
    });
    return /* @__PURE__ */ React$4.cloneElement(handle, props);
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props2 = this.props, children = _this$props2.children, className = _this$props2.className, draggableOpts = _this$props2.draggableOpts;
    _this$props2.width;
    _this$props2.height;
    _this$props2.handle;
    _this$props2.handleSize;
    _this$props2.lockAspectRatio;
    _this$props2.axis;
    _this$props2.minConstraints;
    _this$props2.maxConstraints;
    _this$props2.onResize;
    _this$props2.onResizeStop;
    _this$props2.onResizeStart;
    var resizeHandles = _this$props2.resizeHandles;
    _this$props2.transformScale;
    var p = _objectWithoutPropertiesLoose$1(_this$props2, _excluded$1);
    return (0, _utils$4.cloneElement)(children, _objectSpread$1(_objectSpread$1({}, p), {}, {
      className: (className ? className + " " : "") + "react-resizable",
      children: [].concat(children.props.children, resizeHandles.map(function(handleAxis) {
        var _this3$handleRefs$han;
        var ref = (_this3$handleRefs$han = _this3.handleRefs[handleAxis]) != null ? _this3$handleRefs$han : _this3.handleRefs[handleAxis] = /* @__PURE__ */ React$4.createRef();
        return /* @__PURE__ */ React$4.createElement(_reactDraggable$1.DraggableCore, _extends$3({}, draggableOpts, {
          nodeRef: ref,
          key: "resizableHandle-" + handleAxis,
          onStop: _this3.resizeHandler("onResizeStop", handleAxis),
          onStart: _this3.resizeHandler("onResizeStart", handleAxis),
          onDrag: _this3.resizeHandler("onResize", handleAxis)
        }), _this3.renderResizeHandle(handleAxis, ref));
      }))
    }));
  };
  return Resizable2;
}(React$4.Component);
Resizable$1.default = Resizable;
Resizable.propTypes = _propTypes$5.resizableProps;
Resizable.defaultProps = {
  axis: "both",
  handleSize: [20, 20],
  lockAspectRatio: false,
  minConstraints: [20, 20],
  maxConstraints: [Infinity, Infinity],
  resizeHandles: ["se"],
  transformScale: 1
};
var ResizableBox$1 = {};
ResizableBox$1.__esModule = true;
ResizableBox$1.default = void 0;
var React$3 = _interopRequireWildcard$3(o);
var _propTypes$4 = _interopRequireDefault$5(propTypesExports);
var _Resizable = _interopRequireDefault$5(Resizable$1);
var _propTypes2 = propTypes;
var _excluded = ["handle", "handleSize", "onResize", "onResizeStart", "onResizeStop", "draggableOpts", "minConstraints", "maxConstraints", "lockAspectRatio", "axis", "width", "height", "resizeHandles", "style", "transformScale"];
function _interopRequireDefault$5(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _getRequireWildcardCache$3(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
  var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$3 = function _getRequireWildcardCache2(nodeInterop2) {
    return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard$3(obj, nodeInterop) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache$3(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty$4(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$4(obj, key, value) {
  key = _toPropertyKey$4(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$4(arg) {
  var key = _toPrimitive$4(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$4(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o2, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p2) {
    o3.__proto__ = p2;
    return o3;
  };
  return _setPrototypeOf(o2, p);
}
var ResizableBox = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(ResizableBox2, _React$Component);
  function ResizableBox2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      width: _this.props.width,
      height: _this.props.height,
      propsWidth: _this.props.width,
      propsHeight: _this.props.height
    };
    _this.onResize = function(e2, data) {
      var size = data.size;
      if (_this.props.onResize) {
        e2.persist == null ? void 0 : e2.persist();
        _this.setState(size, function() {
          return _this.props.onResize && _this.props.onResize(e2, data);
        });
      } else {
        _this.setState(size);
      }
    };
    return _this;
  }
  ResizableBox2.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (state.propsWidth !== props.width || state.propsHeight !== props.height) {
      return {
        width: props.width,
        height: props.height,
        propsWidth: props.width,
        propsHeight: props.height
      };
    }
    return null;
  };
  var _proto = ResizableBox2.prototype;
  _proto.render = function render() {
    var _this$props = this.props, handle = _this$props.handle, handleSize = _this$props.handleSize;
    _this$props.onResize;
    var onResizeStart = _this$props.onResizeStart, onResizeStop = _this$props.onResizeStop, draggableOpts = _this$props.draggableOpts, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio, axis = _this$props.axis;
    _this$props.width;
    _this$props.height;
    var resizeHandles = _this$props.resizeHandles, style = _this$props.style, transformScale = _this$props.transformScale, props = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /* @__PURE__ */ React$3.createElement(_Resizable.default, {
      axis,
      draggableOpts,
      handle,
      handleSize,
      height: this.state.height,
      lockAspectRatio,
      maxConstraints,
      minConstraints,
      onResizeStart,
      onResize: this.onResize,
      onResizeStop,
      resizeHandles,
      transformScale,
      width: this.state.width
    }, /* @__PURE__ */ React$3.createElement("div", _extends$2({}, props, {
      style: _objectSpread(_objectSpread({}, style), {}, {
        width: this.state.width + "px",
        height: this.state.height + "px"
      })
    })));
  };
  return ResizableBox2;
}(React$3.Component);
ResizableBox$1.default = ResizableBox;
ResizableBox.propTypes = _objectSpread(_objectSpread({}, _propTypes2.resizableProps), {}, {
  children: _propTypes$4.default.element
});
reactResizable.exports = function() {
  throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
};
reactResizable.exports.Resizable = Resizable$1.default;
reactResizable.exports.ResizableBox = ResizableBox$1.default;
var reactResizableExports = reactResizable.exports;
var ReactGridLayoutPropTypes = {};
Object.defineProperty(ReactGridLayoutPropTypes, "__esModule", {
  value: true
});
ReactGridLayoutPropTypes.resizeHandleType = ReactGridLayoutPropTypes.resizeHandleAxesType = ReactGridLayoutPropTypes.default = void 0;
var _propTypes$3 = _interopRequireDefault$4(propTypesExports);
var _react$1 = _interopRequireDefault$4(o);
function _interopRequireDefault$4(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
const resizeHandleAxesType = ReactGridLayoutPropTypes.resizeHandleAxesType = _propTypes$3.default.arrayOf(_propTypes$3.default.oneOf(["s", "w", "e", "n", "sw", "nw", "se", "ne"]));
const resizeHandleType = ReactGridLayoutPropTypes.resizeHandleType = _propTypes$3.default.oneOfType([_propTypes$3.default.node, _propTypes$3.default.func]);
ReactGridLayoutPropTypes.default = {
  //
  // Basic props
  //
  className: _propTypes$3.default.string,
  style: _propTypes$3.default.object,
  // This can be set explicitly. If it is not set, it will automatically
  // be set to the container width. Note that resizes will *not* cause this to adjust.
  // If you need that behavior, use WidthProvider.
  width: _propTypes$3.default.number,
  // If true, the container height swells and contracts to fit contents
  autoSize: _propTypes$3.default.bool,
  // # of cols.
  cols: _propTypes$3.default.number,
  // A selector that will not be draggable.
  draggableCancel: _propTypes$3.default.string,
  // A selector for the draggable handler
  draggableHandle: _propTypes$3.default.string,
  // Deprecated
  verticalCompact: function(props) {
    if (props.verticalCompact === false && process.env.NODE_ENV !== "production") {
      console.warn(
        // eslint-disable-line no-console
        '`verticalCompact` on <ReactGridLayout> is deprecated and will be removed soon. Use `compactType`: "horizontal" | "vertical" | null.'
      );
    }
  },
  // Choose vertical or hotizontal compaction
  compactType: _propTypes$3.default.oneOf(["vertical", "horizontal"]),
  // layout is an array of object with the format:
  // {x: Number, y: Number, w: Number, h: Number, i: String}
  layout: function(props) {
    var layout = props.layout;
    if (layout === void 0) return;
    utils$1.validateLayout(layout, "layout");
  },
  //
  // Grid Dimensions
  //
  // Margin between items [x, y] in px
  margin: _propTypes$3.default.arrayOf(_propTypes$3.default.number),
  // Padding inside the container [x, y] in px
  containerPadding: _propTypes$3.default.arrayOf(_propTypes$3.default.number),
  // Rows have a static height, but you can change this based on breakpoints if you like
  rowHeight: _propTypes$3.default.number,
  // Default Infinity, but you can specify a max here if you like.
  // Note that this isn't fully fleshed out and won't error if you specify a layout that
  // extends beyond the row capacity. It will, however, not allow users to drag/resize
  // an item past the barrier. They can push items beyond the barrier, though.
  // Intentionally not documented for this reason.
  maxRows: _propTypes$3.default.number,
  //
  // Flags
  //
  isBounded: _propTypes$3.default.bool,
  isDraggable: _propTypes$3.default.bool,
  isResizable: _propTypes$3.default.bool,
  // If true, grid can be placed one over the other.
  allowOverlap: _propTypes$3.default.bool,
  // If true, grid items won't change position when being dragged over.
  preventCollision: _propTypes$3.default.bool,
  // Use CSS transforms instead of top/left
  useCSSTransforms: _propTypes$3.default.bool,
  // parent layout transform scale
  transformScale: _propTypes$3.default.number,
  // If true, an external element can trigger onDrop callback with a specific grid position as a parameter
  isDroppable: _propTypes$3.default.bool,
  // Resize handle options
  resizeHandles: resizeHandleAxesType,
  resizeHandle: resizeHandleType,
  //
  // Callbacks
  //
  // Callback so you can save the layout. Calls after each drag & resize stops.
  onLayoutChange: _propTypes$3.default.func,
  // Calls when drag starts. Callback is of the signature (layout, oldItem, newItem, placeholder, e, ?node).
  // All callbacks below have the same signature. 'start' and 'stop' callbacks omit the 'placeholder'.
  onDragStart: _propTypes$3.default.func,
  // Calls on each drag movement.
  onDrag: _propTypes$3.default.func,
  // Calls when drag is complete.
  onDragStop: _propTypes$3.default.func,
  //Calls when resize starts.
  onResizeStart: _propTypes$3.default.func,
  // Calls when resize movement happens.
  onResize: _propTypes$3.default.func,
  // Calls when resize is complete.
  onResizeStop: _propTypes$3.default.func,
  // Calls when some element is dropped.
  onDrop: _propTypes$3.default.func,
  //
  // Other validations
  //
  droppingItem: _propTypes$3.default.shape({
    i: _propTypes$3.default.string.isRequired,
    w: _propTypes$3.default.number.isRequired,
    h: _propTypes$3.default.number.isRequired
  }),
  // Children must not have duplicate keys.
  children: function(props, propName) {
    const children = props[propName];
    const keys = {};
    _react$1.default.Children.forEach(children, function(child) {
      if ((child == null ? void 0 : child.key) == null) return;
      if (keys[child.key]) {
        throw new Error('Duplicate child key "' + child.key + '" found! This will cause problems in ReactGridLayout.');
      }
      keys[child.key] = true;
    });
  },
  // Optional ref for getting a reference for the wrapping div.
  innerRef: _propTypes$3.default.any
};
Object.defineProperty(GridItem$1, "__esModule", {
  value: true
});
GridItem$1.default = void 0;
var _react = _interopRequireDefault$3(o);
var _propTypes$2 = _interopRequireDefault$3(propTypesExports);
var _reactDraggable = cjsExports;
var _reactResizable = reactResizableExports;
var _utils$3 = utils$1;
var _calculateUtils$1 = calculateUtils;
var _ReactGridLayoutPropTypes$1 = ReactGridLayoutPropTypes;
var _clsx$2 = _interopRequireDefault$3(clsxExports);
function _interopRequireDefault$3(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _defineProperty$3(obj, key, value) {
  key = _toPropertyKey$3(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$3(arg) {
  var key = _toPrimitive$3(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$3(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
class GridItem extends _react.default.Component {
  constructor() {
    super(...arguments);
    _defineProperty$3(this, "state", {
      resizing: null,
      dragging: null,
      className: ""
    });
    _defineProperty$3(this, "elementRef", /* @__PURE__ */ _react.default.createRef());
    _defineProperty$3(this, "onDragStart", (e2, _ref) => {
      let {
        node: node2
      } = _ref;
      const {
        onDragStart,
        transformScale
      } = this.props;
      if (!onDragStart) return;
      const newPosition = {
        top: 0,
        left: 0
      };
      const {
        offsetParent
      } = node2;
      if (!offsetParent) return;
      const parentRect = offsetParent.getBoundingClientRect();
      const clientRect = node2.getBoundingClientRect();
      const cLeft = clientRect.left / transformScale;
      const pLeft = parentRect.left / transformScale;
      const cTop = clientRect.top / transformScale;
      const pTop = parentRect.top / transformScale;
      newPosition.left = cLeft - pLeft + offsetParent.scrollLeft;
      newPosition.top = cTop - pTop + offsetParent.scrollTop;
      this.setState({
        dragging: newPosition
      });
      const {
        x: x2,
        y: y2
      } = (0, _calculateUtils$1.calcXY)(this.getPositionParams(), newPosition.top, newPosition.left, this.props.w, this.props.h);
      return onDragStart.call(this, this.props.i, x2, y2, {
        e: e2,
        node: node2,
        newPosition
      });
    });
    _defineProperty$3(this, "onDrag", (e2, _ref2) => {
      let {
        node: node2,
        deltaX,
        deltaY
      } = _ref2;
      const {
        onDrag
      } = this.props;
      if (!onDrag) return;
      if (!this.state.dragging) {
        throw new Error("onDrag called before onDragStart.");
      }
      let top = this.state.dragging.top + deltaY;
      let left = this.state.dragging.left + deltaX;
      const {
        isBounded,
        i,
        w: w2,
        h,
        containerWidth
      } = this.props;
      const positionParams = this.getPositionParams();
      if (isBounded) {
        const {
          offsetParent
        } = node2;
        if (offsetParent) {
          const {
            margin,
            rowHeight,
            containerPadding
          } = this.props;
          const bottomBoundary = offsetParent.clientHeight - (0, _calculateUtils$1.calcGridItemWHPx)(h, rowHeight, margin[1]);
          top = (0, _calculateUtils$1.clamp)(top - containerPadding[1], 0, bottomBoundary);
          const colWidth = (0, _calculateUtils$1.calcGridColWidth)(positionParams);
          const rightBoundary = containerWidth - (0, _calculateUtils$1.calcGridItemWHPx)(w2, colWidth, margin[0]);
          left = (0, _calculateUtils$1.clamp)(left - containerPadding[0], 0, rightBoundary);
        }
      }
      const newPosition = {
        top,
        left
      };
      this.setState({
        dragging: newPosition
      });
      const {
        x: x2,
        y: y2
      } = (0, _calculateUtils$1.calcXY)(positionParams, top, left, w2, h);
      return onDrag.call(this, i, x2, y2, {
        e: e2,
        node: node2,
        newPosition
      });
    });
    _defineProperty$3(this, "onDragStop", (e2, _ref3) => {
      let {
        node: node2
      } = _ref3;
      const {
        onDragStop
      } = this.props;
      if (!onDragStop) return;
      if (!this.state.dragging) {
        throw new Error("onDragEnd called before onDragStart.");
      }
      const {
        w: w2,
        h,
        i
      } = this.props;
      const {
        left,
        top
      } = this.state.dragging;
      const newPosition = {
        top,
        left
      };
      this.setState({
        dragging: null
      });
      const {
        x: x2,
        y: y2
      } = (0, _calculateUtils$1.calcXY)(this.getPositionParams(), top, left, w2, h);
      return onDragStop.call(this, i, x2, y2, {
        e: e2,
        node: node2,
        newPosition
      });
    });
    _defineProperty$3(this, "onResizeStop", (e2, callbackData, position2) => this.onResizeHandler(e2, callbackData, position2, "onResizeStop"));
    _defineProperty$3(this, "onResizeStart", (e2, callbackData, position2) => this.onResizeHandler(e2, callbackData, position2, "onResizeStart"));
    _defineProperty$3(this, "onResize", (e2, callbackData, position2) => this.onResizeHandler(e2, callbackData, position2, "onResize"));
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.children !== nextProps.children) return true;
    if (this.props.droppingPosition !== nextProps.droppingPosition) return true;
    const oldPosition = (0, _calculateUtils$1.calcGridItemPosition)(this.getPositionParams(this.props), this.props.x, this.props.y, this.props.w, this.props.h, this.state);
    const newPosition = (0, _calculateUtils$1.calcGridItemPosition)(this.getPositionParams(nextProps), nextProps.x, nextProps.y, nextProps.w, nextProps.h, nextState);
    return !(0, _utils$3.fastPositionEqual)(oldPosition, newPosition) || this.props.useCSSTransforms !== nextProps.useCSSTransforms;
  }
  componentDidMount() {
    this.moveDroppingItem({});
  }
  componentDidUpdate(prevProps) {
    this.moveDroppingItem(prevProps);
  }
  // When a droppingPosition is present, this means we should fire a move event, as if we had moved
  // this element by `x, y` pixels.
  moveDroppingItem(prevProps) {
    const {
      droppingPosition
    } = this.props;
    if (!droppingPosition) return;
    const node2 = this.elementRef.current;
    if (!node2) return;
    const prevDroppingPosition = prevProps.droppingPosition || {
      left: 0,
      top: 0
    };
    const {
      dragging
    } = this.state;
    const shouldDrag = dragging && droppingPosition.left !== prevDroppingPosition.left || droppingPosition.top !== prevDroppingPosition.top;
    if (!dragging) {
      this.onDragStart(droppingPosition.e, {
        node: node2,
        deltaX: droppingPosition.left,
        deltaY: droppingPosition.top
      });
    } else if (shouldDrag) {
      const deltaX = droppingPosition.left - dragging.left;
      const deltaY = droppingPosition.top - dragging.top;
      this.onDrag(droppingPosition.e, {
        node: node2,
        deltaX,
        deltaY
      });
    }
  }
  getPositionParams() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props;
    return {
      cols: props.cols,
      containerPadding: props.containerPadding,
      containerWidth: props.containerWidth,
      margin: props.margin,
      maxRows: props.maxRows,
      rowHeight: props.rowHeight
    };
  }
  /**
   * This is where we set the grid item's absolute placement. It gets a little tricky because we want to do it
   * well when server rendering, and the only way to do that properly is to use percentage width/left because
   * we don't know exactly what the browser viewport is.
   * Unfortunately, CSS Transforms, which are great for performance, break in this instance because a percentage
   * left is relative to the item itself, not its container! So we cannot use them on the server rendering pass.
   *
   * @param  {Object} pos Position object with width, height, left, top.
   * @return {Object}     Style object.
   */
  createStyle(pos) {
    const {
      usePercentages,
      containerWidth,
      useCSSTransforms
    } = this.props;
    let style;
    if (useCSSTransforms) {
      style = (0, _utils$3.setTransform)(pos);
    } else {
      style = (0, _utils$3.setTopLeft)(pos);
      if (usePercentages) {
        style.left = (0, _utils$3.perc)(pos.left / containerWidth);
        style.width = (0, _utils$3.perc)(pos.width / containerWidth);
      }
    }
    return style;
  }
  /**
   * Mix a Draggable instance into a child.
   * @param  {Element} child    Child element.
   * @return {Element}          Child wrapped in Draggable.
   */
  mixinDraggable(child, isDraggable) {
    return /* @__PURE__ */ _react.default.createElement(_reactDraggable.DraggableCore, {
      disabled: !isDraggable,
      onStart: this.onDragStart,
      onDrag: this.onDrag,
      onStop: this.onDragStop,
      handle: this.props.handle,
      cancel: ".react-resizable-handle" + (this.props.cancel ? "," + this.props.cancel : ""),
      scale: this.props.transformScale,
      nodeRef: this.elementRef
    }, child);
  }
  /**
   * Utility function to setup callback handler definitions for
   * similarily structured resize events.
   */
  curryResizeHandler(position2, handler) {
    return (e2, data) => (
      /*: Function*/
      handler(e2, data, position2)
    );
  }
  /**
   * Mix a Resizable instance into a child.
   * @param  {Element} child    Child element.
   * @param  {Object} position  Position object (pixel values)
   * @return {Element}          Child wrapped in Resizable.
   */
  mixinResizable(child, position2, isResizable) {
    const {
      cols,
      minW,
      minH,
      maxW,
      maxH,
      transformScale,
      resizeHandles,
      resizeHandle
    } = this.props;
    const positionParams = this.getPositionParams();
    const maxWidth = (0, _calculateUtils$1.calcGridItemPosition)(positionParams, 0, 0, cols, 0).width;
    const mins = (0, _calculateUtils$1.calcGridItemPosition)(positionParams, 0, 0, minW, minH);
    const maxes = (0, _calculateUtils$1.calcGridItemPosition)(positionParams, 0, 0, maxW, maxH);
    const minConstraints = [mins.width, mins.height];
    const maxConstraints = [Math.min(maxes.width, maxWidth), Math.min(maxes.height, Infinity)];
    return /* @__PURE__ */ _react.default.createElement(
      _reactResizable.Resizable,
      {
        draggableOpts: {
          disabled: !isResizable
        },
        className: isResizable ? void 0 : "react-resizable-hide",
        width: position2.width,
        height: position2.height,
        minConstraints,
        maxConstraints,
        onResizeStop: this.curryResizeHandler(position2, this.onResizeStop),
        onResizeStart: this.curryResizeHandler(position2, this.onResizeStart),
        onResize: this.curryResizeHandler(position2, this.onResize),
        transformScale,
        resizeHandles,
        handle: resizeHandle
      },
      child
    );
  }
  /**
   * Wrapper around resize events to provide more useful data.
   */
  onResizeHandler(e2, _ref4, position2, handlerName) {
    let {
      node: node2,
      size,
      handle
    } = _ref4;
    const handler = this.props[handlerName];
    if (!handler) return;
    const {
      x: x2,
      y: y2,
      i,
      maxH,
      minH,
      containerWidth
    } = this.props;
    const {
      minW,
      maxW
    } = this.props;
    let updatedSize = size;
    if (node2) {
      updatedSize = (0, _utils$3.resizeItemInDirection)(handle, position2, size, containerWidth);
      this.setState({
        resizing: handlerName === "onResizeStop" ? null : updatedSize
      });
    }
    let {
      w: w2,
      h
    } = (0, _calculateUtils$1.calcWH)(this.getPositionParams(), updatedSize.width, updatedSize.height, x2, y2, handle);
    w2 = (0, _calculateUtils$1.clamp)(w2, Math.max(minW, 1), maxW);
    h = (0, _calculateUtils$1.clamp)(h, minH, maxH);
    handler.call(this, i, w2, h, {
      e: e2,
      node: node2,
      size: updatedSize,
      handle
    });
  }
  render() {
    const {
      x: x2,
      y: y2,
      w: w2,
      h,
      isDraggable,
      isResizable,
      droppingPosition,
      useCSSTransforms
    } = this.props;
    const pos = (0, _calculateUtils$1.calcGridItemPosition)(this.getPositionParams(), x2, y2, w2, h, this.state);
    const child = _react.default.Children.only(this.props.children);
    let newChild = /* @__PURE__ */ _react.default.cloneElement(child, {
      ref: this.elementRef,
      className: (0, _clsx$2.default)("react-grid-item", child.props.className, this.props.className, {
        static: this.props.static,
        resizing: Boolean(this.state.resizing),
        "react-draggable": isDraggable,
        "react-draggable-dragging": Boolean(this.state.dragging),
        dropping: Boolean(droppingPosition),
        cssTransforms: useCSSTransforms
      }),
      // We can set the width and height on the child, but unfortunately we can't set the position.
      style: {
        ...this.props.style,
        ...child.props.style,
        ...this.createStyle(pos)
      }
    });
    newChild = this.mixinResizable(newChild, pos, isResizable);
    newChild = this.mixinDraggable(newChild, isDraggable);
    return newChild;
  }
}
GridItem$1.default = GridItem;
_defineProperty$3(GridItem, "propTypes", {
  // Children must be only a single element
  children: _propTypes$2.default.element,
  // General grid attributes
  cols: _propTypes$2.default.number.isRequired,
  containerWidth: _propTypes$2.default.number.isRequired,
  rowHeight: _propTypes$2.default.number.isRequired,
  margin: _propTypes$2.default.array.isRequired,
  maxRows: _propTypes$2.default.number.isRequired,
  containerPadding: _propTypes$2.default.array.isRequired,
  // These are all in grid units
  x: _propTypes$2.default.number.isRequired,
  y: _propTypes$2.default.number.isRequired,
  w: _propTypes$2.default.number.isRequired,
  h: _propTypes$2.default.number.isRequired,
  // All optional
  minW: function(props, propName) {
    const value = props[propName];
    if (typeof value !== "number") return new Error("minWidth not Number");
    if (value > props.w || value > props.maxW) return new Error("minWidth larger than item width/maxWidth");
  },
  maxW: function(props, propName) {
    const value = props[propName];
    if (typeof value !== "number") return new Error("maxWidth not Number");
    if (value < props.w || value < props.minW) return new Error("maxWidth smaller than item width/minWidth");
  },
  minH: function(props, propName) {
    const value = props[propName];
    if (typeof value !== "number") return new Error("minHeight not Number");
    if (value > props.h || value > props.maxH) return new Error("minHeight larger than item height/maxHeight");
  },
  maxH: function(props, propName) {
    const value = props[propName];
    if (typeof value !== "number") return new Error("maxHeight not Number");
    if (value < props.h || value < props.minH) return new Error("maxHeight smaller than item height/minHeight");
  },
  // ID is nice to have for callbacks
  i: _propTypes$2.default.string.isRequired,
  // Resize handle options
  resizeHandles: _ReactGridLayoutPropTypes$1.resizeHandleAxesType,
  resizeHandle: _ReactGridLayoutPropTypes$1.resizeHandleType,
  // Functions
  onDragStop: _propTypes$2.default.func,
  onDragStart: _propTypes$2.default.func,
  onDrag: _propTypes$2.default.func,
  onResizeStop: _propTypes$2.default.func,
  onResizeStart: _propTypes$2.default.func,
  onResize: _propTypes$2.default.func,
  // Flags
  isDraggable: _propTypes$2.default.bool.isRequired,
  isResizable: _propTypes$2.default.bool.isRequired,
  isBounded: _propTypes$2.default.bool.isRequired,
  static: _propTypes$2.default.bool,
  // Use CSS transforms instead of top/left
  useCSSTransforms: _propTypes$2.default.bool.isRequired,
  transformScale: _propTypes$2.default.number,
  // Others
  className: _propTypes$2.default.string,
  // Selector for draggable handle
  handle: _propTypes$2.default.string,
  // Selector for draggable cancel (see react-draggable)
  cancel: _propTypes$2.default.string,
  // Current position of a dropping element
  droppingPosition: _propTypes$2.default.shape({
    e: _propTypes$2.default.object.isRequired,
    left: _propTypes$2.default.number.isRequired,
    top: _propTypes$2.default.number.isRequired
  })
});
_defineProperty$3(GridItem, "defaultProps", {
  className: "",
  cancel: "",
  handle: "",
  minH: 1,
  minW: 1,
  maxH: Infinity,
  maxW: Infinity,
  transformScale: 1
});
Object.defineProperty(ReactGridLayout$1, "__esModule", {
  value: true
});
ReactGridLayout$1.default = void 0;
var React$2 = _interopRequireWildcard$2(o);
var _fastEquals$1 = require$$2$1;
var _clsx$1 = _interopRequireDefault$2(clsxExports);
var _utils$2 = utils$1;
var _calculateUtils = calculateUtils;
var _GridItem = _interopRequireDefault$2(GridItem$1);
var _ReactGridLayoutPropTypes = _interopRequireDefault$2(ReactGridLayoutPropTypes);
function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _getRequireWildcardCache$2(e2) {
  if ("function" != typeof WeakMap) return null;
  var r2 = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$2 = function(e3) {
    return e3 ? t : r2;
  })(e2);
}
function _interopRequireWildcard$2(e2, r2) {
  if (e2 && e2.__esModule) return e2;
  if (null === e2 || "object" != typeof e2 && "function" != typeof e2) return { default: e2 };
  var t = _getRequireWildcardCache$2(r2);
  if (t && t.has(e2)) return t.get(e2);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e2) if ("default" !== u && Object.prototype.hasOwnProperty.call(e2, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e2, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e2[u];
  }
  return n.default = e2, t && t.set(e2, n), n;
}
function _defineProperty$2(obj, key, value) {
  key = _toPropertyKey$2(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$2(arg) {
  var key = _toPrimitive$2(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$2(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
const layoutClassName$1 = "react-grid-layout";
let isFirefox = false;
try {
  isFirefox = /firefox/i.test(navigator.userAgent);
} catch (e2) {
}
class ReactGridLayout extends React$2.Component {
  constructor() {
    super(...arguments);
    _defineProperty$2(this, "state", {
      activeDrag: null,
      layout: (0, _utils$2.synchronizeLayoutWithChildren)(
        this.props.layout,
        this.props.children,
        this.props.cols,
        // Legacy support for verticalCompact: false
        (0, _utils$2.compactType)(this.props),
        this.props.allowOverlap
      ),
      mounted: false,
      oldDragItem: null,
      oldLayout: null,
      oldResizeItem: null,
      resizing: false,
      droppingDOMNode: null,
      children: []
    });
    _defineProperty$2(this, "dragEnterCounter", 0);
    _defineProperty$2(this, "onDragStart", (i, x2, y2, _ref) => {
      let {
        e: e2,
        node: node2
      } = _ref;
      const {
        layout
      } = this.state;
      const l = (0, _utils$2.getLayoutItem)(layout, i);
      if (!l) return;
      const placeholder = {
        w: l.w,
        h: l.h,
        x: l.x,
        y: l.y,
        placeholder: true,
        i
      };
      this.setState({
        oldDragItem: (0, _utils$2.cloneLayoutItem)(l),
        oldLayout: layout,
        activeDrag: placeholder
      });
      return this.props.onDragStart(layout, l, l, null, e2, node2);
    });
    _defineProperty$2(this, "onDrag", (i, x2, y2, _ref2) => {
      let {
        e: e2,
        node: node2
      } = _ref2;
      const {
        oldDragItem
      } = this.state;
      let {
        layout
      } = this.state;
      const {
        cols,
        allowOverlap,
        preventCollision,
        disableDragPreview,
        rowHeight,
        margin,
        parentContainer
      } = this.props;
      if (!disableDragPreview) {
        const l = (0, _utils$2.getLayoutItem)(layout, i);
        if (!l) return;
        const placeholder = {
          w: l.w,
          h: l.h,
          x: l.x,
          y: l.y,
          placeholder: true,
          i
        };
        const isUserAction = true;
        layout = (0, _utils$2.moveElement)(layout, l, x2, y2, isUserAction, preventCollision, (0, _utils$2.compactType)(this.props), cols, allowOverlap);
        this.props.onDrag(layout, oldDragItem, l, placeholder, e2, node2);
        this.setState({
          layout: allowOverlap ? layout : (0, _utils$2.compact)(layout, (0, _utils$2.compactType)(this.props), cols),
          activeDrag: placeholder
        });
      }
    });
    _defineProperty$2(this, "onDragStop", (i, x2, y2, _ref3) => {
      let {
        e: e2,
        node: node2
      } = _ref3;
      if (!this.state.activeDrag) return;
      const {
        oldDragItem
      } = this.state;
      let {
        layout
      } = this.state;
      const {
        cols,
        allowOverlap
      } = this.props;
      const layoutItemIndex = layout.findIndex((item) => item.i === i);
      if (layoutItemIndex === -1) return;
      const updatedLayout = [...layout];
      const l = updatedLayout[layoutItemIndex];
      updatedLayout[layoutItemIndex] = {
        ...l,
        x: x2,
        y: y2
      };
      const newLayout = allowOverlap ? updatedLayout : (0, _utils$2.compact)(updatedLayout, (0, _utils$2.compactType)(this.props), cols);
      this.props.onDragStop(newLayout, oldDragItem, l, null, e2, node2);
      const {
        oldLayout
      } = this.state;
      this.setState({
        activeDrag: null,
        layout: newLayout,
        oldDragItem: null,
        oldLayout: null
      });
      this.onLayoutMaybeChanged(newLayout, oldLayout);
    });
    _defineProperty$2(this, "onResizeStart", (i, w2, h, _ref4) => {
      let {
        e: e2,
        node: node2
      } = _ref4;
      const {
        layout
      } = this.state;
      const l = (0, _utils$2.getLayoutItem)(layout, i);
      if (!l) return;
      this.setState({
        oldResizeItem: (0, _utils$2.cloneLayoutItem)(l),
        oldLayout: this.state.layout,
        resizing: true
      });
      this.props.onResizeStart(layout, l, l, null, e2, node2);
    });
    _defineProperty$2(this, "onResize", (i, w2, h, _ref5) => {
      let {
        e: e2,
        node: node2,
        size,
        handle
      } = _ref5;
      const {
        oldResizeItem,
        layout
      } = this.state;
      const {
        cols,
        preventCollision,
        allowOverlap,
        disableDragPreview
      } = this.props;
      let finalLayout = layout;
      const l = (0, _utils$2.getLayoutItem)(this.state.layout, i);
      const placeholder = {
        w: l.w,
        h: l.h,
        x: l.x,
        y: l.y,
        static: true,
        i
      };
      if (disableDragPreview) {
        this.setState({
          activeDrag: placeholder
        });
      } else {
        finalLayout = (0, _utils$2.compactForResize)(layout, i, w2, h, handle, preventCollision, allowOverlap, cols, (0, _utils$2.compactType)(this.props));
        finalLayout = allowOverlap ? finalLayout : (0, _utils$2.compact)(finalLayout, (0, _utils$2.compactType)(this.props), cols);
      }
      this.props.onResize(finalLayout, oldResizeItem, l, placeholder, e2, node2);
      this.setState({
        layout: finalLayout,
        activeDrag: placeholder
      });
    });
    _defineProperty$2(this, "onResizeStop", (i, w2, h, _ref6) => {
      let {
        e: e2,
        node: node2,
        size,
        handle
      } = _ref6;
      const {
        layout,
        oldResizeItem,
        oldLayout
      } = this.state;
      const {
        cols,
        preventCollision,
        allowOverlap,
        disableDragPreview
      } = this.props;
      const l = (0, _utils$2.getLayoutItem)(layout, i);
      let finalLayout = layout;
      if (disableDragPreview) {
        finalLayout = (0, _utils$2.compactForResize)(layout, i, w2, h, preventCollision, allowOverlap, cols, (0, _utils$2.compactType)(this.props));
      }
      finalLayout = allowOverlap ? finalLayout : (0, _utils$2.compact)(finalLayout, (0, _utils$2.compactType)(this.props), cols);
      this.props.onResizeStop(finalLayout, oldResizeItem, l, null, e2, node2);
      this.setState({
        activeDrag: null,
        layout: finalLayout,
        oldResizeItem: null,
        oldLayout: null,
        resizing: false
      });
      this.onLayoutMaybeChanged(finalLayout, oldLayout);
    });
    _defineProperty$2(this, "onDragOver", (e2) => {
      var _a;
      e2.preventDefault();
      e2.stopPropagation();
      if (isFirefox && // $FlowIgnore can't figure this out
      !((_a = e2.nativeEvent.target) == null ? void 0 : _a.classList.contains(layoutClassName$1))) {
        return false;
      }
      const {
        droppingItem,
        onDropDragOver,
        margin,
        cols,
        rowHeight,
        maxRows,
        width: width2,
        containerPadding,
        transformScale
      } = this.props;
      const onDragOverResult = onDropDragOver == null ? void 0 : onDropDragOver(e2);
      if (onDragOverResult === false) {
        if (this.state.droppingDOMNode) {
          this.removeDroppingPlaceholder();
        }
        return false;
      }
      const finalDroppingItem = {
        ...droppingItem,
        ...onDragOverResult
      };
      const {
        layout
      } = this.state;
      const gridRect = e2.currentTarget.getBoundingClientRect();
      const layerX = e2.clientX - gridRect.left;
      const layerY = e2.clientY - gridRect.top;
      const droppingPosition = {
        left: layerX / transformScale,
        top: layerY / transformScale,
        e: e2
      };
      if (!this.state.droppingDOMNode) {
        const positionParams = {
          cols,
          margin,
          maxRows,
          rowHeight,
          containerWidth: width2,
          containerPadding: containerPadding || margin
        };
        const calculatedPosition = (0, _calculateUtils.calcXY)(positionParams, layerY, layerX, finalDroppingItem.w, finalDroppingItem.h);
        this.setState({
          droppingDOMNode: /* @__PURE__ */ React$2.createElement("div", {
            key: finalDroppingItem.i
          }),
          droppingPosition,
          layout: [...layout, {
            ...finalDroppingItem,
            x: calculatedPosition.x,
            y: calculatedPosition.y,
            static: false,
            isDraggable: true
          }]
        });
      } else if (this.state.droppingPosition) {
        const {
          left,
          top
        } = this.state.droppingPosition;
        const shouldUpdatePosition = left != layerX || top != layerY;
        if (shouldUpdatePosition) {
          this.setState({
            droppingPosition
          });
        }
      }
    });
    _defineProperty$2(this, "removeDroppingPlaceholder", () => {
      const {
        droppingItem,
        cols
      } = this.props;
      const {
        layout
      } = this.state;
      const newLayout = (0, _utils$2.compact)(layout.filter((l) => l.i !== droppingItem.i), (0, _utils$2.compactType)(this.props), cols, this.props.allowOverlap);
      this.setState({
        layout: newLayout,
        droppingDOMNode: null,
        activeDrag: null,
        droppingPosition: void 0
      });
    });
    _defineProperty$2(this, "onDragLeave", (e2) => {
      e2.preventDefault();
      e2.stopPropagation();
      this.dragEnterCounter--;
      if (this.dragEnterCounter === 0) {
        this.removeDroppingPlaceholder();
      }
    });
    _defineProperty$2(this, "onDragEnter", (e2) => {
      e2.preventDefault();
      e2.stopPropagation();
      this.dragEnterCounter++;
    });
    _defineProperty$2(this, "onDrop", (e2) => {
      e2.preventDefault();
      e2.stopPropagation();
      const {
        droppingItem
      } = this.props;
      const {
        layout
      } = this.state;
      const item = layout.find((l) => l.i === droppingItem.i);
      this.dragEnterCounter = 0;
      this.removeDroppingPlaceholder();
      this.props.onDrop(layout, item, e2);
    });
  }
  componentDidMount() {
    this.setState({
      mounted: true
    });
    this.onLayoutMaybeChanged(this.state.layout, this.props.layout);
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let newLayoutBase;
    if (prevState.activeDrag) {
      return null;
    }
    if (!(0, _fastEquals$1.deepEqual)(nextProps.layout, prevState.propsLayout) || nextProps.compactType !== prevState.compactType) {
      newLayoutBase = nextProps.layout;
    } else if (!(0, _utils$2.childrenEqual)(nextProps.children, prevState.children)) {
      newLayoutBase = prevState.layout;
    }
    if (newLayoutBase) {
      const newLayout = (0, _utils$2.synchronizeLayoutWithChildren)(newLayoutBase, nextProps.children, nextProps.cols, (0, _utils$2.compactType)(nextProps), nextProps.allowOverlap);
      return {
        layout: newLayout,
        // We need to save these props to state for using
        // getDerivedStateFromProps instead of componentDidMount (in which we would get extra rerender)
        compactType: nextProps.compactType,
        children: nextProps.children,
        propsLayout: nextProps.layout
      };
    }
    return null;
  }
  shouldComponentUpdate(nextProps, nextState) {
    return (
      // NOTE: this is almost always unequal. Therefore the only way to get better performance
      // from SCU is if the user intentionally memoizes children. If they do, and they can
      // handle changes properly, performance will increase.
      this.props.children !== nextProps.children || !(0, _utils$2.fastRGLPropsEqual)(this.props, nextProps, _fastEquals$1.deepEqual) || this.state.activeDrag !== nextState.activeDrag || this.state.mounted !== nextState.mounted || this.state.droppingPosition !== nextState.droppingPosition
    );
  }
  componentDidUpdate(prevProps, prevState) {
    if (!this.state.activeDrag) {
      const newLayout = this.state.layout;
      const oldLayout = prevState.layout;
      this.onLayoutMaybeChanged(newLayout, oldLayout);
    }
  }
  /**
   * Calculates a pixel value for the container.
   * @return {String} Container height in pixels.
   */
  containerHeight() {
    if (!this.props.autoSize) return;
    const nbRow = (0, _utils$2.bottom)(this.state.layout);
    const containerPaddingY = this.props.containerPadding ? this.props.containerPadding[1] : this.props.margin[1];
    return nbRow * this.props.rowHeight + (nbRow - 1) * this.props.margin[1] + containerPaddingY * 2 + "px";
  }
  onLayoutMaybeChanged(newLayout, oldLayout) {
    if (!oldLayout) oldLayout = this.state.layout;
    if (!(0, _fastEquals$1.deepEqual)(oldLayout, newLayout)) {
      this.props.onLayoutChange(newLayout);
    }
  }
  /**
   * Create a placeholder object.
   * @return {Element} Placeholder div.
   */
  placeholder() {
    const {
      activeDrag
    } = this.state;
    if (!activeDrag) return null;
    const {
      width: width2,
      cols,
      margin,
      containerPadding,
      rowHeight,
      maxRows,
      useCSSTransforms,
      transformScale
    } = this.props;
    return /* @__PURE__ */ React$2.createElement(_GridItem.default, {
      w: activeDrag.w,
      h: activeDrag.h,
      x: activeDrag.x,
      y: activeDrag.y,
      i: activeDrag.i,
      className: `react-grid-placeholder ${this.state.resizing ? "placeholder-resizing" : ""}`,
      containerWidth: width2,
      cols,
      margin,
      containerPadding: containerPadding || margin,
      maxRows,
      rowHeight,
      isDraggable: false,
      isResizable: false,
      isBounded: false,
      useCSSTransforms,
      transformScale
    }, /* @__PURE__ */ React$2.createElement("div", null));
  }
  /**
   * Given a grid item, set its style attributes & surround in a <Draggable>.
   * @param  {Element} child React element.
   * @return {Element}       Element wrapped in draggable and properly placed.
   */
  processGridItem(child, isDroppingItem) {
    if (!child || !child.key) return;
    const l = (0, _utils$2.getLayoutItem)(this.state.layout, String(child.key));
    if (!l) return null;
    const {
      width: width2,
      cols,
      margin,
      containerPadding,
      rowHeight,
      maxRows,
      isDraggable,
      isResizable,
      isBounded,
      useCSSTransforms,
      transformScale,
      draggableCancel,
      draggableHandle,
      resizeHandles,
      resizeHandle,
      lazyload,
      parentContainer,
      compactType: compactType2
    } = this.props;
    const {
      mounted,
      droppingPosition,
      activeDrag
    } = this.state;
    const draggable = typeof l.isDraggable === "boolean" ? l.isDraggable : !l.static && isDraggable;
    const resizable = typeof l.isResizable === "boolean" ? l.isResizable : !l.static && isResizable;
    const resizeHandlesOptions = l.resizeHandles || resizeHandles;
    const bounded = draggable && isBounded && l.isBounded !== false;
    if (lazyload && l.i !== (activeDrag == null ? void 0 : activeDrag.i) && parentContainer && compactType2 !== "horizontal" && !(0, _utils$2.isLayoutItemVisible)(l, rowHeight, margin, parentContainer.scrollTop, parentContainer.clientHeight)) return null;
    return /* @__PURE__ */ React$2.createElement(_GridItem.default, {
      containerWidth: width2,
      cols,
      margin,
      containerPadding: containerPadding || margin,
      maxRows,
      rowHeight,
      cancel: draggableCancel,
      handle: draggableHandle,
      onDragStop: this.onDragStop,
      onDragStart: this.onDragStart,
      onDrag: this.onDrag,
      onResizeStart: this.onResizeStart,
      onResize: this.onResize,
      onResizeStop: this.onResizeStop,
      isDraggable: draggable,
      isResizable: resizable,
      isBounded: bounded,
      useCSSTransforms: useCSSTransforms && mounted,
      usePercentages: !mounted,
      transformScale,
      w: l.w,
      h: l.h,
      x: l.x,
      y: l.y,
      i: l.i,
      minH: l.minH,
      minW: l.minW,
      maxH: l.maxH,
      maxW: l.maxW,
      static: l.static,
      droppingPosition: isDroppingItem ? droppingPosition : void 0,
      resizeHandles: resizeHandlesOptions,
      resizeHandle
    }, child);
  }
  render() {
    const {
      className,
      style,
      isDroppable,
      innerRef
    } = this.props;
    const mergedClassName = (0, _clsx$1.default)(layoutClassName$1, className);
    const mergedStyle = {
      height: this.containerHeight(),
      ...style
    };
    return /* @__PURE__ */ React$2.createElement("div", {
      ref: innerRef,
      className: mergedClassName,
      style: mergedStyle,
      onDrop: isDroppable ? this.onDrop : _utils$2.noop,
      onDragLeave: isDroppable ? this.onDragLeave : _utils$2.noop,
      onDragEnter: isDroppable ? this.onDragEnter : _utils$2.noop,
      onDragOver: isDroppable ? this.onDragOver : _utils$2.noop
    }, React$2.Children.map(this.props.children, (child) => this.processGridItem(child)), isDroppable && this.state.droppingDOMNode && this.processGridItem(this.state.droppingDOMNode, true), this.placeholder());
  }
}
ReactGridLayout$1.default = ReactGridLayout;
_defineProperty$2(ReactGridLayout, "displayName", "ReactGridLayout");
_defineProperty$2(ReactGridLayout, "propTypes", _ReactGridLayoutPropTypes.default);
_defineProperty$2(ReactGridLayout, "defaultProps", {
  disableDragPreview: false,
  lazyload: false,
  autoSize: true,
  cols: 12,
  className: "",
  style: {},
  draggableHandle: "",
  draggableCancel: "",
  containerPadding: null,
  rowHeight: 150,
  maxRows: Infinity,
  // infinite vertical growth
  layout: [],
  margin: [10, 10],
  isBounded: false,
  isDraggable: true,
  isResizable: true,
  allowOverlap: false,
  isDroppable: false,
  useCSSTransforms: true,
  transformScale: 1,
  verticalCompact: true,
  compactType: "vertical",
  preventCollision: false,
  droppingItem: {
    i: "__dropping-elem__",
    h: 1,
    w: 1
  },
  resizeHandles: ["se"],
  onLayoutChange: _utils$2.noop,
  onDragStart: _utils$2.noop,
  onDrag: _utils$2.noop,
  onDragStop: _utils$2.noop,
  onResizeStart: _utils$2.noop,
  onResize: _utils$2.noop,
  onResizeStop: _utils$2.noop,
  onDrop: _utils$2.noop,
  onDropDragOver: _utils$2.noop
});
var ResponsiveReactGridLayout$1 = {};
var responsiveUtils = {};
Object.defineProperty(responsiveUtils, "__esModule", {
  value: true
});
responsiveUtils.findOrGenerateResponsiveLayout = findOrGenerateResponsiveLayout;
responsiveUtils.getBreakpointFromWidth = getBreakpointFromWidth;
responsiveUtils.getColsFromBreakpoint = getColsFromBreakpoint;
responsiveUtils.sortBreakpoints = sortBreakpoints;
var _utils$1 = utils$1;
function getBreakpointFromWidth(breakpoints, width2) {
  const sorted = sortBreakpoints(breakpoints);
  let matching = sorted[0];
  for (let i = 1, len = sorted.length; i < len; i++) {
    const breakpointName = sorted[i];
    if (width2 > breakpoints[breakpointName]) matching = breakpointName;
  }
  return matching;
}
function getColsFromBreakpoint(breakpoint, cols) {
  if (!cols[breakpoint]) {
    throw new Error("ResponsiveReactGridLayout: `cols` entry for breakpoint " + breakpoint + " is missing!");
  }
  return cols[breakpoint];
}
function findOrGenerateResponsiveLayout(layouts, breakpoints, breakpoint, lastBreakpoint, cols, compactType2) {
  if (layouts[breakpoint]) return (0, _utils$1.cloneLayout)(layouts[breakpoint]);
  let layout = layouts[lastBreakpoint];
  const breakpointsSorted = sortBreakpoints(breakpoints);
  const breakpointsAbove = breakpointsSorted.slice(breakpointsSorted.indexOf(breakpoint));
  for (let i = 0, len = breakpointsAbove.length; i < len; i++) {
    const b = breakpointsAbove[i];
    if (layouts[b]) {
      layout = layouts[b];
      break;
    }
  }
  layout = (0, _utils$1.cloneLayout)(layout || []);
  return (0, _utils$1.compact)((0, _utils$1.correctBounds)(layout, {
    cols
  }), compactType2, cols);
}
function sortBreakpoints(breakpoints) {
  const keys = Object.keys(breakpoints);
  return keys.sort(function(a, b) {
    return breakpoints[a] - breakpoints[b];
  });
}
Object.defineProperty(ResponsiveReactGridLayout$1, "__esModule", {
  value: true
});
ResponsiveReactGridLayout$1.default = void 0;
var React$1 = _interopRequireWildcard$1(o);
var _propTypes$1 = _interopRequireDefault$1(propTypesExports);
var _fastEquals = require$$2$1;
var _utils = utils$1;
var _responsiveUtils = responsiveUtils;
var _ReactGridLayout = _interopRequireDefault$1(ReactGridLayout$1);
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _getRequireWildcardCache$1(e2) {
  if ("function" != typeof WeakMap) return null;
  var r2 = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$1 = function(e3) {
    return e3 ? t : r2;
  })(e2);
}
function _interopRequireWildcard$1(e2, r2) {
  if (e2 && e2.__esModule) return e2;
  if (null === e2 || "object" != typeof e2 && "function" != typeof e2) return { default: e2 };
  var t = _getRequireWildcardCache$1(r2);
  if (t && t.has(e2)) return t.get(e2);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e2) if ("default" !== u && Object.prototype.hasOwnProperty.call(e2, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e2, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e2[u];
  }
  return n.default = e2, t && t.set(e2, n), n;
}
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey$1(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$1(arg) {
  var key = _toPrimitive$1(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
const type = (obj) => Object.prototype.toString.call(obj);
function getIndentationValue(param, breakpoint) {
  if (param == null) return null;
  return Array.isArray(param) ? param : param[breakpoint];
}
class ResponsiveReactGridLayout extends React$1.Component {
  constructor() {
    super(...arguments);
    _defineProperty$1(this, "state", this.generateInitialState());
    _defineProperty$1(this, "onLayoutChange", (layout) => {
      this.props.onLayoutChange(layout, {
        ...this.props.layouts,
        [this.state.breakpoint]: layout
      });
    });
  }
  generateInitialState() {
    const {
      width: width2,
      breakpoints,
      layouts,
      cols
    } = this.props;
    const breakpoint = (0, _responsiveUtils.getBreakpointFromWidth)(breakpoints, width2);
    const colNo = (0, _responsiveUtils.getColsFromBreakpoint)(breakpoint, cols);
    const compactType2 = this.props.verticalCompact === false ? null : this.props.compactType;
    const initialLayout = (0, _responsiveUtils.findOrGenerateResponsiveLayout)(layouts, breakpoints, breakpoint, breakpoint, colNo, compactType2);
    return {
      layout: initialLayout,
      breakpoint,
      cols: colNo
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (!(0, _fastEquals.deepEqual)(nextProps.layouts, prevState.layouts)) {
      const {
        breakpoint,
        cols
      } = prevState;
      const newLayout = (0, _responsiveUtils.findOrGenerateResponsiveLayout)(nextProps.layouts, nextProps.breakpoints, breakpoint, breakpoint, cols, nextProps.compactType);
      return {
        layout: newLayout,
        layouts: nextProps.layouts
      };
    }
    return null;
  }
  componentDidUpdate(prevProps) {
    if (this.props.width != prevProps.width || this.props.breakpoint !== prevProps.breakpoint || !(0, _fastEquals.deepEqual)(this.props.breakpoints, prevProps.breakpoints) || !(0, _fastEquals.deepEqual)(this.props.cols, prevProps.cols)) {
      this.onWidthChange(prevProps);
    }
  }
  /**
   * When the width changes work through breakpoints and reset state with the new width & breakpoint.
   * Width changes are necessary to figure out the widget widths.
   */
  onWidthChange(prevProps) {
    const {
      breakpoints,
      cols,
      layouts,
      compactType: compactType2
    } = this.props;
    const newBreakpoint = this.props.breakpoint || (0, _responsiveUtils.getBreakpointFromWidth)(this.props.breakpoints, this.props.width);
    const lastBreakpoint = this.state.breakpoint;
    const newCols = (0, _responsiveUtils.getColsFromBreakpoint)(newBreakpoint, cols);
    const newLayouts = {
      ...layouts
    };
    if (lastBreakpoint !== newBreakpoint || prevProps.breakpoints !== breakpoints || prevProps.cols !== cols) {
      if (!(lastBreakpoint in newLayouts)) newLayouts[lastBreakpoint] = (0, _utils.cloneLayout)(this.state.layout);
      let layout = (0, _responsiveUtils.findOrGenerateResponsiveLayout)(newLayouts, breakpoints, newBreakpoint, lastBreakpoint, newCols, compactType2);
      layout = (0, _utils.synchronizeLayoutWithChildren)(layout, this.props.children, newCols, compactType2, this.props.allowOverlap);
      newLayouts[newBreakpoint] = layout;
      this.props.onBreakpointChange(newBreakpoint, newCols);
      this.props.onLayoutChange(layout, newLayouts);
      this.setState({
        breakpoint: newBreakpoint,
        layout,
        cols: newCols
      });
    }
    const margin = getIndentationValue(this.props.margin, newBreakpoint);
    const containerPadding = getIndentationValue(this.props.containerPadding, newBreakpoint);
    this.props.onWidthChange(this.props.width, margin, newCols, containerPadding);
  }
  render() {
    const {
      breakpoint,
      breakpoints,
      cols,
      layouts,
      margin,
      containerPadding,
      onBreakpointChange,
      onLayoutChange,
      onWidthChange,
      ...other
    } = this.props;
    return /* @__PURE__ */ React$1.createElement(_ReactGridLayout.default, _extends$1({}, other, {
      // $FlowIgnore should allow nullable here due to DefaultProps
      margin: getIndentationValue(margin, this.state.breakpoint),
      containerPadding: getIndentationValue(containerPadding, this.state.breakpoint),
      onLayoutChange: this.onLayoutChange,
      layout: this.state.layout,
      cols: this.state.cols
    }));
  }
}
ResponsiveReactGridLayout$1.default = ResponsiveReactGridLayout;
_defineProperty$1(ResponsiveReactGridLayout, "propTypes", {
  //
  // Basic props
  //
  // Optional, but if you are managing width yourself you may want to set the breakpoint
  // yourself as well.
  breakpoint: _propTypes$1.default.string,
  // {name: pxVal}, e.g. {lg: 1200, md: 996, sm: 768, xs: 480}
  breakpoints: _propTypes$1.default.object,
  allowOverlap: _propTypes$1.default.bool,
  // # of cols. This is a breakpoint -> cols map
  cols: _propTypes$1.default.object,
  // # of margin. This is a breakpoint -> margin map
  // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
  // Margin between items [x, y] in px
  // e.g. [10, 10]
  margin: _propTypes$1.default.oneOfType([_propTypes$1.default.array, _propTypes$1.default.object]),
  // # of containerPadding. This is a breakpoint -> containerPadding map
  // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
  // Padding inside the container [x, y] in px
  // e.g. [10, 10]
  containerPadding: _propTypes$1.default.oneOfType([_propTypes$1.default.array, _propTypes$1.default.object]),
  // layouts is an object mapping breakpoints to layouts.
  // e.g. {lg: Layout, md: Layout, ...}
  layouts(props, propName) {
    if (type(props[propName]) !== "[object Object]") {
      throw new Error("Layout property must be an object. Received: " + type(props[propName]));
    }
    Object.keys(props[propName]).forEach((key) => {
      if (!(key in props.breakpoints)) {
        throw new Error("Each key in layouts must align with a key in breakpoints.");
      }
      (0, _utils.validateLayout)(props.layouts[key], "layouts." + key);
    });
  },
  // The width of this component.
  // Required in this propTypes stanza because generateInitialState() will fail without it.
  width: _propTypes$1.default.number.isRequired,
  //
  // Callbacks
  //
  // Calls back with breakpoint and new # cols
  onBreakpointChange: _propTypes$1.default.func,
  // Callback so you can save the layout.
  // Calls back with (currentLayout, allLayouts). allLayouts are keyed by breakpoint.
  onLayoutChange: _propTypes$1.default.func,
  // Calls back with (containerWidth, margin, cols, containerPadding)
  onWidthChange: _propTypes$1.default.func
});
_defineProperty$1(ResponsiveReactGridLayout, "defaultProps", {
  breakpoints: {
    lg: 1200,
    md: 996,
    sm: 768,
    xs: 480,
    xxs: 0
  },
  cols: {
    lg: 12,
    md: 10,
    sm: 6,
    xs: 4,
    xxs: 2
  },
  containerPadding: {
    lg: null,
    md: null,
    sm: null,
    xs: null,
    xxs: null
  },
  layouts: {},
  margin: [10, 10],
  allowOverlap: false,
  onBreakpointChange: _utils.noop,
  onLayoutChange: _utils.noop,
  onWidthChange: _utils.noop
});
var WidthProvider = {};
var MapShim = function() {
  if (typeof Map !== "undefined") {
    return Map;
  }
  function getIndex(arr, key) {
    var result = -1;
    arr.some(function(entry, index2) {
      if (entry[0] === key) {
        result = index2;
        return true;
      }
      return false;
    });
    return result;
  }
  return (
    /** @class */
    function() {
      function class_1() {
        this.__entries__ = [];
      }
      Object.defineProperty(class_1.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: true,
        configurable: true
      });
      class_1.prototype.get = function(key) {
        var index2 = getIndex(this.__entries__, key);
        var entry = this.__entries__[index2];
        return entry && entry[1];
      };
      class_1.prototype.set = function(key, value) {
        var index2 = getIndex(this.__entries__, key);
        if (~index2) {
          this.__entries__[index2][1] = value;
        } else {
          this.__entries__.push([key, value]);
        }
      };
      class_1.prototype.delete = function(key) {
        var entries = this.__entries__;
        var index2 = getIndex(entries, key);
        if (~index2) {
          entries.splice(index2, 1);
        }
      };
      class_1.prototype.has = function(key) {
        return !!~getIndex(this.__entries__, key);
      };
      class_1.prototype.clear = function() {
        this.__entries__.splice(0);
      };
      class_1.prototype.forEach = function(callback, ctx) {
        if (ctx === void 0) {
          ctx = null;
        }
        for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
          var entry = _a[_i];
          callback.call(ctx, entry[1], entry[0]);
        }
      };
      return class_1;
    }()
  );
}();
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
var global$1 = function() {
  if (typeof global !== "undefined" && global.Math === Math) {
    return global;
  }
  if (typeof self !== "undefined" && self.Math === Math) {
    return self;
  }
  if (typeof window !== "undefined" && window.Math === Math) {
    return window;
  }
  return Function("return this")();
}();
var requestAnimationFrame$1 = function() {
  if (typeof requestAnimationFrame === "function") {
    return requestAnimationFrame.bind(global$1);
  }
  return function(callback) {
    return setTimeout(function() {
      return callback(Date.now());
    }, 1e3 / 60);
  };
}();
var trailingTimeout = 2;
function throttle(callback, delay) {
  var leadingCall = false, trailingCall = false, lastCallTime = 0;
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }
    if (trailingCall) {
      proxy();
    }
  }
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}
var REFRESH_DELAY = 20;
var transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"];
var mutationObserverSupported = typeof MutationObserver !== "undefined";
var ResizeObserverController = (
  /** @class */
  function() {
    function ResizeObserverController2() {
      this.connected_ = false;
      this.mutationEventsAdded_ = false;
      this.mutationsObserver_ = null;
      this.observers_ = [];
      this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
      this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    ResizeObserverController2.prototype.addObserver = function(observer) {
      if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
      }
      if (!this.connected_) {
        this.connect_();
      }
    };
    ResizeObserverController2.prototype.removeObserver = function(observer) {
      var observers2 = this.observers_;
      var index2 = observers2.indexOf(observer);
      if (~index2) {
        observers2.splice(index2, 1);
      }
      if (!observers2.length && this.connected_) {
        this.disconnect_();
      }
    };
    ResizeObserverController2.prototype.refresh = function() {
      var changesDetected = this.updateObservers_();
      if (changesDetected) {
        this.refresh();
      }
    };
    ResizeObserverController2.prototype.updateObservers_ = function() {
      var activeObservers = this.observers_.filter(function(observer) {
        return observer.gatherActive(), observer.hasActive();
      });
      activeObservers.forEach(function(observer) {
        return observer.broadcastActive();
      });
      return activeObservers.length > 0;
    };
    ResizeObserverController2.prototype.connect_ = function() {
      if (!isBrowser || this.connected_) {
        return;
      }
      document.addEventListener("transitionend", this.onTransitionEnd_);
      window.addEventListener("resize", this.refresh);
      if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);
        this.mutationsObserver_.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      } else {
        document.addEventListener("DOMSubtreeModified", this.refresh);
        this.mutationEventsAdded_ = true;
      }
      this.connected_ = true;
    };
    ResizeObserverController2.prototype.disconnect_ = function() {
      if (!isBrowser || !this.connected_) {
        return;
      }
      document.removeEventListener("transitionend", this.onTransitionEnd_);
      window.removeEventListener("resize", this.refresh);
      if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
      }
      if (this.mutationEventsAdded_) {
        document.removeEventListener("DOMSubtreeModified", this.refresh);
      }
      this.mutationsObserver_ = null;
      this.mutationEventsAdded_ = false;
      this.connected_ = false;
    };
    ResizeObserverController2.prototype.onTransitionEnd_ = function(_a) {
      var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
      var isReflowProperty = transitionKeys.some(function(key) {
        return !!~propertyName.indexOf(key);
      });
      if (isReflowProperty) {
        this.refresh();
      }
    };
    ResizeObserverController2.getInstance = function() {
      if (!this.instance_) {
        this.instance_ = new ResizeObserverController2();
      }
      return this.instance_;
    };
    ResizeObserverController2.instance_ = null;
    return ResizeObserverController2;
  }()
);
var defineConfigurable = function(target, props) {
  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
    var key = _a[_i];
    Object.defineProperty(target, key, {
      value: props[key],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
};
var getWindowOf = function(target) {
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  return ownerGlobal || global$1;
};
var emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(value) {
  return parseFloat(value) || 0;
}
function getBordersSize(styles) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function(size, position2) {
    var value = styles["border-" + position2 + "-width"];
    return size + toFloat(value);
  }, 0);
}
function getPaddings(styles) {
  var positions = ["top", "right", "bottom", "left"];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position2 = positions_1[_i];
    var value = styles["padding-" + position2];
    paddings[position2] = toFloat(value);
  }
  return paddings;
}
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
function getHTMLElementContentRect(target) {
  var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  var width2 = toFloat(styles.width), height2 = toFloat(styles.height);
  if (styles.boxSizing === "border-box") {
    if (Math.round(width2 + horizPad) !== clientWidth) {
      width2 -= getBordersSize(styles, "left", "right") + horizPad;
    }
    if (Math.round(height2 + vertPad) !== clientHeight) {
      height2 -= getBordersSize(styles, "top", "bottom") + vertPad;
    }
  }
  if (!isDocumentElement(target)) {
    var vertScrollbar = Math.round(width2 + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height2 + vertPad) - clientHeight;
    if (Math.abs(vertScrollbar) !== 1) {
      width2 -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height2 -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width2, height2);
}
var isSVGGraphicsElement = function() {
  if (typeof SVGGraphicsElement !== "undefined") {
    return function(target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  }
  return function(target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === "function";
  };
}();
function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
function getContentRect(target) {
  if (!isBrowser) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
function createReadOnlyRect(_a) {
  var x2 = _a.x, y2 = _a.y, width2 = _a.width, height2 = _a.height;
  var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  defineConfigurable(rect, {
    x: x2,
    y: y2,
    width: width2,
    height: height2,
    top: y2,
    right: x2 + width2,
    bottom: height2 + y2,
    left: x2
  });
  return rect;
}
function createRectInit(x2, y2, width2, height2) {
  return { x: x2, y: y2, width: width2, height: height2 };
}
var ResizeObservation = (
  /** @class */
  function() {
    function ResizeObservation2(target) {
      this.broadcastWidth = 0;
      this.broadcastHeight = 0;
      this.contentRect_ = createRectInit(0, 0, 0, 0);
      this.target = target;
    }
    ResizeObservation2.prototype.isActive = function() {
      var rect = getContentRect(this.target);
      this.contentRect_ = rect;
      return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    ResizeObservation2.prototype.broadcastRect = function() {
      var rect = this.contentRect_;
      this.broadcastWidth = rect.width;
      this.broadcastHeight = rect.height;
      return rect;
    };
    return ResizeObservation2;
  }()
);
var ResizeObserverEntry = (
  /** @class */
  /* @__PURE__ */ function() {
    function ResizeObserverEntry2(target, rectInit) {
      var contentRect = createReadOnlyRect(rectInit);
      defineConfigurable(this, { target, contentRect });
    }
    return ResizeObserverEntry2;
  }()
);
var ResizeObserverSPI = (
  /** @class */
  function() {
    function ResizeObserverSPI2(callback, controller, callbackCtx) {
      this.activeObservations_ = [];
      this.observations_ = new MapShim();
      if (typeof callback !== "function") {
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      }
      this.callback_ = callback;
      this.controller_ = controller;
      this.callbackCtx_ = callbackCtx;
    }
    ResizeObserverSPI2.prototype.observe = function(target) {
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      if (typeof Element === "undefined" || !(Element instanceof Object)) {
        return;
      }
      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }
      var observations = this.observations_;
      if (observations.has(target)) {
        return;
      }
      observations.set(target, new ResizeObservation(target));
      this.controller_.addObserver(this);
      this.controller_.refresh();
    };
    ResizeObserverSPI2.prototype.unobserve = function(target) {
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      if (typeof Element === "undefined" || !(Element instanceof Object)) {
        return;
      }
      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }
      var observations = this.observations_;
      if (!observations.has(target)) {
        return;
      }
      observations.delete(target);
      if (!observations.size) {
        this.controller_.removeObserver(this);
      }
    };
    ResizeObserverSPI2.prototype.disconnect = function() {
      this.clearActive();
      this.observations_.clear();
      this.controller_.removeObserver(this);
    };
    ResizeObserverSPI2.prototype.gatherActive = function() {
      var _this = this;
      this.clearActive();
      this.observations_.forEach(function(observation) {
        if (observation.isActive()) {
          _this.activeObservations_.push(observation);
        }
      });
    };
    ResizeObserverSPI2.prototype.broadcastActive = function() {
      if (!this.hasActive()) {
        return;
      }
      var ctx = this.callbackCtx_;
      var entries = this.activeObservations_.map(function(observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
      });
      this.callback_.call(ctx, entries, ctx);
      this.clearActive();
    };
    ResizeObserverSPI2.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    };
    ResizeObserverSPI2.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI2;
  }()
);
var observers = typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : new MapShim();
var ResizeObserver = (
  /** @class */
  /* @__PURE__ */ function() {
    function ResizeObserver2(callback) {
      if (!(this instanceof ResizeObserver2)) {
        throw new TypeError("Cannot call a class as a function.");
      }
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      var controller = ResizeObserverController.getInstance();
      var observer = new ResizeObserverSPI(callback, controller, this);
      observers.set(this, observer);
    }
    return ResizeObserver2;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(method) {
  ResizeObserver.prototype[method] = function() {
    var _a;
    return (_a = observers.get(this))[method].apply(_a, arguments);
  };
});
var index = function() {
  if (typeof global$1.ResizeObserver !== "undefined") {
    return global$1.ResizeObserver;
  }
  return ResizeObserver;
}();
const ResizeObserver_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: index
}, Symbol.toStringTag, { value: "Module" }));
const require$$2 = /* @__PURE__ */ getAugmentedNamespace(ResizeObserver_es);
Object.defineProperty(WidthProvider, "__esModule", {
  value: true
});
WidthProvider.default = WidthProvideRGL;
var React = _interopRequireWildcard(o);
var _propTypes = _interopRequireDefault(propTypesExports);
var _resizeObserverPolyfill = _interopRequireDefault(require$$2);
var _clsx = _interopRequireDefault(clsxExports);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _getRequireWildcardCache(e2) {
  if ("function" != typeof WeakMap) return null;
  var r2 = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache = function(e3) {
    return e3 ? t : r2;
  })(e2);
}
function _interopRequireWildcard(e2, r2) {
  if (e2 && e2.__esModule) return e2;
  if (null === e2 || "object" != typeof e2 && "function" != typeof e2) return { default: e2 };
  var t = _getRequireWildcardCache(r2);
  if (t && t.has(e2)) return t.get(e2);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e2) if ("default" !== u && Object.prototype.hasOwnProperty.call(e2, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e2, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e2[u];
  }
  return n.default = e2, t && t.set(e2, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
const layoutClassName = "react-grid-layout";
function WidthProvideRGL(ComposedComponent) {
  var _class;
  return _class = class WidthProvider extends React.Component {
    constructor() {
      super(...arguments);
      _defineProperty(this, "state", {
        width: 1280
      });
      _defineProperty(this, "elementRef", /* @__PURE__ */ React.createRef());
      _defineProperty(this, "mounted", false);
      _defineProperty(this, "resizeObserver", void 0);
    }
    componentDidMount() {
      this.mounted = true;
      this.resizeObserver = new _resizeObserverPolyfill.default((entries) => {
        const node3 = this.elementRef.current;
        if (node3 instanceof HTMLElement) {
          const width2 = entries[0].contentRect.width;
          this.setState({
            width: width2
          });
        }
      });
      const node2 = this.elementRef.current;
      if (node2 instanceof HTMLElement) {
        this.resizeObserver.observe(node2);
      }
    }
    componentWillUnmount() {
      this.mounted = false;
      const node2 = this.elementRef.current;
      if (node2 instanceof HTMLElement) {
        this.resizeObserver.unobserve(node2);
      }
      this.resizeObserver.disconnect();
    }
    render() {
      const {
        measureBeforeMount,
        ...rest
      } = this.props;
      if (measureBeforeMount && !this.mounted) {
        return /* @__PURE__ */ React.createElement("div", {
          className: (0, _clsx.default)(this.props.className, layoutClassName),
          style: this.props.style,
          ref: this.elementRef
        });
      }
      return /* @__PURE__ */ React.createElement(ComposedComponent, _extends({
        innerRef: this.elementRef
      }, rest, this.state));
    }
  }, _defineProperty(_class, "defaultProps", {
    measureBeforeMount: false
  }), _defineProperty(_class, "propTypes", {
    // If true, will not render children until mounted. Useful for getting the exact width before
    // rendering, to prevent any unsightly resizing.
    measureBeforeMount: _propTypes.default.bool
  }), _class;
}
(function(module) {
  module.exports = ReactGridLayout$1.default;
  module.exports.utils = utils$1;
  module.exports.calculateUtils = calculateUtils;
  module.exports.Responsive = ResponsiveReactGridLayout$1.default;
  module.exports.Responsive.utils = responsiveUtils;
  module.exports.WidthProvider = WidthProvider.default;
})(reactGridLayout);
var reactGridLayoutExports = reactGridLayout.exports;
const GridLayout = /* @__PURE__ */ getDefaultExportFromCjs(reactGridLayoutExports);
const DragIcon = ({ fill }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { fill, style: { maxWidth: "100%", maxHeight: "100%" }, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 512", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M64 96A16 16 0 1 0 32 96a16 16 0 1 0 32 0zM0 96a48 48 0 1 1 96 0A48 48 0 1 1 0 96zM64 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zM48 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM224 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm16 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z" }) });
};
const ResizeIcon = ({ fill }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { fill, style: { maxWidth: "100%", maxHeight: "100%" }, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M336 32l-16 0 0 32 16 0 89.4 0L256 233.4 86.6 64 176 64l16 0 0-32-16 0L48 32 32 32l0 16 0 128 0 16 32 0 0-16 0-89.4L233.4 256 64 425.4 64 336l0-16-32 0 0 16 0 128 0 16 16 0 128 0 16 0 0-32-16 0-89.4 0L256 278.6 425.4 448 336 448l-16 0 0 32 16 0 128 0 16 0 0-16 0-128 0-16-32 0 0 16 0 89.4L278.6 256 448 86.6l0 89.4 0 16 32 0 0-16 0-128 0-16-16 0L336 32z" }) });
};
const StyledField = dt.div.withConfig({
  shouldForwardProp: (prop) => prop !== "editable" && prop !== "focused" && prop !== "theme" && prop !== "zIndex"
})`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 2px;

  .react-resizable-drag-handle {
    ${(props) => !props.editable ? "visibility: hidden;" : ""}
    opacity: 0;
  }
  
  .react-resizable-handle {
    ${(props) => !props.editable ? "visibility: hidden;" : ""}
    opacity: 0;
    background-image: none;
    padding: 0px;
  }
  
  &:hover {
    ${(props) => {
  var _a;
  return props.editable ? `border: 1px solid ${(_a = props.theme) == null ? void 0 : _a.primaryColor};` : "";
}}
    ${(props) => {
  var _a;
  return props.editable ? `background-color: ${(_a = props.theme) == null ? void 0 : _a.highlightColor};` : "";
}} 
    z-index:9999999999 !important;
  }

  &:hover .react-resizable-drag-handle {
    opacity: 1;
  }

  &:hover .react-resizable-handle {
    opacity: 1;
  }

  /*
   * IMPORTANT NOTE: Do not remove transparent border.
   *
   * Fields always have a 1px border width regardless if they are focused 
   * or not. This is to ensure that the field stays the same size 
   * when toggling in and out of focus mode and no visual shift happens.
   */
  border: 1px solid transparent;
  ${(props) => {
  var _a;
  return props.focused && props.editable ? `border: 1px solid ${(_a = props.theme) == null ? void 0 : _a.primaryColor};` : "";
}}
  ${(props) => props.zIndex ? `z-index: ${props.zIndex} !important;` : ""};
`;
const StyledLayoutItemInternal = dt.div`
  height: 100%;
  width: 100%;
`;
const LayoutItem = o.forwardRef(
  ({ id, focused, editable, theme, zIndex, ...props }, ref) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      StyledField,
      {
        ref,
        ...{
          focused: focused || false,
          editable,
          theme,
          zIndex: zIndex || 0
        },
        ...props,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLayoutItemInternal, { children: props.children }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(LayoutItemDragHandle, { id, theme })
        ]
      }
    );
  }
);
const LayoutItemDragHandle = ({ theme }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      style: {
        boxSizing: "border-box",
        width: "20px",
        height: "20px",
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        top: "-8px",
        right: "-8px",
        textAlign: "center",
        backgroundColor: theme.primaryColor,
        border: `1px solid ${theme.primaryColor}`,
        borderRadius: "3px",
        zIndex: 999999999,
        cursor: "grab"
      },
      className: `react-resizable-drag-handle`,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(DragIcon, { fill: theme.iconColor })
    }
  );
};
const LayoutItemResizeHandle = o.forwardRef(
  ({ theme, ...props }, ref) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        ...props,
        ref,
        "data-testid": "react-resizable-handle",
        className: "react-resizable-handle",
        style: {
          position: "absolute",
          boxSizing: "border-box",
          width: "20px",
          height: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          bottom: "-8px",
          right: "-8px",
          textAlign: "center",
          backgroundColor: theme.primaryColor,
          border: `1px solid ${theme.primaryColor}`,
          borderRadius: "3px",
          padding: "2px",
          zIndex: 999999999,
          cursor: "nwse-resize"
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ResizeIcon, { fill: theme.iconColor })
      }
    );
  }
);
const float = "float";
const grid = "grid";
const all$1 = [float, grid];
const LayoutTypes = {
  float,
  grid,
  all: all$1
};
const StyledDefaults = dt.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  /*height: 100%;*/
  width: 100%;

  /*Default Form Field Styles*/

  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  border-width: 0px !important;

  button, input, optgroup, select, textarea {
    margin: 0;
    font-family: inherit;
    line-height: inherit;
    font-size: inherit;
  }

  *, ::after, ::before {
    box-sizing: border-box;
  }

  /*React Grid Layout Styles*/
  .react-resizable-handle::after {
    display: none !important;
  };

  .react-grid-item.react-grid-placeholder {
    background-color: ${(props) => props.theme.highlightColor} !important;
    opacity: 1;
  }

  .react-grid-item > .react-resizable-handle {
    width: 18px;
    height 18px;
  }

`;
class Layout extends PureComponent {
  constructor(props) {
    super(props);
    __publicField(this, "populateFormattedFieldPositons", () => {
      const { fields, scale } = this.props;
      const formattedFieldPositions = !fields || fields.length < 1 ? [] : fields.map((field) => {
        if (scale === 1) return field;
        return {
          ...field
          //y: field.y * scale,
          //height: field.height * scale
        };
      });
      this.setState({ formattedFieldPositions });
    });
    __publicField(this, "getLayout", () => {
      const { formattedFieldPositions } = this.state;
      const layouts = formattedFieldPositions.map((field) => {
        return {
          i: field._id,
          x: field.x,
          y: field.y,
          w: field.width,
          h: field.height
        };
      });
      return layouts;
    });
    __publicField(this, "getFieldNodes", () => {
      const { editable, theme, itemRenderer, id } = this.props;
      const { formattedFieldPositions } = this.state;
      return formattedFieldPositions.map((field) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          LayoutItem,
          {
            id: field._id,
            editable,
            theme,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                style: {
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                },
                children: itemRenderer ? itemRenderer(id, field) : null
              }
            )
          },
          field._id
        );
      });
    });
    /**
     * React-grid-layout doesn't call onLayoutChange prop when allowOverlap (layout === float)
     * props is set to true.
     *
     * We manually call on onLayoutChange here when layout is float
     * (float means allowOverlap on react-grid-layout will be true) to trigger the
     * field layout update action handler so that it gets fired everytime there is
     * a change regardless of the layout set. This ensures it consistently fires
     * if someone has logic that is dependent on it firing.
     */
    __publicField(this, "handleManualLayoutChange", (layouts) => {
      const { layout } = this.props;
      if (layout === float) this.handleLayoutChange(layouts);
    });
    __publicField(this, "handleLayoutChange", (layouts) => {
      const { onFieldLayoutsChange } = this.props;
      const { formattedFieldPositions } = this.state;
      const currentLayouts = this.getLayout();
      if (!hasLayoutChanged(currentLayouts, layouts)) return;
      if (onFieldLayoutsChange) {
        const fieldPositionLookup = {};
        formattedFieldPositions.forEach((fieldPosition) => fieldPositionLookup[fieldPosition._id] = fieldPosition);
        const nextLayouts = layouts.map((layout) => {
          const formattedLayoutObject = getFormattedLayoutObject(layout);
          return { ...formattedLayoutObject };
        });
        onFieldLayoutsChange(nextLayouts);
      }
    });
    this.state = {
      formattedFieldPositions: [],
      layoutContainer: null
    };
  }
  componentDidMount() {
    this.populateFormattedFieldPositons();
  }
  componentDidUpdate(prevProps) {
    const { fields } = this.props;
    if (prevProps.fields !== fields) {
      this.populateFormattedFieldPositons();
    }
  }
  render() {
    const { theme, editable, rowHeight, cols, layout, scale } = this.props;
    const { layoutContainer } = this.state;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      StyledDefaults,
      {
        theme,
        className: "joyfill_layout",
        ref: (e2) => {
          if (e2 && !layoutContainer) this.setState({ layoutContainer: e2 });
        },
        children: !layoutContainer ? null : (
          // @ts-ignore
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            GridLayout,
            {
              className: "layout",
              measureBeforeMount: false,
              allowOverlap: layout === float,
              compactType: "vertical",
              margin: [0, 0],
              isDraggable: editable,
              isResizable: editable,
              layout: this.getLayout(),
              cols,
              width: layoutContainer.offsetWidth,
              rowHeight,
              useCSSTransforms: true,
              transformScale: scale,
              onDragStart: (_a, _b, _c, _d, e2) => e2.stopPropagation(),
              draggableHandle: `.react-resizable-drag-handle`,
              resizeHandle: /* @__PURE__ */ jsxRuntimeExports.jsx(LayoutItemResizeHandle, { ...{ theme } }),
              onLayoutChange: this.handleLayoutChange,
              onResizeStop: this.handleManualLayoutChange,
              onDragStop: this.handleManualLayoutChange,
              children: this.getFieldNodes()
            }
          )
        )
      }
    );
  }
}
const getFormattedLayoutObject = (reactGridLayout2) => {
  return {
    _id: reactGridLayout2.i,
    width: reactGridLayout2.w,
    height: reactGridLayout2.h,
    x: reactGridLayout2.x,
    y: reactGridLayout2.y
  };
};
const hasLayoutChanged = (currentLayouts, nextLayouts) => {
  const currentLayoutLookup = {};
  currentLayouts.forEach((layout) => currentLayoutLookup[layout.i] = layout);
  const changedLayout = nextLayouts.find((nextLayout) => {
    const currentLayout = currentLayoutLookup[nextLayout.i];
    if (!currentLayout) return true;
    if (currentLayout.x !== nextLayout.x) return true;
    if (currentLayout.y !== nextLayout.y) return true;
    if (currentLayout.w !== nextLayout.w) return true;
    if (currentLayout.h !== nextLayout.h) return true;
    return false;
  });
  return !!changedLayout;
};
const Scaler = ({
  testid = "id",
  scale = 1,
  transformOrigin = "center",
  children
}) => {
  const transformOriginTarget = transformOrigin || (scale > 1 ? "left top" : "center");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      "data-testid": `scaler-${testid}`,
      style: {
        transform: `scale(${scale})`,
        transformOrigin: transformOriginTarget
      },
      children
    }
  );
};
const StyledHeaderFooterWrapper = dt.div`
  width: 100%;
`;
const StyledHeaderFooter = dt.div.withConfig({
  shouldForwardProp: (prop) => prop !== "height" && prop !== "padding" && prop !== "backgroundColor" && prop !== "borderColor" && prop !== "borderWidth" && prop !== "borderRadius" && prop !== "boxShadow" && prop !== "backgroundImage" && prop !== "backgroundSize"
})`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  height: ${(props) => props.height}px;
  padding: ${(props) => props.padding}px;
  background-color: ${(props) => props.backgroundColor || "transparent"};
  border: ${(props) => props.borderWidth}px solid ${(props) => props.borderColor};
  border-radius: ${(props) => props.borderRadius}px;
  box-shadow: ${(props) => props.boxShadow};
  background-repeat: no-repeat;
  background-size: ${(props) => props.backgroundSize}; 
  background-image: url("${(props) => props.backgroundImage}");
`;
const PageHeaderFooter = (props) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeaderFooterWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeaderFooter, { ...props, children: props.children }) });
};
function bottom(layout) {
  let max = 0;
  let bottomY;
  for (let i = 0, len = layout.length; i < len; i++) {
    bottomY = layout[i].y + layout[i].h;
    if (bottomY > max) max = bottomY;
  }
  return max;
}
function cloneLayoutItem(layoutItem) {
  return {
    w: layoutItem.w,
    h: layoutItem.h,
    x: layoutItem.x,
    y: layoutItem.y,
    i: layoutItem.i,
    minW: layoutItem.minW,
    maxW: layoutItem.maxW,
    minH: layoutItem.minH,
    maxH: layoutItem.maxH,
    moved: Boolean(layoutItem.moved),
    static: Boolean(layoutItem.static),
    // These can be null/undefined
    isDraggable: layoutItem.isDraggable,
    isResizable: layoutItem.isResizable,
    resizeHandles: layoutItem.resizeHandles,
    isBounded: layoutItem.isBounded
  };
}
function collides(l1, l2) {
  if (l1.i === l2.i) return false;
  if (l1.x + l1.w <= l2.x) return false;
  if (l1.x >= l2.x + l2.w) return false;
  if (l1.y + l1.h <= l2.y) return false;
  if (l1.y >= l2.y + l2.h) return false;
  return true;
}
function compact(layout, compactType2, cols, allowOverlap) {
  const startTime = performance.now();
  const compareWith = getStatics(layout);
  const sorted = sortLayoutItems(layout, compactType2);
  const out = Array(layout.length);
  const indexMap = {};
  for (let i = 0, len = layout.length; i < len; i++) {
    indexMap[layout[i].i] = i;
  }
  for (let i = 0, len = sorted.length; i < len; i++) {
    let l = cloneLayoutItem(sorted[i]);
    if (!l.static) {
      l = compactItem(compareWith, l, compactType2, cols, sorted, allowOverlap);
      compareWith.push(l);
    }
    const idx = indexMap[sorted[i].i];
    out[idx !== void 0 ? idx : i] = l;
    l.moved = false;
  }
  const elapsed = performance.now() - startTime;
  if (elapsed > 10) {
    console.log(`compact(): ${layout.length} items took ${elapsed.toFixed(2)}ms`);
  }
  return out;
}
const heightWidth = { x: "w", y: "h" };
function resolveCompactionCollision(layout, item, moveToCoord, axis) {
  const sizeProp = heightWidth[axis];
  item[axis] += 1;
  const itemIndex = layout.map((layoutItem) => {
    return layoutItem.i;
  }).indexOf(item.i);
  for (let i = itemIndex + 1; i < layout.length; i++) {
    const otherItem = layout[i];
    if (otherItem.static) continue;
    if (otherItem.y > item.y + item.h) break;
    if (collides(item, otherItem)) {
      resolveCompactionCollision(
        layout,
        otherItem,
        moveToCoord + item[sizeProp],
        axis
      );
    }
  }
  item[axis] = moveToCoord;
}
function compactItem(compareWith, l, compactType2, cols, fullLayout, allowOverlap) {
  const compactV = compactType2 === "vertical";
  const compactH = compactType2 === "horizontal";
  if (compactV) {
    l.y = Math.min(bottom(compareWith), l.y);
    while (l.y > 0 && !getFirstCollision(compareWith, l)) {
      l.y--;
    }
  } else if (compactH) {
    while (l.x > 0 && !getFirstCollision(compareWith, l)) {
      l.x--;
    }
  }
  let collides2;
  while ((collides2 = getFirstCollision(compareWith, l)) && !(compactType2 === null && allowOverlap)) {
    if (compactH) {
      resolveCompactionCollision(fullLayout, l, collides2.x + collides2.w, "x");
    } else {
      resolveCompactionCollision(fullLayout, l, collides2.y + collides2.h, "y");
    }
    if (compactH && l.x + l.w > cols) {
      l.x = cols - l.w;
      l.y++;
      while (l.x > 0 && !getFirstCollision(compareWith, l)) {
        l.x--;
      }
    }
  }
  l.y = Math.max(l.y, 0);
  l.x = Math.max(l.x, 0);
  return l;
}
function getFirstCollision(layout, layoutItem) {
  for (let i = 0, len = layout.length; i < len; i++) {
    if (collides(layout[i], layoutItem)) return layout[i];
  }
}
function getStatics(layout) {
  return layout.filter((l) => l.static);
}
function sortLayoutItems(layout, compactType2) {
  if (compactType2 === "horizontal") return sortLayoutItemsByColRow(layout);
  if (compactType2 === "vertical") return sortLayoutItemsByRowCol(layout);
  else return layout;
}
function sortLayoutItemsByRowCol(layout) {
  return layout.slice(0).sort(function(a, b) {
    if (a.y > b.y || a.y === b.y && a.x > b.x) {
      return 1;
    } else if (a.y === b.y && a.x === b.x) {
      return 0;
    }
    return -1;
  });
}
function sortLayoutItemsByColRow(layout) {
  return layout.slice(0).sort(function(a, b) {
    if (a.x > b.x || a.x === b.x && a.y > b.y) {
      return 1;
    }
    return -1;
  });
}
const staticMode = "static";
const dynamicVerticalMode = "dynamic-vertical";
const all = [staticMode, dynamicVerticalMode];
const FieldLayoutTypes = {
  static: staticMode,
  dynamicVertical: dynamicVerticalMode,
  all
};
function splitDynamicVerticalField(field, containerHeight) {
  const baseLayouts = field.layouts || [];
  if (baseLayouts.length === 0) {
    return [field];
  }
  if (baseLayouts.every(
    (layout) => layout.type === "header" || layout.type === "title" || layout.type === "fieldTitle"
  )) {
    return [field];
  }
  const result = [];
  let groupIndex = 1;
  const headerMap = {};
  baseLayouts.forEach((layout) => {
    if (layout.type === "header" && layout.key) {
      headerMap[layout.key] = layout;
    }
  });
  const createGroup = (layouts, isFirstGroup2) => {
    if (layouts.length === 0) return null;
    const groupHeight = layouts.reduce((sum, layout) => sum + layout.height, 0);
    const groupField = {
      ...field,
      _id: `${field._id}.${groupIndex}`,
      y: isFirstGroup2 ? field.y : field.y + (groupIndex - 1),
      height: groupHeight,
      layouts: [...layouts]
    };
    result.push(groupField);
    groupIndex++;
    return groupField;
  };
  let currentGroup = [];
  let currentHeight = 0;
  let isFirstGroup = true;
  let firstGroupAvailableHeight = containerHeight - field.y;
  if (baseLayouts.length > 0 && baseLayouts[0].height > firstGroupAvailableHeight) {
    firstGroupAvailableHeight = containerHeight;
  }
  for (let i = 0; i < baseLayouts.length; i++) {
    const layout = baseLayouts[i];
    if (layout.height > containerHeight) {
      if (currentGroup.length > 0) {
        createGroup(currentGroup, isFirstGroup);
        currentGroup = [];
        currentHeight = 0;
        isFirstGroup = false;
      }
      const groupLayouts = [];
      if (layout.header && headerMap[layout.header]) {
        groupLayouts.push({ ...headerMap[layout.header] });
      }
      groupLayouts.push(layout);
      createGroup(groupLayouts, isFirstGroup);
      isFirstGroup = false;
      continue;
    }
    const availableHeight = isFirstGroup ? firstGroupAvailableHeight : containerHeight;
    if (currentHeight + layout.height <= availableHeight) {
      currentGroup.push(layout);
      currentHeight += layout.height;
      continue;
    }
    if (currentGroup.length > 0) {
      createGroup(currentGroup, isFirstGroup);
      currentGroup = [];
      currentHeight = 0;
      isFirstGroup = false;
    }
    if (layout.header && headerMap[layout.header]) {
      currentGroup.push({ ...headerMap[layout.header] });
      currentHeight += headerMap[layout.header].height;
    }
    currentGroup.push(layout);
    currentHeight += layout.height;
  }
  if (currentGroup.length > 0) {
    createGroup(currentGroup, isFirstGroup);
  }
  return result;
}
const formatPageForPDFGeneration = (pdfDimensions, page, header, footer) => {
  console.time("formatPageForPDFGeneration:total");
  const { cols, fields } = page;
  console.log("formatPageForPDFGeneration: Processing page with", fields == null ? void 0 : fields.length, "fields");
  const nextPage = { ...page };
  let nextFieldPositions = [];
  const layouts = getLayout(fields);
  console.log("formatPageForPDFGeneration: Calling compact() with", layouts.length, "layouts");
  console.time("formatPageForPDFGeneration:compact");
  const formattedLayouts = compact(layouts, "vertical", cols, false);
  console.timeEnd("formatPageForPDFGeneration:compact");
  const formattedLayoutsLookup = {};
  formattedLayouts.forEach((layout) => formattedLayoutsLookup[layout.i] = layout);
  const formattedFieldPositions = fields.map((fieldPosition) => {
    const layout = formattedLayoutsLookup[fieldPosition._id];
    return {
      ...fieldPosition,
      x: layout.x,
      y: layout.y * (page.rowHeight || 1),
      width: layout.w,
      height: layout.h * (page.rowHeight || 1)
    };
  });
  formattedFieldPositions.forEach((fieldPosition) => {
    if (fieldPosition.layoutType !== FieldLayoutTypes.dynamicVertical || !fieldPosition.layouts || fieldPosition.layouts.length < 1) nextFieldPositions.push(fieldPosition);
    else nextFieldPositions = nextFieldPositions.concat(splitDynamicVerticalField(fieldPosition, getPageFieldPositionContainerHeight(pdfDimensions, page, header, footer)));
  });
  console.log("formatPageForPDFGeneration: Calling splitFieldPositionsIntoPages with", nextFieldPositions.length, "field positions");
  console.time("formatPageForPDFGeneration:splitPages");
  const pages = splitFieldPositionsIntoPages(pdfDimensions, page, nextFieldPositions, header, footer);
  console.timeEnd("formatPageForPDFGeneration:splitPages");
  console.log("formatPageForPDFGeneration: Split into", pages.length, "pages");
  console.timeEnd("formatPageForPDFGeneration:total");
  return pages.map((formattedPage) => ({ ...nextPage, ...formattedPage }));
};
const getPageFieldPositionContainerHeight = (pdfDimensions, page, header, footer) => {
  const { height: height2, padding } = pdfDimensions;
  return height2 - (((header == null ? void 0 : header.height) || 0) + ((footer == null ? void 0 : footer.height) || 0) + (padding || 0) * 2 + (page.padding || 0) * 2);
};
const getPageHeight = (pdfDimensions, header, footer) => {
  const { height: height2, padding } = pdfDimensions;
  return height2 - (padding || 0) * 2 - ((header == null ? void 0 : header.height) || 0) - ((footer == null ? void 0 : footer.height) || 0);
};
const splitFieldPositionsIntoPages = (pdfDimensions, page, fieldPositions, header, footer) => {
  const { cols } = page;
  const { height: height2 } = pdfDimensions;
  const adjustedFieldPositionContainerHeight = getPageFieldPositionContainerHeight(pdfDimensions, page, header, footer);
  const pageHeight = getPageHeight(pdfDimensions, header, footer);
  const pageLayouts = [];
  const generatePageLayout = (pageIndex, layouts) => {
    pageLayouts.push({ height: pageHeight, numberOfPages: 1, layouts: [] });
    const formattedLayouts = compact(layouts, "vertical", cols, false);
    const nextLayouts = [...formattedLayouts];
    formattedLayouts.forEach((layout) => {
      const fieldPositionHeight = layout.h;
      const fieldPositionTop = layout.y;
      const fieldPositionBottom = fieldPositionTop + fieldPositionHeight;
      if (fieldPositionTop < adjustedFieldPositionContainerHeight && fieldPositionHeight > adjustedFieldPositionContainerHeight) {
        pageLayouts[pageIndex].layouts.push(layout);
        const numberOfPages = Math.ceil((fieldPositionTop + fieldPositionHeight + ((header == null ? void 0 : header.height) || 0) + ((footer == null ? void 0 : footer.height) || 0)) / height2);
        pageLayouts[pageIndex].numberOfPages = numberOfPages;
        pageLayouts[pageIndex].height = getPageHeight(pdfDimensions, header, footer) * numberOfPages;
        const nextLayoutsIndex = nextLayouts.findIndex((nl) => nl.i === layout.i);
        nextLayouts.splice(nextLayoutsIndex, 1);
      } else if (fieldPositionBottom <= adjustedFieldPositionContainerHeight) {
        pageLayouts[pageIndex].layouts.push(layout);
        const nextLayoutsIndex = nextLayouts.findIndex((nl) => nl.i === layout.i);
        nextLayouts.splice(nextLayoutsIndex, 1);
      }
    });
    if (nextLayouts.length > 0) generatePageLayout(pageIndex + 1, nextLayouts);
    else return;
  };
  generatePageLayout(0, getLayout(fieldPositions));
  const fieldPositionLookup = {};
  fieldPositions.forEach((fieldPosition) => fieldPositionLookup[fieldPosition._id] = fieldPosition);
  return pageLayouts.map((pageLayout) => {
    return {
      ...pageLayout,
      height: pageLayout.height,
      fields: pageLayout.layouts.map((layout) => {
        const fieldPosition = fieldPositionLookup[layout.i];
        return {
          ...fieldPosition,
          width: layout.w,
          height: layout.h,
          x: layout.x,
          y: layout.y
        };
      })
    };
  });
};
const getLayout = (fieldPositions) => {
  return fieldPositions.map((fieldPosition) => {
    return {
      i: fieldPosition._id,
      x: fieldPosition.x,
      y: fieldPosition.y,
      w: fieldPosition.width,
      h: fieldPosition.height
    };
  });
};
const PDFRenderer = ({
  //PDF Export Configuration
  config,
  //Data for the PDF
  pages,
  header,
  footer,
  fieldRenderer
}) => {
  let formattedPages = [];
  pages.forEach((page) => {
    if (page.layout === LayoutTypes.grid) {
      const pages2 = formatPageForPDFGeneration(config.page, page, header, footer);
      formattedPages = formattedPages.concat(pages2);
    } else {
      formattedPages.push({ ...page });
    }
  });
  const pageNodes = formattedPages.map((page, index2) => {
    const {
      fields,
      transform,
      layout,
      cols,
      rowHeight,
      height: height2,
      //Calculated height from the PDF Page Parsing logic
      width: width2,
      numberOfPages
    } = page;
    const targetPDFPageContainerHeight = layout === LayoutTypes.float ? config.page.height : numberOfPages * config.page.height;
    const targetTransformType = transform || (layout === LayoutTypes.float ? "scale" : "page-break");
    let scale = 1;
    if (targetTransformType === "scale") {
      const targetPageHeight = height2 + ((header == null ? void 0 : header.height) || 0) + ((footer == null ? void 0 : footer.height) || 0);
      const scaleAdjustment = getPageScale(config == null ? void 0 : config.page, width2, targetPageHeight);
      scale = scale + scaleAdjustment;
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        id: `pdf-page-${index2}-container`,
        style: {
          ...config.page,
          boxSizing: "border-box",
          overflow: "hidden",
          height: targetPDFPageContainerHeight
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Scaler,
          {
            scale,
            transformOrigin: "left top",
            children: [
              !header ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeaderFooter, { ...header, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                Layout,
                {
                  ...header,
                  ...{
                    id: `${page._id}-header`,
                    itemRenderer: fieldRenderer,
                    editable: false,
                    scale,
                    theme: {
                      primaryColor: "transparent",
                      highlightColor: "transparent",
                      iconColor: "transparent"
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Page,
                {
                  ...{
                    id: "page",
                    ...page,
                    overflow: "hidden",
                    maxHeight: height2,
                    //Must use calculated .height from page. This calculated height is given by the PDF Page Parsing logic
                    minHeight: height2,
                    //Must use calculated .height from page. This calculated height is given by the PDF Page Parsing logic
                    maxHeightType: "px",
                    //Must use calcualted px because that is what the PDF Page calculated height is based on
                    minHeightType: "px",
                    //Must use calcualted px because that is what the PDF Page calculated height is based on
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    borderColor: "transparent"
                  },
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Layout,
                    {
                      ...{
                        id: page._id,
                        fields,
                        editable: false,
                        layout,
                        //Important Note: Row height should be forced to 1 for PDF Export Layout Component when page layout is grid. The PDF Page Parser/Formatter 
                        //(formatPageForPDFGeneration) will adjust field y and height properties to the proper value with targeting a rowHeight of 1. Since the
                        //formatPageForPDFGeneration is only targeted at grid layout pages we only use it for grid pages.
                        rowHeight: page.layout === LayoutTypes.grid ? 1 : rowHeight,
                        cols,
                        scale,
                        theme: {
                          primaryColor: "transparent",
                          highlightColor: "transparent",
                          iconColor: "transparent"
                        },
                        itemRenderer: fieldRenderer
                      }
                    }
                  )
                },
                index2
              ),
              !footer ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeaderFooter, { ...footer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                Layout,
                {
                  ...footer,
                  ...{
                    id: `${page._id}-footer`,
                    itemRenderer: fieldRenderer,
                    editable: false,
                    scale,
                    theme: {
                      primaryColor: "transparent",
                      highlightColor: "transparent",
                      iconColor: "transparent"
                    }
                  }
                }
              ) })
            ]
          }
        )
      }
    );
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: pageNodes });
};
const getPageScale = (pdfPageConfig, pageWidth, pageHeight) => {
  const adjustedContainerWidth = getAdjustedDimension(pdfPageConfig.width, pdfPageConfig.padding);
  const adjustedContainerHeight = getAdjustedDimension(pdfPageConfig.height, pdfPageConfig.padding);
  const percentageDifference = calculatePagePercentageAdjustments(pageHeight, pageWidth, adjustedContainerHeight, adjustedContainerWidth);
  return percentageDifference;
};
const getAdjustedDimension = (value, padding = 0) => {
  let pageValue = value;
  if (padding) pageValue -= padding * 2;
  return pageValue;
};
const calculatePagePercentageAdjustments = (pageHeight, pageWidth, maxHeight, maxWidth) => {
  const widthAdjustmentPercent = (maxWidth - pageWidth) / pageWidth;
  const heightAdjustmentPercent = (maxHeight - pageHeight) / pageHeight;
  let adjustementPercentage = 0;
  if (widthAdjustmentPercent !== 0 || heightAdjustmentPercent !== 0) {
    adjustementPercentage = Math.min(widthAdjustmentPercent, heightAdjustmentPercent);
  }
  return adjustementPercentage;
};
export {
  PDFRenderer
};
//# sourceMappingURL=index.es.js.map
